import { C as e, I as t, N as n, S as r, T as i, a, b as o, d as s, f as c, g as l, h as u, j as d, l as f, m as p, o as m, v as h, w as g, x as _ } from "./config-DT7lPKdp.js";
import { A as v, C as y, D as b, E as x, O as S, S as C, T as ee, _ as te, a as ne, b as re, c as ie, d as ae, f as w, g as T, h as E, i as oe, k as D, l as se, m as ce, n as le, o as ue, p as de, r as O, s as fe, t as pe, u as me, v as he, w as ge, x as _e, y as ve } from "./urlParams-D0HNN7eY.js";
import { a as k, c as ye, i as be, l as xe, n as Se, o as Ce, r as we, s as Te, t as Ee, u as De } from "./theme-C5OUkEkk.js";
import { Accordion as Oe, ActionIcon as A, Alert as ke, Anchor as Ae, AspectRatio as je, Avatar as Me, Badge as j, Box as M, Breadcrumbs as Ne, Button as N, Card as P, Center as Pe, Checkbox as Fe, CloseButton as Ie, Code as Le, Collapse as Re, Combobox as F, Container as ze, Divider as Be, Drawer as Ve, Flex as He, Group as I, HoverCard as Ue, Image as We, Indicator as Ge, Loader as Ke, Menu as L, Modal as qe, NavLink as Je, NumberInput as Ye, Pagination as Xe, Paper as Ze, Pill as Qe, Popover as $e, RangeSlider as et, ScrollArea as tt, SegmentedControl as nt, Select as rt, SimpleGrid as it, Skeleton as R, Stack as z, Switch as at, Table as ot, Text as B, TextInput as st, ThemeIcon as ct, Timeline as lt, Title as ut, Tooltip as dt, UnstyledButton as ft, VisuallyHidden as pt, useCombobox as mt, useComputedColorScheme as ht, useMantineColorScheme as gt } from "@mantine/core";
import { IconAdjustmentsHorizontal as _t, IconAlertCircle as vt, IconAlertTriangle as yt, IconArchive as bt, IconArrowRight as xt, IconAt as St, IconBan as Ct, IconBriefcase as wt, IconBuildingStore as Tt, IconCalendar as Et, IconCheck as Dt, IconChecks as Ot, IconChefHat as kt, IconChevronDown as At, IconChevronLeft as jt, IconChevronRight as Mt, IconChevronUp as Nt, IconCircle as Pt, IconCircleCheck as Ft, IconCircleDot as It, IconClock as Lt, IconClockOff as Rt, IconCloudCheck as zt, IconCloudOff as Bt, IconCloudUpload as Vt, IconCoin as Ht, IconCoinOff as Ut, IconCoins as Wt, IconCreditCard as Gt, IconCurrencyBitcoin as Kt, IconCurrencyDollar as qt, IconDownload as Jt, IconFile as Yt, IconFileSpreadsheet as Xt, IconFileText as Zt, IconFileTypePdf as Qt, IconFileTypeZip as $t, IconFingerprint as en, IconFolder as tn, IconHeart as nn, IconHeartFilled as rn, IconInbox as an, IconInfoCircle as on, IconKey as sn, IconLanguage as cn, IconLoader2 as ln, IconLock as un, IconLogout as dn, IconMapPin as fn, IconMessage as pn, IconMessage2 as mn, IconMinus as hn, IconMoodSmile as gn, IconMoon as _n, IconPackage as vn, IconPaperclip as yn, IconPhotoOff as bn, IconPlus as xn, IconReceiptRefund as Sn, IconRefresh as Cn, IconRepeat as wn, IconSearch as Tn, IconSelector as En, IconSend2 as Dn, IconSettings as On, IconShield as kn, IconShoppingBag as An, IconShoppingCart as jn, IconStar as Mn, IconSun as Nn, IconToolsKitchen2 as Pn, IconTrash as Fn, IconTrendingDown as In, IconTrendingUp as Ln, IconTruck as Rn, IconUser as zn, IconUsers as Bn, IconUsersGroup as Vn, IconWifi as Hn, IconX as V, IconZoomIn as Un, IconZoomOut as Wn } from "@tabler/icons-react";
import { Fragment as Gn, jsx as H, jsxs as U } from "react/jsx-runtime";
import { useTranslation as W } from "react-i18next";
import Kn, { Children as qn, Component as Jn, Fragment as Yn, Suspense as Xn, cloneElement as Zn, createContext as Qn, forwardRef as $n, isValidElement as er, lazy as tr, useCallback as G, useContext as nr, useEffect as K, useId as rr, useImperativeHandle as ir, useLayoutEffect as ar, useMemo as q, useReducer as or, useRef as J, useState as Y } from "react";
import { useDebouncedCallback as sr, useDebouncedValue as cr, useDisclosure as lr, useMediaQuery as ur, useReducedMotion as dr } from "@mantine/hooks";
import { AreaChart as fr, BarChart as pr, DonutChart as mr, LineChart as hr, PieChart as gr } from "@mantine/charts";
import { DatePicker as _r } from "@mantine/dates";
import X from "dayjs";
import "dayjs/locale/es";
import { Link as vr } from "react-router-dom";
import { UserAvatar as yr } from "@teletienda/shared-auth-ui";
import br from "react-markdown";
import xr from "remark-gfm";
import { NodeViewWrapper as Sr, ReactNodeViewRenderer as Cr, useEditor as wr } from "@tiptap/react";
import { notifications as Tr } from "@mantine/notifications";
import { Extension as Er } from "@tiptap/core";
import Dr from "@tiptap/starter-kit";
import Or from "@tiptap/extension-link";
import kr from "@tiptap/extension-placeholder";
import { Markdown as Ar } from "tiptap-markdown";
import { RichTextEditor as jr } from "@mantine/tiptap";
import Mr from "@tiptap/extension-mention";
import { PluginKey as Nr } from "@tiptap/pm/state";
import Pr from "@tiptap/suggestion";
import { useQuery as Fr } from "@tanstack/react-query";
import { EventType as Ir, RealtimeTopics as Lr, useRealtimeEventOptional as Rr, useWebSocketOptional as zr } from "@teletienda/ws-client/react";
//#region \0rolldown/runtime.js
var Br = Object.create, Vr = Object.defineProperty, Hr = Object.getOwnPropertyDescriptor, Ur = Object.getOwnPropertyNames, Wr = Object.getPrototypeOf, Gr = Object.prototype.hasOwnProperty, Kr = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), qr = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = Ur(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Gr.call(e, s) && s !== n && Vr(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Hr(t, s)) || r.enumerable
	});
	return e;
}, Jr = (e, t, n) => (n = e == null ? {} : Br(Wr(e)), qr(t || !e || !e.__esModule ? Vr(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), Yr = {
	order: {
		completed: Dt,
		pending: Lt,
		partially_paid: qt,
		overpaid: Wt,
		check: vt,
		expired: Lt,
		expired_partial: Lt,
		cancelled: V,
		failed: V
	},
	payment: {
		pending: Lt,
		detected: It,
		confirming: Cn,
		confirmed: Dt,
		completed: Dt,
		failed: V,
		refunded: Cn
	},
	withdrawal: {
		completed: Dt,
		processing: Cn,
		pending: Lt,
		failed: V,
		cancelled: V
	},
	transaction: {
		confirmed: Dt,
		pending: Lt,
		failed: V
	},
	address: {
		ready: It,
		assigned_to_order: Lt,
		payment_received: qt,
		check: vt,
		consolidating: Cn,
		archived: bt
	},
	merchant: {
		active: Dt,
		inactive: V,
		pending: Lt
	},
	merchantOrder: {
		pending: Lt,
		paid: qt,
		confirmed: Dt,
		preparing: vn,
		ready: vn,
		shipped: Rn,
		delivered: Dt,
		cancelled: V
	},
	sync: {
		synced: zt,
		pending: Cn,
		error: Bt
	},
	stock: {
		in_stock: Dt,
		low_stock: vt,
		out_of_stock: V
	},
	paymentStatus: {
		pending: Lt,
		partially_paid: Ut,
		paid: Ht,
		overpaid: yt,
		expired: Rt,
		expired_partial: Rt,
		failed: V,
		refunded: Sn
	},
	fulfillmentStatus: {
		awaiting_payment: Lt,
		confirmed: Dt,
		preparing: kt,
		ready: vn,
		shipped: Rn,
		delivered: Ft,
		cancelled: V
	}
};
function Xr({ type: e, status: t, showIcon: n = !1, label: r, ...i }) {
	let a = h(e, t), o = n ? Yr[e]?.[t] : void 0, s = l(e, t), c = r ?? s;
	return /* @__PURE__ */ H(j, {
		color: a.color,
		leftSection: o ? /* @__PURE__ */ H(o, {
			size: 12,
			stroke: 1.5
		}) : void 0,
		...i,
		children: c
	});
}
function Zr(e) {
	return /* @__PURE__ */ H(Xr, {
		type: "order",
		...e
	});
}
function Qr(e) {
	return /* @__PURE__ */ H(Xr, {
		type: "payment",
		...e
	});
}
function $r(e) {
	return /* @__PURE__ */ H(Xr, {
		type: "withdrawal",
		...e
	});
}
function ei(e) {
	return /* @__PURE__ */ H(Xr, {
		type: "transaction",
		...e
	});
}
function ti(e) {
	return /* @__PURE__ */ H(Xr, {
		type: "address",
		...e
	});
}
function ni(e) {
	return /* @__PURE__ */ H(Xr, {
		type: "merchant",
		...e
	});
}
function ri(e) {
	return /* @__PURE__ */ H(Xr, {
		type: "merchantOrder",
		...e
	});
}
function ii(e) {
	return /* @__PURE__ */ H(Xr, {
		type: "sync",
		...e
	});
}
function ai(e) {
	return /* @__PURE__ */ H(Xr, {
		type: "stock",
		...e
	});
}
function oi(e) {
	return /* @__PURE__ */ H(Xr, {
		type: "paymentStatus",
		...e
	});
}
function si(e) {
	return /* @__PURE__ */ H(Xr, {
		type: "fulfillmentStatus",
		...e
	});
}
//#endregion
//#region src/components/feedback/CategoryBadge/CategoryBadge.tsx
var ci = {
	merchant: {
		shop: An,
		restaurant: Pn,
		service: wt
	},
	resource: {
		users: Bn,
		roles: kn,
		permissions: un,
		merchants: Tt,
		orders: jn,
		products: vn,
		payments: Gt,
		settings: On,
		addresses: fn,
		api_keys: sn,
		blockchain: Kt,
		cart: jn
	},
	role: {
		system: kn,
		custom: zn
	},
	addressContext: {
		personal: zn,
		merchant: Tt,
		system: On
	},
	paymentMode: {
		reuse: wn,
		unique: en
	}
};
function li({ type: e, value: t, showIcon: n = !1, label: r, ...i }) {
	let a = f(e, t), o = n ? ci[e]?.[t] : void 0, s = p(e, t), c = r ?? s;
	return /* @__PURE__ */ H(j, {
		color: a.color,
		leftSection: o ? /* @__PURE__ */ H(o, {
			size: 12,
			stroke: 1.5
		}) : void 0,
		...i,
		children: c
	});
}
function ui(e) {
	return /* @__PURE__ */ H(li, {
		type: "merchant",
		...e
	});
}
function di(e) {
	return /* @__PURE__ */ H(li, {
		type: "resource",
		...e
	});
}
function fi(e) {
	return /* @__PURE__ */ H(li, {
		type: "role",
		...e
	});
}
function pi(e) {
	return /* @__PURE__ */ H(li, {
		type: "addressContext",
		...e
	});
}
function mi(e) {
	return /* @__PURE__ */ H(li, {
		type: "paymentMode",
		...e
	});
}
//#endregion
//#region src/components/feedback/LevelBadge/LevelBadge.tsx
function hi({ value: e, thresholds: t, suffix: n = "", prefix: r = "", showLabel: i = !1, formatValue: a, ...o }) {
	let l = s(e, t), d;
	if (i) {
		let n = c(e, t);
		d = n ? u(n) : String(e);
	} else d = a ? `${r}${a(e)}${n}` : `${r}${e}${n}`;
	return /* @__PURE__ */ H(j, {
		color: l,
		...o,
		children: d
	});
}
function gi(e) {
	return /* @__PURE__ */ H(hi, {
		thresholds: g,
		...e
	});
}
function _i(e) {
	return /* @__PURE__ */ H(hi, {
		thresholds: _,
		...e
	});
}
function vi(t) {
	return /* @__PURE__ */ H(hi, {
		thresholds: e,
		...t
	});
}
function yi(e) {
	return /* @__PURE__ */ H(hi, {
		thresholds: o,
		...e
	});
}
function bi(e) {
	return /* @__PURE__ */ H(hi, {
		thresholds: i,
		...e
	});
}
function xi(e) {
	return /* @__PURE__ */ H(hi, {
		thresholds: r,
		...e
	});
}
//#endregion
//#region src/components/feedback/CounterBadge/CounterBadge.tsx
function Si({ count: e, max: t, showZero: n = !0, formatCount: r, color: i = "blue", ...a }) {
	if (e === 0 && !n) return null;
	let o;
	return o = r ? r(e, t) : t !== void 0 && e > t ? `${t}+` : String(e), /* @__PURE__ */ H(j, {
		color: i,
		...a,
		children: o
	});
}
function Ci(e) {
	return /* @__PURE__ */ H(Si, {
		max: 99,
		size: "xs",
		...e
	});
}
function wi(e) {
	return /* @__PURE__ */ H(Si, {
		max: 999,
		...e
	});
}
function Ti(e) {
	return /* @__PURE__ */ H(Si, {
		color: "gray",
		...e
	});
}
//#endregion
//#region src/components/feedback/RoleBadge/RoleBadge.tsx
var Ei = {
	super_admin: "Super Admin",
	admin: "Admin",
	support: "Support",
	moderator: "Moderator",
	content_manager: "Content Manager",
	unconfirmed: "Unconfirmed",
	confirmed: "Confirmed",
	verified: "Verified"
};
function Di(e) {
	return Ei[e] ? Ei[e] : e.split("_").map((e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase()).join(" ");
}
function Oi({ role: e, isSystem: t = !1, showIcon: n = !1, label: r, color: i, ...a }) {
	let o = d[t ? "system" : "custom"], s = i ?? o.color, c = r ?? Di(e), l = n ? t ? kn : zn : void 0;
	return /* @__PURE__ */ H(j, {
		color: s,
		leftSection: l ? /* @__PURE__ */ H(l, {
			size: 12,
			stroke: 1.5
		}) : void 0,
		...a,
		children: c
	});
}
function ki(e) {
	return /* @__PURE__ */ H(Oi, {
		isSystem: !0,
		...e
	});
}
function Ai(e) {
	return /* @__PURE__ */ H(Oi, {
		isSystem: !1,
		...e
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/ProductGridSkeleton.tsx
function ji() {
	return /* @__PURE__ */ U(P, {
		shadow: "sm",
		padding: "lg",
		radius: "md",
		withBorder: !0,
		"data-testid": "product-skeleton",
		children: [
			/* @__PURE__ */ H(P.Section, { children: /* @__PURE__ */ H(R, { height: 160 }) }),
			/* @__PURE__ */ U(I, {
				justify: "space-between",
				mt: "md",
				mb: "xs",
				children: [/* @__PURE__ */ H(R, {
					height: 16,
					width: "70%"
				}), /* @__PURE__ */ H(R, {
					height: 20,
					width: 60
				})]
			}),
			/* @__PURE__ */ H(R, {
				height: 14,
				mt: 6
			}),
			/* @__PURE__ */ H(R, {
				height: 14,
				mt: 6,
				width: "80%"
			}),
			/* @__PURE__ */ U(I, {
				justify: "space-between",
				mt: "md",
				children: [/* @__PURE__ */ H(R, {
					height: 24,
					width: 80
				}), /* @__PURE__ */ H(R, {
					height: 36,
					width: 100
				})]
			})
		]
	});
}
function Mi({ count: e = 8 }) {
	return /* @__PURE__ */ H(it, {
		cols: {
			base: 1,
			xs: 2,
			sm: 3,
			md: 4
		},
		spacing: "md",
		"data-testid": "product-grid-skeleton",
		children: Array.from({ length: e }).map((e, t) => /* @__PURE__ */ H(ji, {}, t))
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/MerchantGridSkeleton.tsx
function Ni() {
	return /* @__PURE__ */ U(P, {
		shadow: "sm",
		padding: "lg",
		radius: "md",
		withBorder: !0,
		children: [
			/* @__PURE__ */ H(P.Section, { children: /* @__PURE__ */ H(R, { height: 120 }) }),
			/* @__PURE__ */ U(I, {
				justify: "space-between",
				mt: "md",
				mb: "xs",
				children: [/* @__PURE__ */ H(R, {
					height: 18,
					width: "70%"
				}), /* @__PURE__ */ H(R, {
					height: 20,
					width: 60
				})]
			}),
			/* @__PURE__ */ H(R, {
				height: 14,
				mt: 6
			}),
			/* @__PURE__ */ H(R, {
				height: 14,
				mt: 6,
				width: "80%"
			}),
			/* @__PURE__ */ U(I, {
				justify: "space-between",
				mt: "md",
				children: [/* @__PURE__ */ H(R, {
					height: 16,
					width: 100
				}), /* @__PURE__ */ H(R, {
					height: 36,
					width: 120
				})]
			})
		]
	});
}
function Pi({ count: e = 6 }) {
	return /* @__PURE__ */ H(it, {
		cols: {
			base: 1,
			sm: 2,
			md: 3
		},
		spacing: "md",
		"data-testid": "merchant-grid-skeleton",
		children: Array.from({ length: e }).map((e, t) => /* @__PURE__ */ H(Ni, {}, t))
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/ProductDetailSkeleton.tsx
function Fi() {
	return /* @__PURE__ */ U(I, {
		align: "flex-start",
		gap: "xl",
		wrap: "wrap",
		"data-testid": "product-detail-skeleton",
		children: [/* @__PURE__ */ U(M, {
			style: {
				flex: 1,
				minWidth: 300
			},
			children: [/* @__PURE__ */ H(R, {
				height: 400,
				radius: "md"
			}), /* @__PURE__ */ U(I, {
				gap: "sm",
				mt: "sm",
				children: [
					/* @__PURE__ */ H(R, {
						height: 60,
						width: 60,
						radius: "sm"
					}),
					/* @__PURE__ */ H(R, {
						height: 60,
						width: 60,
						radius: "sm"
					}),
					/* @__PURE__ */ H(R, {
						height: 60,
						width: 60,
						radius: "sm"
					}),
					/* @__PURE__ */ H(R, {
						height: 60,
						width: 60,
						radius: "sm"
					})
				]
			})]
		}), /* @__PURE__ */ U(z, {
			gap: "md",
			style: {
				flex: 1,
				minWidth: 300
			},
			children: [
				/* @__PURE__ */ H(R, {
					height: 32,
					width: "80%"
				}),
				/* @__PURE__ */ H(R, {
					height: 20,
					width: "40%"
				}),
				/* @__PURE__ */ H(R, {
					height: 28,
					width: 120
				}),
				/* @__PURE__ */ H(R, {
					height: 20,
					width: "30%"
				}),
				/* @__PURE__ */ H(R, { height: 100 }),
				/* @__PURE__ */ U(I, { children: [/* @__PURE__ */ H(R, {
					height: 44,
					width: 200,
					radius: "md"
				}), /* @__PURE__ */ H(R, {
					height: 44,
					width: 44,
					radius: "md"
				})] })
			]
		})]
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/ListSkeleton.tsx
function Ii() {
	return /* @__PURE__ */ U(I, {
		gap: "md",
		p: "md",
		"data-testid": "list-item-skeleton",
		children: [/* @__PURE__ */ H(R, {
			height: 60,
			width: 60,
			radius: "md"
		}), /* @__PURE__ */ U(z, {
			gap: "xs",
			style: { flex: 1 },
			children: [/* @__PURE__ */ H(R, {
				height: 14,
				width: "60%"
			}), /* @__PURE__ */ H(R, {
				height: 12,
				width: "40%"
			})]
		})]
	});
}
function Li({ count: e = 4 }) {
	return /* @__PURE__ */ H(z, {
		gap: 0,
		"data-testid": "list-skeleton",
		children: Array.from({ length: e }).map((e, t) => /* @__PURE__ */ H(Ii, {}, t))
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/CardSkeleton.tsx
function Ri() {
	return /* @__PURE__ */ U(P, {
		withBorder: !0,
		padding: "md",
		"data-testid": "card-skeleton",
		children: [/* @__PURE__ */ H(P.Section, { children: /* @__PURE__ */ H(R, { height: 200 }) }), /* @__PURE__ */ U(z, {
			gap: "xs",
			mt: "md",
			children: [
				/* @__PURE__ */ H(R, {
					height: 16,
					width: "70%"
				}),
				/* @__PURE__ */ H(R, {
					height: 12,
					width: "50%"
				}),
				/* @__PURE__ */ U(I, {
					justify: "space-between",
					mt: "xs",
					children: [/* @__PURE__ */ H(R, {
						height: 20,
						width: 80
					}), /* @__PURE__ */ H(R, {
						height: 32,
						width: 32,
						radius: "xl"
					})]
				})
			]
		})]
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/TextSkeleton.tsx
function zi({ lines: e = 3, width: t = [
	"100%",
	"80%",
	"60%"
] }) {
	return /* @__PURE__ */ H(z, {
		gap: "xs",
		"data-testid": "text-skeleton",
		children: Array.from({ length: e }).map((e, n) => /* @__PURE__ */ H(R, {
			height: 14,
			width: Array.isArray(t) ? t[n % t.length] : t
		}, n))
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/StatsSkeleton.tsx
function Bi({ count: e = 4 }) {
	return /* @__PURE__ */ H(I, {
		justify: "space-around",
		"data-testid": "stats-skeleton",
		children: Array.from({ length: e }).map((e, t) => /* @__PURE__ */ U("div", {
			style: { textAlign: "center" },
			children: [/* @__PURE__ */ H(R, {
				height: 32,
				width: 80,
				mb: "xs"
			}), /* @__PURE__ */ H(R, {
				height: 16,
				width: 100
			})]
		}, t))
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/TableSkeleton.tsx
function Vi({ rows: e = 5, columns: t = 4 }) {
	return /* @__PURE__ */ U(ot, {
		"data-testid": "table-skeleton",
		children: [/* @__PURE__ */ H(ot.Thead, { children: /* @__PURE__ */ H(ot.Tr, { children: Array.from({ length: t }).map((e, t) => /* @__PURE__ */ H(ot.Th, { children: /* @__PURE__ */ H(R, {
			height: 16,
			width: "70%"
		}) }, t)) }) }), /* @__PURE__ */ H(ot.Tbody, { children: Array.from({ length: e }).map((e, n) => /* @__PURE__ */ H(ot.Tr, { children: Array.from({ length: t }).map((e, t) => /* @__PURE__ */ H(ot.Td, { children: /* @__PURE__ */ H(R, {
			height: 14,
			width: t === 0 ? "80%" : "60%"
		}) }, t)) }, n)) })]
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/KPISkeleton.tsx
function Hi() {
	return /* @__PURE__ */ H(P, {
		withBorder: !0,
		padding: "lg",
		radius: "md",
		children: /* @__PURE__ */ U(z, {
			gap: "xs",
			children: [
				/* @__PURE__ */ U(I, {
					justify: "space-between",
					children: [/* @__PURE__ */ H(R, {
						height: 14,
						width: 100
					}), /* @__PURE__ */ H(R, {
						height: 24,
						width: 24,
						radius: "sm"
					})]
				}),
				/* @__PURE__ */ H(R, {
					height: 32,
					width: "60%"
				}),
				/* @__PURE__ */ H(R, {
					height: 12,
					width: "40%"
				})
			]
		})
	});
}
function Ui({ count: e = 4 }) {
	return /* @__PURE__ */ H(it, {
		cols: {
			base: 1,
			xs: 2,
			md: 4
		},
		spacing: "md",
		"data-testid": "kpi-skeleton",
		children: Array.from({ length: e }).map((e, t) => /* @__PURE__ */ H(Hi, {}, t))
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/layouts/ChartSkeleton.tsx
function Wi({ height: e = 300 }) {
	return /* @__PURE__ */ U(z, {
		gap: "md",
		"data-testid": "chart-skeleton",
		children: [
			/* @__PURE__ */ U(I, {
				justify: "space-between",
				children: [/* @__PURE__ */ H(R, {
					height: 20,
					width: 150
				}), /* @__PURE__ */ U(I, {
					gap: "sm",
					children: [
						/* @__PURE__ */ H(R, {
							height: 16,
							width: 60,
							radius: "xl"
						}),
						/* @__PURE__ */ H(R, {
							height: 16,
							width: 60,
							radius: "xl"
						}),
						/* @__PURE__ */ H(R, {
							height: 16,
							width: 60,
							radius: "xl"
						})
					]
				})]
			}),
			/* @__PURE__ */ H(M, {
				pos: "relative",
				h: e,
				children: /* @__PURE__ */ H(R, {
					height: e,
					radius: "md"
				})
			}),
			/* @__PURE__ */ H(I, {
				justify: "space-between",
				px: "md",
				children: Array.from({ length: 6 }).map((e, t) => /* @__PURE__ */ H(R, {
					height: 12,
					width: 40
				}, t))
			})
		]
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/LoadingSkeleton.tsx
function Gi({ layout: e, count: t, rows: n, columns: r, lines: i, width: a, height: o }) {
	switch (e) {
		case "product-grid": return /* @__PURE__ */ H(Mi, { count: t });
		case "merchant-grid": return /* @__PURE__ */ H(Pi, { count: t });
		case "product-detail": return /* @__PURE__ */ H(Fi, {});
		case "list": return /* @__PURE__ */ H(Li, { count: t });
		case "card": return /* @__PURE__ */ H(Ri, {});
		case "text": return /* @__PURE__ */ H(zi, {
			lines: i,
			width: a
		});
		case "stats": return /* @__PURE__ */ H(Bi, { count: t });
		case "table": return /* @__PURE__ */ H(Vi, {
			rows: n,
			columns: r
		});
		case "kpi": return /* @__PURE__ */ H(Ui, { count: t });
		case "chart": return /* @__PURE__ */ H(Wi, { height: o });
		default: return null;
	}
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/PageLoader.tsx
function Ki({ message: e, height: t = 300 }) {
	let { t: n } = W("common"), r = e ?? n("loading_states.loading", "Loading...");
	return /* @__PURE__ */ H(Pe, {
		h: t,
		"data-testid": "page-loader",
		children: /* @__PURE__ */ U(z, {
			align: "center",
			gap: "md",
			children: [/* @__PURE__ */ H(Ke, { size: "lg" }), /* @__PURE__ */ H(B, {
				size: "lg",
				c: "dimmed",
				children: r
			})]
		})
	});
}
//#endregion
//#region src/components/feedback/LoadingSkeleton/FullScreenLoader.tsx
function qi({ message: e }) {
	let { t } = W("common"), n = ht("light"), r = e ?? t("loading_states.loading", "Loading...");
	return /* @__PURE__ */ H("div", {
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundColor: n === "dark" ? "rgba(0, 0, 0, 0.9)" : "rgba(255, 255, 255, 0.9)",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			zIndex: 1e3
		},
		"data-testid": "full-screen-loader",
		children: /* @__PURE__ */ U(z, {
			align: "center",
			gap: "md",
			children: [/* @__PURE__ */ H(Ke, { size: "xl" }), /* @__PURE__ */ H(B, {
				size: "lg",
				c: "dimmed",
				children: r
			})]
		})
	});
}
//#endregion
//#region src/components/feedback/EmptyState/EmptyState.tsx
var Ji = {
	sm: 120,
	md: 180,
	lg: 240
}, Yi = {
	sm: 60,
	md: 80,
	lg: 100
}, Xi = {
	sm: 30,
	md: 40,
	lg: 50
}, Zi = {
	sm: 4,
	md: 3,
	lg: 2
};
function Qi({ title: e, description: t, icon: n, image: r, action: i, secondaryAction: a, size: o = "md", ...s }) {
	let c = Ji[o], l = Yi[o], u = Xi[o], d = Zi[o], f = o === "sm" ? "sm" : "md", p = o === "sm" ? "xs" : "sm";
	return /* @__PURE__ */ H(Pe, {
		py: o === "lg" ? "xl" : "lg",
		"data-testid": "empty-state",
		...s,
		children: /* @__PURE__ */ U(z, {
			align: "center",
			gap: "md",
			maw: 400,
			children: [
				r ? /* @__PURE__ */ H(We, {
					src: r,
					alt: "",
					w: c,
					h: c,
					fit: "contain",
					"data-testid": "empty-state-image",
					"aria-hidden": "true"
				}) : /* @__PURE__ */ H(ct, {
					size: l,
					radius: "xl",
					variant: "light",
					color: "gray",
					"data-testid": "empty-state-icon",
					children: n || /* @__PURE__ */ H(an, { size: u })
				}),
				/* @__PURE__ */ H(ut, {
					order: d,
					ta: "center",
					"data-testid": "empty-state-title",
					children: e
				}),
				t && /* @__PURE__ */ H(B, {
					c: "dimmed",
					ta: "center",
					size: o === "sm" ? "sm" : "md",
					"data-testid": "empty-state-description",
					children: t
				}),
				(i || a) && /* @__PURE__ */ U(z, {
					gap: "xs",
					mt: "xs",
					align: "center",
					children: [i && /* @__PURE__ */ H(N, {
						variant: i.variant || "light",
						onClick: i.onClick,
						size: f,
						"data-testid": "empty-state-action",
						children: i.label
					}), a && /* @__PURE__ */ H(N, {
						variant: "subtle",
						onClick: a.onClick,
						size: p,
						"data-testid": "empty-state-secondary-action",
						children: a.label
					})]
				})
			]
		})
	});
}
//#endregion
//#region src/components/feedback/ErrorState/ErrorState.tsx
function $i(e, t) {
	return !!(e === "NETWORK_ERROR" || t?.toLowerCase().includes("fetch") || t?.toLowerCase().includes("network"));
}
function ea({ message: e, title: t, code: n, onRetry: r, retryLabel: i = "Reintentar", isRetrying: a = !1, action: o, details: s, showDetails: c = !1, variant: l = "alert", color: u = "red" }) {
	let [d, f] = Y(!1), p = $i(n, e), m = p ? Hn : vt, h = t ?? (p ? "Error de conexión" : "Error"), g = c && s ? /* @__PURE__ */ H(N, {
		variant: "subtle",
		size: "xs",
		color: "gray",
		onClick: () => f(!d),
		rightSection: H(d ? Nt : At, { size: 14 }),
		"data-testid": "error-state-details-toggle",
		children: d ? "Ocultar detalles" : "Ver detalles"
	}) : null, _ = c && s ? /* @__PURE__ */ H(Re, {
		expanded: d,
		children: /* @__PURE__ */ H(Le, {
			block: !0,
			mt: "sm",
			style: {
				maxHeight: 200,
				overflow: "auto"
			},
			"data-testid": "error-state-details",
			children: s
		})
	}) : null;
	return l === "alert" ? /* @__PURE__ */ H(ke, {
		icon: /* @__PURE__ */ H(m, { size: 16 }),
		color: u,
		title: h,
		"data-testid": "error-state",
		children: /* @__PURE__ */ U(z, {
			gap: "sm",
			children: [
				/* @__PURE__ */ H(B, {
					size: "sm",
					"data-testid": "error-state-message",
					children: e
				}),
				(r || o) && /* @__PURE__ */ U(z, {
					gap: "xs",
					children: [r && /* @__PURE__ */ H(N, {
						variant: "light",
						color: u,
						size: "xs",
						leftSection: /* @__PURE__ */ H(Cn, { size: 14 }),
						onClick: r,
						loading: a,
						"data-testid": "error-state-retry",
						children: i
					}), o && /* @__PURE__ */ H(N, {
						variant: "subtle",
						color: u,
						size: "xs",
						onClick: o.onClick,
						"data-testid": "error-state-action",
						children: o.label
					})]
				}),
				g,
				_
			]
		})
	}) : /* @__PURE__ */ H(Pe, {
		py: "xl",
		"data-testid": "error-state",
		children: /* @__PURE__ */ U(z, {
			align: "center",
			gap: "lg",
			maw: 400,
			children: [
				/* @__PURE__ */ H(m, {
					size: 64,
					color: `var(--mantine-color-${u}-6)`,
					"data-testid": "error-state-icon"
				}),
				/* @__PURE__ */ H(B, {
					size: "xl",
					fw: 600,
					ta: "center",
					"data-testid": "error-state-title",
					children: h
				}),
				/* @__PURE__ */ H(B, {
					c: "dimmed",
					ta: "center",
					"data-testid": "error-state-message",
					children: e
				}),
				(r || o) && /* @__PURE__ */ U(z, {
					gap: "xs",
					align: "center",
					children: [r && /* @__PURE__ */ H(N, {
						leftSection: /* @__PURE__ */ H(Cn, { size: 18 }),
						onClick: r,
						loading: a,
						"data-testid": "error-state-retry",
						children: i
					}), o && /* @__PURE__ */ H(N, {
						variant: "subtle",
						onClick: o.onClick,
						"data-testid": "error-state-action",
						children: o.label
					})]
				}),
				g,
				_
			]
		})
	});
}
//#endregion
//#region src/components/feedback/ErrorBoundary/ErrorBoundary.tsx
var ta = class extends Jn {
	state = {
		hasError: !1,
		error: null,
		errorInfo: null,
		showDetails: !1
	};
	static getDerivedStateFromError(e) {
		return {
			hasError: !0,
			error: e
		};
	}
	componentDidCatch(e, t) {
		this.setState({ errorInfo: t }), this.props.onError?.(e, t), console.error("ErrorBoundary caught an error:", e, t);
	}
	handleRetry = () => {
		this.setState({
			hasError: !1,
			error: null,
			errorInfo: null,
			showDetails: !1
		});
	};
	handleReload = () => {
		window.location.reload();
	};
	toggleDetails = () => {
		this.setState((e) => ({ showDetails: !e.showDetails }));
	};
	render() {
		let { children: e, fallback: t, title: n = "Algo salió mal", message: r = "Lo sentimos, ocurrió un error inesperado. Podés intentar recargar la página.", retryLabel: i = "Reintentar", reloadLabel: a = "Recargar página" } = this.props, { hasError: o, error: s, errorInfo: c, showDetails: l } = this.state;
		return o ? t || /* @__PURE__ */ H(ze, {
			size: "sm",
			py: "xl",
			"data-testid": "error-boundary-fallback",
			children: /* @__PURE__ */ H(Ze, {
				p: "xl",
				withBorder: !0,
				children: /* @__PURE__ */ U(z, {
					align: "center",
					gap: "lg",
					children: [
						/* @__PURE__ */ H(yt, {
							size: 64,
							color: "var(--mantine-color-red-6)",
							"data-testid": "error-boundary-icon"
						}),
						/* @__PURE__ */ H(B, {
							size: "xl",
							fw: 600,
							ta: "center",
							"data-testid": "error-boundary-title",
							children: n
						}),
						/* @__PURE__ */ H(B, {
							c: "dimmed",
							ta: "center",
							maw: 400,
							"data-testid": "error-boundary-message",
							children: r
						}),
						/* @__PURE__ */ U(I, { children: [/* @__PURE__ */ H(N, {
							leftSection: /* @__PURE__ */ H(Cn, { size: 18 }),
							onClick: this.handleRetry,
							"data-testid": "error-boundary-retry",
							children: i
						}), /* @__PURE__ */ H(N, {
							variant: "light",
							onClick: this.handleReload,
							"data-testid": "error-boundary-reload",
							children: a
						})] }),
						!1
					]
				})
			})
		}) : e;
	}
};
//#endregion
//#region src/components/feedback/FilterChips/FilterChips.tsx
function na({ filters: e, onClearAll: t, clearAllLabel: n = "Limpiar filtros", clearAllMinFilters: r = 2, size: i = "lg", variant: a = "outline" }) {
	if (e.length === 0) return null;
	let o = t && e.length >= r;
	return /* @__PURE__ */ U(I, {
		gap: "xs",
		"data-testid": "filter-chips",
		children: [e.map((e) => {
			let t = e.value ? `${e.label}: ${e.value}` : e.label;
			return /* @__PURE__ */ H(j, {
				variant: a,
				size: i,
				pr: 3,
				rightSection: /* @__PURE__ */ H(Ie, {
					size: "xs",
					variant: "transparent",
					onClick: e.onRemove,
					"aria-label": `Eliminar filtro ${e.label}`,
					"data-testid": `remove-filter-${e.key}`,
					tabIndex: 0,
					onKeyDown: (t) => {
						(t.key === "Enter" || t.key === " ") && (t.preventDefault(), e.onRemove());
					}
				}),
				"data-testid": `filter-chip-${e.key}`,
				children: t
			}, e.key);
		}), o && /* @__PURE__ */ H(N, {
			size: "xs",
			variant: "subtle",
			color: "gray",
			leftSection: /* @__PURE__ */ H(V, { size: 14 }),
			onClick: t,
			"data-testid": "clear-all-filters",
			children: n
		})]
	});
}
//#endregion
//#region src/components/feedback/NotificationIcons/NotificationIcons.tsx
var ra = 18, ia = "\n@keyframes notification-icon-spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n";
typeof document < "u" && (() => {
	if (typeof document > "u") return;
	let e = "notification-icons-spin-keyframes";
	if (document.getElementById(e)) return;
	let t = document.createElement("style");
	t.id = e, t.textContent = ia, document.head.appendChild(t);
})();
var aa = {
	success: /* @__PURE__ */ H(Dt, { size: 18 }),
	error: /* @__PURE__ */ H(V, { size: 18 }),
	warning: /* @__PURE__ */ H(yt, { size: 18 }),
	info: /* @__PURE__ */ H(on, { size: 18 }),
	loading: /* @__PURE__ */ H(ln, {
		size: 18,
		style: { animation: "notification-icon-spin 1s linear infinite" }
	})
}, oa = [
	"success",
	"error",
	"warning",
	"info",
	"loading"
];
//#endregion
//#region src/components/data-display/Breadcrumbs/Breadcrumbs.tsx
function sa(e, t) {
	if (t <= 0 || e.length <= t) return e;
	let n = Math.max(t - 2, 1);
	return [
		e[0],
		{
			label: "...",
			href: void 0
		},
		...e.slice(-n)
	];
}
function ca({ items: e, separator: t = /* @__PURE__ */ H(Mt, {
	size: 14,
	stroke: 1.5
}), renderLink: n, size: r = "sm", maxItems: i }) {
	let a = ur("(max-width: 768px)"), o = i ?? (a ? 4 : void 0);
	if (e.length === 0) return null;
	let s = o ? sa(e, o) : e;
	return /* @__PURE__ */ H("nav", {
		"aria-label": "Breadcrumb",
		"data-testid": "breadcrumbs",
		children: /* @__PURE__ */ H(Ne, {
			separator: t,
			separatorMargin: "xs",
			children: s.map((e, t) => {
				let i = t === s.length - 1, a = e.label === "...", o = !!e.href;
				return a ? /* @__PURE__ */ H(B, {
					size: r,
					c: "dimmed",
					"data-testid": "breadcrumb-ellipsis",
					children: "..."
				}, "ellipsis") : i || !o ? /* @__PURE__ */ H(B, {
					size: r,
					c: i ? void 0 : "dimmed",
					fw: i ? 500 : void 0,
					"data-testid": `breadcrumb-${t}`,
					"aria-current": i ? "page" : void 0,
					children: e.label
				}, `${e.label}-${t}`) : n ? /* @__PURE__ */ H("span", {
					"data-testid": `breadcrumb-${t}`,
					children: n(e.href, /* @__PURE__ */ H(B, {
						size: r,
						c: "dimmed",
						component: "span",
						style: { cursor: "pointer" },
						children: e.label
					}))
				}, `${e.label}-${t}`) : /* @__PURE__ */ H(Ae, {
					href: e.href,
					size: r,
					c: "dimmed",
					"data-testid": `breadcrumb-${t}`,
					children: e.label
				}, `${e.label}-${t}`);
			})
		})
	});
}
//#endregion
//#region src/components/data-display/PriceDisplay/PriceDisplay.tsx
var la = {
	sm: {
		price: "sm",
		compare: "xs",
		badge: "sm"
	},
	md: {
		price: "lg",
		compare: "sm",
		badge: "sm"
	},
	lg: {
		price: "xl",
		compare: "md",
		badge: "md"
	},
	xl: {
		price: "1.75rem",
		compare: "lg",
		badge: "lg"
	}
};
function ua(e, t, n) {
	return new Intl.NumberFormat(n, {
		style: "currency",
		currency: t,
		minimumFractionDigits: 0,
		maximumFractionDigits: 2
	}).format(e);
}
function da(e, t) {
	return t <= 0 || e >= t ? 0 : Math.round((t - e) / t * 100);
}
function fa({ price: e, compareAtPrice: t, currency: n = "ARS", locale: r = "es-AR", size: i = "md", showDiscountBadge: a = !0, layout: o = "horizontal", formatPrice: s, "data-testid": c, displayCurrency: l, exchangeRate: u, showOriginalPrice: d = !0 }) {
	let f = la[i], p = t ? da(e, t) : 0, m = p > 0, h = l != null && u != null && l !== n, g = h ? e * u : e, _ = h ? l : n, v = (e, t = _) => s ? s(e, t) : ua(e, t, r);
	return o === "vertical" ? /* @__PURE__ */ U(z, {
		gap: 4,
		"data-testid": c ?? "price-display",
		children: [
			m && t && /* @__PURE__ */ U(I, {
				gap: "xs",
				align: "center",
				children: [/* @__PURE__ */ H(B, {
					size: f.compare,
					c: "dimmed",
					td: "line-through",
					"data-testid": "price-compare",
					children: v(h ? t * u : t)
				}), a && /* @__PURE__ */ U(j, {
					size: f.badge,
					color: "green",
					variant: "light",
					"data-testid": "price-discount",
					children: [
						"-",
						p,
						"%"
					]
				})]
			}),
			/* @__PURE__ */ H(B, {
				size: f.price,
				fw: 700,
				c: m ? "green" : void 0,
				"data-testid": "price-current",
				children: v(g)
			}),
			h && d && /* @__PURE__ */ U(B, {
				size: f.compare,
				c: "dimmed",
				"data-testid": "price-original",
				children: [
					"(",
					v(e, n),
					")"
				]
			})
		]
	}) : /* @__PURE__ */ U(I, {
		gap: "xs",
		align: "center",
		wrap: "nowrap",
		"data-testid": c ?? "price-display",
		children: [
			/* @__PURE__ */ H(B, {
				size: f.price,
				fw: 700,
				c: m ? "green" : void 0,
				"data-testid": "price-current",
				children: v(g)
			}),
			h && d && /* @__PURE__ */ U(B, {
				size: f.compare,
				c: "dimmed",
				"data-testid": "price-original",
				children: [
					"(",
					v(e, n),
					")"
				]
			}),
			m && t && /* @__PURE__ */ U(Gn, { children: [/* @__PURE__ */ H(B, {
				size: f.compare,
				c: "dimmed",
				td: "line-through",
				"data-testid": "price-compare",
				children: v(h ? t * u : t)
			}), a && /* @__PURE__ */ U(j, {
				size: f.badge,
				color: "green",
				variant: "light",
				"data-testid": "price-discount",
				children: [
					"-",
					p,
					"%"
				]
			})] })
		]
	});
}
//#endregion
//#region src/components/data-display/StockBadge/StockBadge.tsx
var pa = {
	inStock: "In Stock",
	lowStock: "Low Stock",
	outOfStock: "Out of Stock",
	xInStock: "{{count}} in stock",
	onlyXLeft: "Only {{count}} left!",
	units: "units"
}, ma = {
	xs: 10,
	sm: 12,
	md: 14
}, ha = {
	in_stock: {
		color: "green",
		Icon: Dt,
		labelKey: "inStock"
	},
	low_stock: {
		color: "orange",
		Icon: yt,
		labelKey: "lowStock"
	},
	out_of_stock: {
		color: "red",
		Icon: V,
		labelKey: "outOfStock"
	}
};
function ga(e, t = 10) {
	return e <= 0 ? "out_of_stock" : e <= t ? "low_stock" : "in_stock";
}
function _a(e, t) {
	return e.replace(/\{\{count\}\}/g, String(t));
}
function va(e, t, n, r) {
	let i = r[ha[e].labelKey];
	return t === "status" ? i : e === "out_of_stock" ? r.outOfStock : n === void 0 ? i : _a(e === "low_stock" ? r.onlyXLeft : r.xInStock, n);
}
function ya({ status: e, displayMode: t = "status", quantity: n, variant: r = "badge", size: i = "sm", showLabel: a = !0, labels: o }) {
	let s = {
		...pa,
		...o
	}, c = ha[e], l = ma[i] || 12, u = c.Icon, d = va(e, t, n, s), f = a ? d : void 0;
	if (r === "icon") {
		let e = /* @__PURE__ */ H(u, {
			size: l + 2,
			color: `var(--mantine-color-${c.color}-6)`,
			"data-testid": "stock-badge-icon"
		});
		return f ? /* @__PURE__ */ H(dt, {
			label: f,
			children: /* @__PURE__ */ H("span", {
				"data-testid": "stock-badge",
				children: e
			})
		}) : /* @__PURE__ */ H("span", {
			"data-testid": "stock-badge",
			children: e
		});
	}
	return r === "text" ? /* @__PURE__ */ H(B, {
		size: i,
		c: c.color,
		fw: 500,
		"data-testid": "stock-badge",
		children: f || s[c.labelKey]
	}) : /* @__PURE__ */ H(j, {
		color: c.color,
		size: i,
		variant: e === "out_of_stock" ? "filled" : "light",
		leftSection: /* @__PURE__ */ H(u, { size: l }),
		"data-testid": "stock-badge",
		children: f || s[c.labelKey]
	});
}
//#endregion
//#region src/components/data-display/Timeline/Timeline.tsx
var ba = (e) => (typeof e == "string" ? new Date(e) : e).toLocaleString("es-AR", {
	day: "2-digit",
	month: "2-digit",
	year: "numeric",
	hour: "2-digit",
	minute: "2-digit"
}), xa = (e, t) => {
	switch (e) {
		case "completed": return /* @__PURE__ */ H(Ft, { size: t * .6 });
		case "current": return /* @__PURE__ */ H(It, { size: t * .6 });
		default: return /* @__PURE__ */ H(Pt, { size: t * .6 });
	}
}, Sa = (e) => {
	switch (e) {
		case "completed": return "green";
		case "current": return "blue";
		default: return "gray";
	}
}, Ca = (e) => e === "pending" ? "light" : "filled";
function wa({ events: e, activeIndex: t, reverseOrder: n = !1, bulletSize: r = 36, lineWidth: i = 2, formatTimestamp: a = ba, labels: o }) {
	let s = t ?? e.findIndex((e) => e.status === "current"), c = n ? [...e].reverse() : e, l = n ? e.length - 1 - s : s;
	return /* @__PURE__ */ H(lt, {
		active: l >= 0 ? l : void 0,
		bulletSize: r,
		lineWidth: i,
		"data-testid": "timeline",
		children: c.map((e) => {
			let t = e.status || "pending", n = e.color || Sa(t), i = Ca(t);
			return /* @__PURE__ */ H(lt.Item, {
				"data-testid": `timeline-item-${e.id}`,
				bullet: e.icon ? /* @__PURE__ */ H(ct, {
					size: r,
					variant: i,
					color: n,
					radius: "xl",
					children: e.icon
				}) : /* @__PURE__ */ H(ct, {
					size: r,
					variant: i,
					color: n,
					radius: "xl",
					children: xa(t, r)
				}),
				title: /* @__PURE__ */ U(I, {
					gap: "xs",
					children: [/* @__PURE__ */ H(B, {
						fw: 500,
						"data-testid": `timeline-title-${e.id}`,
						children: e.title
					}), t === "current" && o?.current && /* @__PURE__ */ U(B, {
						size: "sm",
						c: "dimmed",
						children: [
							"(",
							o.current,
							")"
						]
					})]
				}),
				children: /* @__PURE__ */ U(z, {
					gap: 4,
					children: [e.description && /* @__PURE__ */ H(B, {
						size: "sm",
						c: "dimmed",
						"data-testid": `timeline-description-${e.id}`,
						children: e.description
					}), e.timestamp && /* @__PURE__ */ H(B, {
						size: "xs",
						c: "dimmed",
						"data-testid": `timeline-timestamp-${e.id}`,
						children: a(e.timestamp)
					})]
				})
			}, e.id);
		})
	});
}
//#endregion
//#region src/components/data-display/DataTable/DataTableHeader.tsx
function Ta({ sortOrder: e, active: t }) {
	return t ? H(e === "asc" ? Nt : At, {
		size: 14,
		stroke: 2
	}) : /* @__PURE__ */ H(En, {
		size: 14,
		stroke: 1.5,
		style: { opacity: .5 }
	});
}
function Ea({ columns: e, sortBy: t, sortOrder: n, onSort: r, selectable: i, allSelected: a, someSelected: o, onSelectAll: s }) {
	return /* @__PURE__ */ U("tr", {
		"data-testid": "datatable-header",
		children: [i && /* @__PURE__ */ H("th", {
			style: { width: 40 },
			children: /* @__PURE__ */ H(Pe, { children: /* @__PURE__ */ H("input", {
				type: "checkbox",
				checked: a ?? !1,
				ref: (e) => {
					e && (e.indeterminate = !!(o && !a));
				},
				onChange: s,
				"data-testid": "datatable-select-all",
				"aria-label": "Select all rows"
			}) })
		}), e.map((e) => {
			let i = String(e.key), a = t === i, o = /* @__PURE__ */ U(I, {
				gap: 4,
				wrap: "nowrap",
				children: [/* @__PURE__ */ H(B, {
					fw: 500,
					size: "sm",
					children: e.label
				}), e.sortable && /* @__PURE__ */ H(Ta, {
					sortOrder: n,
					active: a
				})]
			});
			return /* @__PURE__ */ H("th", {
				style: {
					width: e.width,
					textAlign: e.align || "left"
				},
				"data-testid": `datatable-header-${i}`,
				children: e.sortable && r ? /* @__PURE__ */ H(ft, {
					onClick: () => r(i),
					style: { width: "100%" },
					"data-testid": `datatable-sort-${i}`,
					children: o
				}) : o
			}, i);
		})]
	});
}
//#endregion
//#region src/components/data-display/DataTable/DataTablePagination.tsx
var Da = [
	{
		value: "10",
		label: "10"
	},
	{
		value: "25",
		label: "25"
	},
	{
		value: "50",
		label: "50"
	},
	{
		value: "100",
		label: "100"
	}
];
function Oa({ pagination: e, onPageChange: t, onLimitChange: n }) {
	let { page: r, limit: i, total: a } = e, o = Math.ceil(a / i), s = a === 0 ? 0 : (r - 1) * i + 1, c = Math.min(r * i, a);
	return /* @__PURE__ */ U(I, {
		justify: "space-between",
		mt: "md",
		"data-testid": "datatable-pagination",
		children: [/* @__PURE__ */ U(I, {
			gap: "xs",
			children: [
				/* @__PURE__ */ H(B, {
					size: "sm",
					c: "dimmed",
					children: "Mostrar"
				}),
				/* @__PURE__ */ H(rt, {
					value: String(i),
					onChange: (e) => {
						e && n && n(Number(e));
					},
					data: Da,
					size: "xs",
					w: 70,
					"data-testid": "datatable-limit-select",
					"aria-label": "Items per page"
				}),
				/* @__PURE__ */ U(B, {
					size: "sm",
					c: "dimmed",
					children: [
						"de ",
						a,
						" registros"
					]
				})
			]
		}), /* @__PURE__ */ U(I, {
			gap: "md",
			children: [/* @__PURE__ */ U(B, {
				size: "sm",
				c: "dimmed",
				"data-testid": "datatable-range",
				children: [
					s,
					"-",
					c,
					" de ",
					a
				]
			}), o > 1 && /* @__PURE__ */ H(Xe, {
				value: r,
				onChange: (e) => t?.(e),
				total: o,
				size: "sm",
				"data-testid": "datatable-pages"
			})]
		})]
	});
}
//#endregion
//#region src/components/data-display/DataTable/DataTable.tsx
function ka(e, t) {
	return t.split(".").reduce((e, t) => {
		if (e && typeof e == "object" && t in e) return e[t];
	}, e);
}
function Aa(e, t) {
	let n = e;
	return "guid" in n && typeof n.guid == "string" ? n.guid : "id" in n && typeof n.id == "string" ? n.id : "id" in n && typeof n.id == "number" ? String(n.id) : String(t);
}
function ja({ data: e, columns: t, loading: n = !1, pagination: r, onPageChange: i, onLimitChange: a, sortBy: o, sortOrder: s, onSort: c, selectable: l = !1, selectedIds: u = [], onSelectionChange: d, getRowId: f, emptyState: p, onRowClick: m, striped: h = !1, highlightOnHover: g = !0, layout: _ = "auto", verticalAlign: v = "middle" }) {
	let y = G((e, t) => f ? f(e) : Aa(e, t), [f]), b = q(() => new Set(u), [u]), x = q(() => e.map((e, t) => y(e, t)), [e, y]), S = x.length > 0 && x.every((e) => b.has(e)), C = x.some((e) => b.has(e)), ee = G(() => {
		d && d(S ? u.filter((e) => !x.includes(e)) : [...new Set([...u, ...x])]);
	}, [
		S,
		u,
		x,
		d
	]), te = G((e) => {
		d && (b.has(e) ? d(u.filter((t) => t !== e)) : d([...u, e]));
	}, [
		b,
		u,
		d
	]), ne = G((e, t, n) => {
		let r = ka(e, String(t.key));
		return t.render ? t.render(r, e, n) : r == null ? "-" : String(r);
	}, []);
	return n ? /* @__PURE__ */ H(M, {
		"data-testid": "datatable-loading",
		children: /* @__PURE__ */ H(Vi, {
			rows: r?.limit || 10,
			columns: t.length + +!!l
		})
	}) : e.length === 0 ? /* @__PURE__ */ H(M, {
		"data-testid": "datatable-empty",
		children: p || /* @__PURE__ */ H(Qi, {
			title: "No hay datos",
			description: "No se encontraron registros"
		})
	}) : /* @__PURE__ */ U(M, {
		"data-testid": "datatable",
		children: [/* @__PURE__ */ U(ot, {
			striped: h,
			highlightOnHover: g,
			layout: _,
			verticalSpacing: "sm",
			children: [/* @__PURE__ */ H(ot.Thead, { children: /* @__PURE__ */ H(Ea, {
				columns: t,
				sortBy: o,
				sortOrder: s,
				onSort: c,
				selectable: l,
				allSelected: S,
				someSelected: C,
				onSelectAll: ee
			}) }), /* @__PURE__ */ H(ot.Tbody, { children: e.map((e, n) => {
				let r = y(e, n), i = b.has(r), a = !!m;
				return /* @__PURE__ */ U(ot.Tr, {
					"data-testid": `datatable-row-${n}`,
					"data-selected": i,
					style: {
						cursor: a ? "pointer" : void 0,
						backgroundColor: i ? "var(--mantine-color-blue-light)" : void 0
					},
					onClick: a ? (t) => {
						t.target.closest("input[type=\"checkbox\"]") || m(e);
					} : void 0,
					children: [l && /* @__PURE__ */ H(ot.Td, {
						style: {
							width: 40,
							verticalAlign: v
						},
						children: /* @__PURE__ */ H(Pe, { children: /* @__PURE__ */ H(Fe, {
							checked: i,
							onChange: () => te(r),
							"data-testid": `datatable-select-${n}`,
							"aria-label": `Select row ${n + 1}`
						}) })
					}), t.map((t) => /* @__PURE__ */ H(ot.Td, {
						style: {
							width: t.width,
							textAlign: t.align || "left",
							verticalAlign: v
						},
						"data-testid": `datatable-cell-${n}-${t.key}`,
						children: ne(e, t, n)
					}, String(t.key)))]
				}, r);
			}) })]
		}), r && /* @__PURE__ */ H(Oa, {
			pagination: r,
			onPageChange: i,
			onLimitChange: a
		})]
	});
}
//#endregion
//#region src/components/data-display/KPICard/KPICard.tsx
function Ma(e, t = "number", n = "ARS", r) {
	if (typeof e == "string") return e;
	switch (t) {
		case "currency": return ee(e, n, { showCode: !1 });
		case "percentage": return `${S(e, r ?? 1)}%`;
		default: return S(e, r ?? 0);
	}
}
function Na(e) {
	return e > 0 ? "green" : e < 0 ? "red" : "gray";
}
function Pa({ trend: e }) {
	return H(e > 0 ? Ln : e < 0 ? In : hn, {
		size: 14,
		stroke: 2
	});
}
function Fa() {
	return /* @__PURE__ */ H(P, {
		withBorder: !0,
		padding: "lg",
		radius: "md",
		"data-testid": "kpicard-loading",
		children: /* @__PURE__ */ U(z, {
			gap: "xs",
			children: [
				/* @__PURE__ */ U(I, {
					justify: "space-between",
					children: [/* @__PURE__ */ H(R, {
						height: 14,
						width: 100
					}), /* @__PURE__ */ H(R, {
						height: 24,
						width: 24,
						radius: "sm"
					})]
				}),
				/* @__PURE__ */ H(R, {
					height: 32,
					width: "60%"
				}),
				/* @__PURE__ */ H(R, {
					height: 12,
					width: "40%"
				})
			]
		})
	});
}
function Ia({ title: e, value: t, format: n = "number", currency: r = "ARS", decimals: i, trend: a, trendPeriod: o, icon: s, color: c = "blue", highlight: l = !1, loading: u = !1 }) {
	if (u) return /* @__PURE__ */ H(Fa, {});
	let d = Ma(t, n, r, i), f = a !== void 0, p = f ? Na(a) : "gray";
	return /* @__PURE__ */ H(P, {
		withBorder: !0,
		padding: "lg",
		radius: "md",
		"data-testid": "kpicard",
		style: {
			borderColor: l ? `var(--mantine-color-${c}-6)` : void 0,
			borderWidth: l ? 2 : void 0,
			backgroundColor: l ? `var(--mantine-color-${c}-light)` : void 0
		},
		children: /* @__PURE__ */ U(z, {
			gap: "xs",
			children: [
				/* @__PURE__ */ U(I, {
					justify: "space-between",
					align: "flex-start",
					children: [/* @__PURE__ */ H(B, {
						size: "sm",
						c: "dimmed",
						fw: 500,
						"data-testid": "kpicard-title",
						children: e
					}), s && /* @__PURE__ */ H(ct, {
						variant: "light",
						color: c,
						size: "md",
						radius: "sm",
						"data-testid": "kpicard-icon",
						children: s
					})]
				}),
				/* @__PURE__ */ H(B, {
					size: "xl",
					fw: 700,
					lh: 1.2,
					"data-testid": "kpicard-value",
					children: d
				}),
				f && /* @__PURE__ */ U(I, {
					gap: 4,
					"data-testid": "kpicard-trend",
					children: [
						/* @__PURE__ */ H(M, {
							c: p,
							children: /* @__PURE__ */ H(Pa, { trend: a })
						}),
						/* @__PURE__ */ U(B, {
							size: "xs",
							c: p,
							fw: 500,
							children: [
								a > 0 ? "+" : "",
								S(a, 1),
								"%"
							]
						}),
						o && /* @__PURE__ */ H(B, {
							size: "xs",
							c: "dimmed",
							children: o
						})
					]
				})
			]
		})
	});
}
//#endregion
//#region src/components/data-display/Chart/chartConfig.ts
var La = {
	primary: "blue.6",
	secondary: "cyan.6",
	success: "green.6",
	warning: "yellow.6",
	danger: "red.6",
	neutral: "gray.6",
	indigo: "indigo.6",
	violet: "violet.6",
	grape: "grape.6",
	pink: "pink.6",
	orange: "orange.6",
	teal: "teal.6",
	lime: "lime.6"
}, Ra = [
	La.primary,
	La.secondary,
	La.success,
	La.warning,
	La.indigo,
	La.violet,
	La.orange,
	La.teal
], za = [
	"blue.5",
	"cyan.5",
	"teal.5",
	"green.5",
	"lime.5",
	"yellow.5",
	"orange.5",
	"red.5",
	"pink.5",
	"grape.5",
	"violet.5",
	"indigo.5"
], Z = {
	withLegend: !0,
	withTooltip: !0,
	gridAxis: "x",
	curveType: "monotone",
	height: 300,
	locale: "es-AR",
	tooltipAnimationDuration: 200
}, Ba = { width: 60 }, Va = { tickLine: "x" };
function Ha(e) {
	return e in La ? La[e] : e;
}
function Ua(e) {
	return e.map((e, t) => ({
		...e,
		color: e.color ?? Ra[t % Ra.length]
	}));
}
function Wa(e) {
	return e.map((e, t) => ({
		...e,
		color: e.color ?? za[t % za.length]
	}));
}
//#endregion
//#region src/components/data-display/Chart/TeleAreaChart.tsx
function Ga({ data: e, dataKey: t, series: n, title: r, height: i = Z.height, loading: a = !1, withLegend: o = Z.withLegend, withTooltip: s = Z.withTooltip, withDots: c = !1, withGradient: l = !0, gridAxis: u = Z.gridAxis, curveType: d = Z.curveType, stacked: f = !1, xAxisLabel: p, yAxisLabel: m, valueFormatter: h, chartProps: g }) {
	if (a) return /* @__PURE__ */ H(Wi, { height: i });
	let _ = Ua(n);
	return /* @__PURE__ */ U(z, {
		gap: "xs",
		"data-testid": "tele-area-chart",
		children: [r && /* @__PURE__ */ H(B, {
			fw: 500,
			size: "sm",
			c: "dimmed",
			children: r
		}), /* @__PURE__ */ H(fr, {
			h: i,
			data: e,
			dataKey: t,
			series: _,
			type: f ? "stacked" : "default",
			withLegend: o,
			withTooltip: s,
			withDots: c,
			withGradient: l,
			gridAxis: u,
			curveType: d,
			xAxisLabel: p,
			yAxisLabel: m,
			valueFormatter: h,
			tooltipAnimationDuration: Z.tooltipAnimationDuration,
			yAxisProps: Ba,
			...g
		})]
	});
}
//#endregion
//#region src/components/data-display/Chart/TeleBarChart.tsx
function Ka({ data: e, dataKey: t, series: n, title: r, height: i = Z.height, loading: a = !1, withLegend: o = Z.withLegend, withTooltip: s = Z.withTooltip, gridAxis: c = Z.gridAxis, stacked: l = !1, orientation: u = "vertical", maxBarWidth: d, xAxisLabel: f, yAxisLabel: p, valueFormatter: m, chartProps: h }) {
	if (a) return /* @__PURE__ */ H(Wi, { height: i });
	let g = Ua(n);
	return /* @__PURE__ */ U(z, {
		gap: "xs",
		"data-testid": "tele-bar-chart",
		children: [r && /* @__PURE__ */ H(B, {
			fw: 500,
			size: "sm",
			c: "dimmed",
			children: r
		}), /* @__PURE__ */ H(pr, {
			h: i,
			data: e,
			dataKey: t,
			series: g,
			type: l ? "stacked" : "default",
			orientation: u,
			withLegend: o,
			withTooltip: s,
			gridAxis: c,
			xAxisLabel: f,
			yAxisLabel: p,
			valueFormatter: m,
			maxBarWidth: d,
			tooltipAnimationDuration: Z.tooltipAnimationDuration,
			yAxisProps: u === "horizontal" ? { width: 80 } : Ba,
			...h
		})]
	});
}
//#endregion
//#region src/components/data-display/Chart/TeleLineChart.tsx
function qa({ data: e, dataKey: t, series: n, title: r, height: i = Z.height, loading: a = !1, withLegend: o = Z.withLegend, withTooltip: s = Z.withTooltip, withDots: c = !0, gridAxis: l = Z.gridAxis, curveType: u = Z.curveType, strokeWidth: d, xAxisLabel: f, yAxisLabel: p, valueFormatter: m, chartProps: h }) {
	if (a) return /* @__PURE__ */ H(Wi, { height: i });
	let g = Ua(n);
	return /* @__PURE__ */ U(z, {
		gap: "xs",
		"data-testid": "tele-line-chart",
		children: [r && /* @__PURE__ */ H(B, {
			fw: 500,
			size: "sm",
			c: "dimmed",
			children: r
		}), /* @__PURE__ */ H(hr, {
			h: i,
			data: e,
			dataKey: t,
			series: g,
			withLegend: o,
			withTooltip: s,
			withDots: c,
			gridAxis: l,
			curveType: u,
			strokeWidth: d,
			xAxisLabel: f,
			yAxisLabel: p,
			valueFormatter: m,
			tooltipAnimationDuration: Z.tooltipAnimationDuration,
			yAxisProps: Ba,
			...h
		})]
	});
}
//#endregion
//#region src/components/data-display/Chart/TelePieChart.tsx
function Ja({ size: e }) {
	return /* @__PURE__ */ U(z, {
		gap: "xs",
		align: "center",
		"data-testid": "pie-chart-skeleton",
		children: [/* @__PURE__ */ H(R, {
			height: e,
			width: e,
			circle: !0
		}), /* @__PURE__ */ H(R, {
			height: 16,
			width: 120
		})]
	});
}
function Ya({ data: e, title: t, size: n = 200, loading: r = !1, withLabels: i = !1, labelsPosition: a = "outside", labelsType: o = "percent", withTooltip: s = !0, strokeColor: c, strokeWidth: l = 1, valueFormatter: u, chartProps: d }) {
	if (r) return /* @__PURE__ */ H(Ja, { size: n });
	let f = Wa(e);
	return /* @__PURE__ */ U(z, {
		gap: "xs",
		"data-testid": "tele-pie-chart",
		children: [t && /* @__PURE__ */ H(B, {
			fw: 500,
			size: "sm",
			c: "dimmed",
			ta: "center",
			children: t
		}), /* @__PURE__ */ H(Pe, { children: /* @__PURE__ */ H(gr, {
			data: f,
			size: n,
			withLabels: i,
			labelsPosition: a,
			labelsType: o,
			withTooltip: s,
			strokeColor: c,
			strokeWidth: l,
			valueFormatter: u,
			tooltipDataSource: "segment",
			...d
		}) })]
	});
}
//#endregion
//#region src/components/data-display/Chart/TeleDonutChart.tsx
function Xa({ size: e }) {
	return /* @__PURE__ */ U(z, {
		gap: "xs",
		align: "center",
		"data-testid": "donut-chart-skeleton",
		children: [/* @__PURE__ */ H(R, {
			height: e,
			width: e,
			circle: !0
		}), /* @__PURE__ */ H(R, {
			height: 16,
			width: 120
		})]
	});
}
function Za({ data: e, title: t, size: n = 200, thickness: r = 20, loading: i = !1, withLabels: a = !1, withLabelsLine: o = !0, withTooltip: s = !0, centerLabel: c, strokeColor: l, strokeWidth: u = 1, valueFormatter: d, chartProps: f }) {
	if (i) return /* @__PURE__ */ H(Xa, { size: n });
	let p = Wa(e);
	return /* @__PURE__ */ U(z, {
		gap: "xs",
		"data-testid": "tele-donut-chart",
		children: [t && /* @__PURE__ */ H(B, {
			fw: 500,
			size: "sm",
			c: "dimmed",
			ta: "center",
			children: t
		}), /* @__PURE__ */ H(Pe, { children: /* @__PURE__ */ H(mr, {
			data: p,
			size: n,
			thickness: r,
			withLabels: a,
			withLabelsLine: o,
			withTooltip: s,
			strokeColor: l,
			strokeWidth: u,
			valueFormatter: d,
			tooltipDataSource: "segment",
			...c ? { chartLabel: c } : {},
			...f
		}) })]
	});
}
//#endregion
//#region src/components/inputs/QuantityInput/QuantityInput.tsx
function Qa({ value: e, onChange: t, min: n = 1, max: r = 99, step: i = 1, decimalScale: a, disabled: o = !1, size: s = "md" }) {
	let c = () => {
		let r = e - i;
		t(r >= n ? r : n);
	}, l = () => {
		let n = e + i;
		t(n <= r ? n : r);
	}, u = (e) => {
		let i = typeof e == "string" ? parseFloat(e) : e;
		t(isNaN(i) ? n : Math.min(r, Math.max(n, i)));
	}, d = (e) => {
		o || (e.key === "ArrowUp" ? (e.preventDefault(), l()) : e.key === "ArrowDown" && (e.preventDefault(), c()));
	}, f = s === "sm" ? "md" : s === "lg" ? "xl" : "lg", p = s === "sm" ? 50 : s === "lg" ? 70 : 60, m = s === "sm" ? 14 : s === "lg" ? 18 : 16;
	return /* @__PURE__ */ U(I, {
		gap: 0,
		"data-testid": "quantity-input-group",
		children: [
			/* @__PURE__ */ H(A, {
				variant: "default",
				size: f,
				onClick: c,
				disabled: o || e <= n,
				"aria-label": "Decrease quantity",
				style: {
					borderTopRightRadius: 0,
					borderBottomRightRadius: 0
				},
				"data-testid": "quantity-decrease",
				children: /* @__PURE__ */ H(hn, { size: m })
			}),
			/* @__PURE__ */ H(Ye, {
				value: e,
				onChange: u,
				onKeyDown: d,
				min: n,
				max: r,
				step: i,
				decimalScale: a,
				disabled: o,
				hideControls: !0,
				w: p,
				size: s,
				styles: { input: {
					textAlign: "center",
					borderRadius: 0,
					borderLeft: 0,
					borderRight: 0
				} },
				"aria-label": "Quantity",
				"data-testid": "quantity-input"
			}),
			/* @__PURE__ */ H(A, {
				variant: "default",
				size: f,
				onClick: l,
				disabled: o || e >= r,
				"aria-label": "Increase quantity",
				style: {
					borderTopLeftRadius: 0,
					borderBottomLeftRadius: 0
				},
				"data-testid": "quantity-increase",
				children: /* @__PURE__ */ H(xn, { size: m })
			})
		]
	});
}
//#endregion
//#region src/hooks/useDebounce.ts
function $a(e, t = {}) {
	let { wait: n = 300, leading: r = !1 } = t, [i] = cr(e, n, { leading: r });
	return i;
}
function eo(e, t = 300) {
	let n = J(null), r = J(e);
	return K(() => {
		r.current = e;
	}, [e]), K(() => () => {
		n.current && clearTimeout(n.current);
	}, []), G((...e) => {
		n.current && clearTimeout(n.current), n.current = setTimeout(() => {
			r.current(...e);
		}, t);
	}, [t]);
}
//#endregion
//#region src/components/inputs/SearchInput/SearchInput.tsx
function to({ value: e, onChange: t, debounceMs: n = 300, onDebouncedChange: r, suggestions: i = [], onSuggestionSelect: a, onSearch: o, onClear: s, placeholder: c = "Buscar...", loading: l = !1, disabled: u = !1, size: d = "md", autoFocus: f = !1 }) {
	let p = J(null), [m, h] = Y(!1), g = $a(e, { wait: n });
	K(() => {
		r && r(g);
	}, [g, r]);
	let _ = mt({
		onDropdownClose: () => {
			_.resetSelectedOption(), h(!1);
		},
		onDropdownOpen: () => {
			h(!0);
		}
	});
	K(() => {
		i.length > 0 && e.trim() !== "" && !u ? _.openDropdown() : _.closeDropdown();
	}, [
		i,
		e,
		u,
		_
	]);
	let v = G((e) => {
		t(e.currentTarget.value);
	}, [t]), y = G(() => {
		t(""), s?.(), p.current?.focus();
	}, [t, s]), b = G((t) => {
		if (t.key === "Enter") {
			if (t.preventDefault(), m && _.getSelectedOptionIndex() !== -1) {
				let e = i[_.getSelectedOptionIndex()];
				if (e && a) {
					a(e), _.closeDropdown();
					return;
				}
			}
			o?.(e), _.closeDropdown();
		}
		m && i.length > 0 && (t.key === "ArrowDown" ? (t.preventDefault(), _.selectNextOption()) : t.key === "ArrowUp" ? (t.preventDefault(), _.selectPreviousOption()) : t.key === "Escape" && _.closeDropdown());
	}, [
		e,
		o,
		m,
		i,
		_,
		a
	]), x = G((e) => {
		t(e), a?.(e), _.closeDropdown(), p.current?.focus();
	}, [
		t,
		a,
		_
	]), S = l ? /* @__PURE__ */ H(Ke, {
		size: "xs",
		"data-testid": "search-loading"
	}) : e ? /* @__PURE__ */ H(A, {
		variant: "subtle",
		color: "gray",
		onClick: y,
		disabled: u,
		"data-testid": "search-clear",
		"aria-label": "Clear search",
		children: /* @__PURE__ */ H(V, { size: 16 })
	}) : null, C = i.map((e, t) => /* @__PURE__ */ H(F.Option, {
		value: e,
		"data-testid": `search-suggestion-${t}`,
		children: e
	}, e));
	return /* @__PURE__ */ U(F, {
		store: _,
		onOptionSubmit: x,
		children: [/* @__PURE__ */ H(F.Target, { children: /* @__PURE__ */ H(st, {
			ref: p,
			value: e,
			onChange: v,
			onKeyDown: b,
			onFocus: () => {
				i.length > 0 && e.trim() !== "" && _.openDropdown();
			},
			onBlur: () => _.closeDropdown(),
			placeholder: c,
			disabled: u,
			size: d,
			autoFocus: f,
			leftSection: /* @__PURE__ */ H(Tn, { size: 16 }),
			rightSection: S,
			"data-testid": "search-input",
			"aria-label": "Search"
		}) }), i.length > 0 && /* @__PURE__ */ H(F.Dropdown, {
			"data-testid": "search-suggestions",
			children: /* @__PURE__ */ H(F.Options, { children: /* @__PURE__ */ H(tt.Autosize, {
				mah: 200,
				children: C
			}) })
		})]
	});
}
//#endregion
//#region src/components/inputs/CurrencyInput/CurrencyInput.tsx
var no = {
	ARS: "$",
	USD: "US$",
	USDT: "USDT "
};
function ro({ value: e, onChange: t, currency: n = "ARS", decimalScale: r = 2, min: i, max: a, placeholder: o, label: s, error: c, disabled: l, required: u, ...d }) {
	let f = (e) => {
		if (e === "" || e === void 0) t(null);
		else if (typeof e == "number") t(e);
		else {
			let n = parseFloat(e);
			t(isNaN(n) ? null : n);
		}
	}, p = no[n] || "$";
	return /* @__PURE__ */ H(Ye, {
		value: e ?? "",
		onChange: f,
		prefix: p + " ",
		decimalScale: r,
		fixedDecimalScale: !0,
		decimalSeparator: ",",
		thousandSeparator: ".",
		min: i,
		max: a,
		placeholder: o,
		label: s,
		error: c,
		disabled: l,
		required: u,
		allowNegative: i === void 0 || i < 0,
		hideControls: !0,
		"data-testid": "currency-input",
		...d
	});
}
//#endregion
//#region src/components/inputs/DateRangePicker/DateRangePicker.tsx
X.locale("es");
var io = (e) => X(e).startOf("day").toDate(), ao = (e) => X(e).endOf("day").toDate(), oo = {
	today: {
		label: "Hoy",
		getValue: () => [io(/* @__PURE__ */ new Date()), ao(/* @__PURE__ */ new Date())]
	},
	yesterday: {
		label: "Ayer",
		getValue: () => {
			let e = X().subtract(1, "day");
			return [io(e.toDate()), ao(e.toDate())];
		}
	},
	last7Days: {
		label: "Últimos 7 días",
		getValue: () => [io(X().subtract(6, "day").toDate()), ao(/* @__PURE__ */ new Date())]
	},
	last30Days: {
		label: "Últimos 30 días",
		getValue: () => [io(X().subtract(29, "day").toDate()), ao(/* @__PURE__ */ new Date())]
	},
	thisMonth: {
		label: "Este mes",
		getValue: () => [io(X().startOf("month").toDate()), ao(/* @__PURE__ */ new Date())]
	},
	lastMonth: {
		label: "Mes pasado",
		getValue: () => {
			let e = X().subtract(1, "month");
			return [io(e.startOf("month").toDate()), ao(e.endOf("month").toDate())];
		}
	},
	thisYear: {
		label: "Este año",
		getValue: () => [io(X().startOf("year").toDate()), ao(/* @__PURE__ */ new Date())]
	}
}, so = (e) => {
	let [t, n] = e;
	return !t && !n ? "" : t && !n ? X(t).format("DD/MM/YYYY") + " - ..." : !t && n ? "... - " + X(n).format("DD/MM/YYYY") : X(t).format("DD/MM/YYYY") + " - " + X(n).format("DD/MM/YYYY");
};
function co({ value: e, onChange: t, label: n, placeholder: r = "Seleccionar rango", minDate: i, maxDate: a, presets: o, error: s, disabled: c = !1, clearable: l = !0 }) {
	let [u, d] = Y(!1), f = (e) => {
		t(e), e[0] && e[1] && d(!1);
	}, p = (e) => {
		t(e.getValue()), d(!1);
	}, m = (e) => {
		e.stopPropagation(), t([null, null]);
	}, h = so(e), g = e[0] || e[1];
	return /* @__PURE__ */ U($e, {
		opened: u,
		onChange: d,
		position: "bottom-start",
		width: "auto",
		shadow: "md",
		children: [/* @__PURE__ */ H($e.Target, { children: /* @__PURE__ */ H(st, {
			value: h,
			label: n,
			placeholder: r,
			error: s,
			disabled: c,
			readOnly: !0,
			onClick: () => !c && d((e) => !e),
			leftSection: /* @__PURE__ */ H(Et, { size: 16 }),
			rightSection: l && g && !c ? /* @__PURE__ */ H(A, {
				size: "sm",
				variant: "subtle",
				color: "gray",
				onClick: m,
				"aria-label": "Clear date range",
				children: /* @__PURE__ */ H(V, { size: 14 })
			}) : null,
			styles: { input: { cursor: c ? "not-allowed" : "pointer" } },
			"data-testid": "date-range-picker-input"
		}) }), /* @__PURE__ */ H($e.Dropdown, { children: /* @__PURE__ */ U(z, {
			gap: "md",
			children: [o && o.length > 0 && /* @__PURE__ */ H(I, {
				gap: "xs",
				"data-testid": "date-range-presets",
				children: o.map((e, t) => /* @__PURE__ */ H(N, {
					variant: "light",
					size: "xs",
					onClick: () => p(e),
					"data-testid": `date-range-preset-${t}`,
					children: e.label
				}, t))
			}), /* @__PURE__ */ H(_r, {
				type: "range",
				value: [e[0] ? X(e[0]).format("YYYY-MM-DD") : null, e[1] ? X(e[1]).format("YYYY-MM-DD") : null],
				onChange: (e) => f([e[0] ? X(e[0]).toDate() : null, e[1] ? X(e[1]).toDate() : null]),
				minDate: i,
				maxDate: a,
				locale: "es",
				numberOfColumns: 2,
				"data-testid": "date-range-calendar"
			})]
		}) })]
	});
}
//#endregion
//#region src/components/overlays/ConfirmModal/ConfirmModal.tsx
function lo({ opened: e, onClose: t, onConfirm: n, title: r, message: i, confirmLabel: a = "Confirmar", cancelLabel: o = "Cancelar", confirmColor: s, loading: c, danger: l = !1 }) {
	let [u, d] = Y(!1), f = c ?? u, p = s ?? (l ? "red" : "blue"), m = G(async () => {
		try {
			d(!0), await n();
		} finally {
			d(!1);
		}
	}, [n]);
	return K(() => {
		if (!e) return;
		let t = (e) => {
			e.key === "Enter" && !f && (e.preventDefault(), m());
		};
		return document.addEventListener("keydown", t), () => document.removeEventListener("keydown", t);
	}, [
		e,
		f,
		m
	]), /* @__PURE__ */ H(qe, {
		opened: e,
		onClose: t,
		title: r,
		centered: !0,
		closeOnClickOutside: !f,
		closeOnEscape: !f,
		withCloseButton: !f,
		"data-testid": "confirm-modal",
		children: /* @__PURE__ */ U(z, {
			gap: "lg",
			children: [typeof i == "string" ? /* @__PURE__ */ H(B, {
				size: "sm",
				"data-testid": "confirm-modal-message",
				children: i
			}) : /* @__PURE__ */ H("div", {
				"data-testid": "confirm-modal-message",
				children: i
			}), /* @__PURE__ */ U(I, {
				justify: "flex-end",
				gap: "sm",
				children: [/* @__PURE__ */ H(N, {
					variant: "default",
					onClick: t,
					disabled: f,
					"data-testid": "confirm-modal-cancel",
					children: o
				}), /* @__PURE__ */ H(N, {
					color: p,
					onClick: m,
					loading: f,
					"data-testid": "confirm-modal-confirm",
					children: a
				})]
			})]
		})
	});
}
//#endregion
//#region src/components/overlays/ImageLightbox/ImageLightbox.tsx
function uo({ images: e, initialIndex: t = 0, opened: n, onClose: r, alt: i }) {
	let [a, o] = Y(t), [s, c] = Y(1);
	K(() => {
		n && (o(t), c(1));
	}, [n, t]);
	let l = e.length > 1, u = a > 0, d = a < e.length - 1, f = G(() => {
		u && (o((e) => e - 1), c(1));
	}, [u]), p = G(() => {
		d && (o((e) => e + 1), c(1));
	}, [d]), m = G(() => {
		c((e) => e === 1 ? 2 : 1);
	}, []), h = G(() => {
		c((e) => Math.min(e + .5, 3));
	}, []), g = G(() => {
		c((e) => Math.max(e - .5, 1));
	}, []);
	if (K(() => {
		if (!n) return;
		let e = (e) => {
			switch (e.key) {
				case "ArrowLeft":
					e.preventDefault(), f();
					break;
				case "ArrowRight":
					e.preventDefault(), p();
					break;
				case "Escape":
					e.preventDefault(), r();
					break;
				case "+":
				case "=":
					e.preventDefault(), h();
					break;
				case "-":
					e.preventDefault(), g();
					break;
			}
		};
		return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e);
	}, [
		n,
		f,
		p,
		r,
		h,
		g
	]), e.length === 0) return null;
	let _ = e[a], v = i || `Image ${a + 1}`;
	return /* @__PURE__ */ U(qe, {
		opened: n,
		onClose: r,
		fullScreen: !0,
		withCloseButton: !1,
		padding: 0,
		styles: {
			body: {
				height: "100%",
				display: "flex",
				flexDirection: "column",
				backgroundColor: "rgba(0, 0, 0, 0.95)"
			},
			content: { backgroundColor: "transparent" }
		},
		"data-testid": "image-lightbox",
		children: [
			/* @__PURE__ */ U(I, {
				justify: "space-between",
				p: "md",
				style: {
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					zIndex: 10
				},
				children: [/* @__PURE__ */ H(I, {
					gap: "xs",
					children: l && /* @__PURE__ */ U(B, {
						c: "white",
						size: "sm",
						"data-testid": "lightbox-counter",
						children: [
							a + 1,
							" / ",
							e.length
						]
					})
				}), /* @__PURE__ */ U(I, {
					gap: "xs",
					children: [
						/* @__PURE__ */ H(A, {
							variant: "subtle",
							color: "gray",
							size: "lg",
							onClick: g,
							disabled: s <= 1,
							"aria-label": "Zoom out",
							"data-testid": "lightbox-zoom-out",
							children: /* @__PURE__ */ H(Wn, {
								size: 20,
								color: "white"
							})
						}),
						/* @__PURE__ */ H(A, {
							variant: "subtle",
							color: "gray",
							size: "lg",
							onClick: h,
							disabled: s >= 3,
							"aria-label": "Zoom in",
							"data-testid": "lightbox-zoom-in",
							children: /* @__PURE__ */ H(Un, {
								size: 20,
								color: "white"
							})
						}),
						/* @__PURE__ */ H(A, {
							variant: "subtle",
							color: "gray",
							size: "lg",
							onClick: r,
							"aria-label": "Close lightbox",
							"data-testid": "lightbox-close",
							children: /* @__PURE__ */ H(V, {
								size: 20,
								color: "white"
							})
						})
					]
				})]
			}),
			/* @__PURE__ */ H(M, {
				style: {
					flex: 1,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					overflow: "auto",
					cursor: s > 1 ? "grab" : "default"
				},
				onClick: (e) => {
					e.target === e.currentTarget && r();
				},
				"data-testid": "lightbox-backdrop",
				children: /* @__PURE__ */ H(We, {
					src: _,
					alt: v,
					fit: "contain",
					style: {
						maxHeight: "90vh",
						maxWidth: "90vw",
						transform: `scale(${s})`,
						transition: "transform 0.2s ease"
					},
					onClick: m,
					"data-testid": "lightbox-image"
				})
			}),
			l && /* @__PURE__ */ U(Gn, { children: [/* @__PURE__ */ H(A, {
				variant: "subtle",
				color: "gray",
				size: "xl",
				onClick: f,
				disabled: !u,
				"aria-label": "Previous image",
				style: {
					position: "absolute",
					left: 16,
					top: "50%",
					transform: "translateY(-50%)"
				},
				"data-testid": "lightbox-prev",
				children: /* @__PURE__ */ H(jt, {
					size: 32,
					color: "white"
				})
			}), /* @__PURE__ */ H(A, {
				variant: "subtle",
				color: "gray",
				size: "xl",
				onClick: p,
				disabled: !d,
				"aria-label": "Next image",
				style: {
					position: "absolute",
					right: 16,
					top: "50%",
					transform: "translateY(-50%)"
				},
				"data-testid": "lightbox-next",
				children: /* @__PURE__ */ H(Mt, {
					size: 32,
					color: "white"
				})
			})] })
		]
	});
}
//#endregion
//#region src/components/navigation/LanguageSwitcher/LanguageSwitcher.tsx
var fo = [
	{
		code: "es",
		label: "Español",
		flag: "🇦🇷"
	},
	{
		code: "en",
		label: "English",
		flag: "🇺🇸"
	},
	{
		code: "pt",
		label: "Português",
		flag: "🇧🇷"
	},
	{
		code: "ru",
		label: "Русский",
		flag: "🇷🇺"
	}
];
function po({ languages: e, currentLanguage: t, onLanguageChange: n, variant: r = "icon", size: i = "md", showFlags: a = !0, showFlagInTrigger: o = !1, showLabels: s = !0, tooltip: c = "Change language", menuLabel: l = "Language", disabled: u = !1 }) {
	let d = e.find((e) => e.code === t), f = i === "xs" ? 14 : i === "sm" ? 16 : 20;
	return r === "icon" ? /* @__PURE__ */ U(L, {
		shadow: "md",
		width: 180,
		children: [/* @__PURE__ */ H(L.Target, { children: /* @__PURE__ */ H(dt, {
			label: c,
			disabled: u,
			children: /* @__PURE__ */ H(A, {
				variant: "subtle",
				size: i,
				"aria-label": c,
				disabled: u,
				"data-testid": "language-switcher-button",
				children: o && d?.flag ? /* @__PURE__ */ H("span", {
					style: { fontSize: f },
					children: d.flag
				}) : /* @__PURE__ */ H(cn, { size: f })
			})
		}) }), /* @__PURE__ */ U(L.Dropdown, {
			"data-testid": "language-switcher-dropdown",
			children: [/* @__PURE__ */ H(L.Label, { children: l }), e.map((e) => /* @__PURE__ */ H(L.Item, {
				onClick: () => n(e.code),
				leftSection: a && e.flag ? /* @__PURE__ */ H("span", { children: e.flag }) : void 0,
				fw: t === e.code ? 700 : 400,
				c: t === e.code ? "blue" : void 0,
				"data-testid": `language-option-${e.code}`,
				children: e.label
			}, e.code))]
		})]
	}) : r === "button-group" ? /* @__PURE__ */ H(N.Group, {
		"data-testid": "language-switcher-button-group",
		children: e.map((e) => /* @__PURE__ */ U(N, {
			variant: t === e.code ? "filled" : "default",
			size: i,
			onClick: () => n(e.code),
			disabled: u,
			"data-testid": `language-button-${e.code}`,
			children: [a && e.flag && /* @__PURE__ */ H("span", {
				style: { marginRight: s ? 4 : 0 },
				children: e.flag
			}), s && e.code.toUpperCase()]
		}, e.code))
	}) : /* @__PURE__ */ H(rt, {
		value: t,
		onChange: (e) => e && n(e),
		data: e.map((e) => ({
			value: e.code,
			label: `${a && e.flag ? e.flag + " " : ""}${e.label}`
		})),
		size: i,
		disabled: u,
		"aria-label": c,
		"data-testid": "language-switcher-select"
	});
}
//#endregion
//#region src/components/navigation/ThemeSwitcher/ThemeSwitcher.tsx
function mo({ size: e = "lg", lightModeLabel: t = "Light mode", darkModeLabel: n = "Dark mode", ariaLabel: r = "Toggle color scheme", disabled: i = !1, testId: a = "theme-toggle" }) {
	let { setColorScheme: o } = gt(), s = ht("light", { getInitialValueInEffect: !0 }) === "dark";
	return /* @__PURE__ */ H(dt, {
		label: s ? t : n,
		disabled: i,
		children: /* @__PURE__ */ H(A, {
			variant: "subtle",
			size: e,
			onClick: () => {
				o(s ? "light" : "dark");
			},
			"aria-label": r,
			disabled: i,
			"data-testid": a,
			children: H(s ? Nn : _n, { size: e === "xs" ? 14 : e === "sm" ? 16 : 20 })
		})
	});
}
//#endregion
//#region src/components/navigation/CurrencySwitcher/CurrencySwitcher.tsx
var ho = [
	{
		code: "ARS",
		label: "Peso Argentino",
		symbol: "AR$",
		flag: "🇦🇷"
	},
	{
		code: "USD",
		label: "US Dollar",
		symbol: "$",
		flag: "🇺🇸"
	},
	{
		code: "EUR",
		label: "Euro",
		symbol: "€",
		flag: "🇪🇺"
	},
	{
		code: "BRL",
		label: "Real Brasileiro",
		symbol: "R$",
		flag: "🇧🇷"
	}
];
function go({ currencies: e, currentCurrency: t, onCurrencyChange: n, variant: r = "icon", size: i = "md", showFlags: a = !0, showFlagInTrigger: o = !1, showLabels: s = !0, tooltip: c = "Change currency", menuLabel: l = "Currency", disabled: u = !1 }) {
	let d = e.find((e) => e.code === t), f = i === "xs" ? 14 : i === "sm" ? 16 : 20;
	return r === "icon" ? /* @__PURE__ */ U(L, {
		shadow: "md",
		width: 200,
		children: [/* @__PURE__ */ H(L.Target, { children: /* @__PURE__ */ H(dt, {
			label: c,
			disabled: u,
			children: /* @__PURE__ */ H(A, {
				variant: "subtle",
				size: i,
				"aria-label": c,
				disabled: u,
				"data-testid": "currency-switcher-button",
				children: o && d?.flag ? /* @__PURE__ */ H("span", {
					style: { fontSize: f },
					children: d.flag
				}) : /* @__PURE__ */ H(qt, { size: f })
			})
		}) }), /* @__PURE__ */ U(L.Dropdown, {
			"data-testid": "currency-switcher-dropdown",
			children: [/* @__PURE__ */ H(L.Label, { children: l }), e.map((e) => /* @__PURE__ */ H(L.Item, {
				onClick: () => n(e.code),
				leftSection: a && e.flag ? /* @__PURE__ */ H("span", { children: e.flag }) : void 0,
				rightSection: /* @__PURE__ */ H("span", {
					style: { opacity: .6 },
					children: e.symbol
				}),
				fw: t === e.code ? 700 : 400,
				c: t === e.code ? "blue" : void 0,
				"data-testid": `currency-option-${e.code}`,
				children: e.label
			}, e.code))]
		})]
	}) : r === "button-group" ? /* @__PURE__ */ H(N.Group, {
		"data-testid": "currency-switcher-button-group",
		children: e.map((e) => /* @__PURE__ */ U(N, {
			variant: t === e.code ? "filled" : "default",
			size: i,
			onClick: () => n(e.code),
			disabled: u,
			"data-testid": `currency-button-${e.code}`,
			children: [a && e.flag && /* @__PURE__ */ H("span", {
				style: { marginRight: s ? 4 : 0 },
				children: e.flag
			}), s && e.code]
		}, e.code))
	}) : /* @__PURE__ */ H(rt, {
		value: t,
		onChange: (e) => e && n(e),
		data: e.map((e) => ({
			value: e.code,
			label: `${a && e.flag ? e.flag + " " : ""}${e.label} (${e.symbol})`
		})),
		size: i,
		disabled: u,
		"aria-label": c,
		"data-testid": "currency-switcher-select"
	});
}
//#endregion
//#region src/components/layout/Header/HeaderLayout.tsx
var _o = Qn(null);
function vo() {
	let e = nr(_o);
	if (!e) throw Error("useHeaderLayout must be used within a HeaderLayout");
	return e;
}
function yo({ children: e }) {
	return /* @__PURE__ */ H(M, {
		style: { flex: "0 0 auto" },
		"data-slot": "logo",
		children: e
	});
}
function bo({ children: e, visibleFrom: t }) {
	return /* @__PURE__ */ H(I, {
		flex: 1,
		justify: "center",
		align: "center",
		visibleFrom: t,
		"data-slot": "center",
		children: e
	});
}
function xo({ children: e, gap: t = "sm" }) {
	return /* @__PURE__ */ H(I, {
		gap: t,
		align: "center",
		wrap: "nowrap",
		"data-slot": "actions",
		children: e
	});
}
function So({ children: e, height: t = 70, px: n = "md", testId: r }) {
	return /* @__PURE__ */ H(_o.Provider, {
		value: { height: t },
		children: /* @__PURE__ */ H(I, {
			h: t,
			px: n,
			justify: "space-between",
			align: "center",
			wrap: "nowrap",
			"data-testid": r,
			children: e
		})
	});
}
var Co = So;
Co.Logo = yo, Co.Center = bo, Co.Actions = xo;
//#endregion
//#region src/components/layout/Header/HeaderDivider.tsx
function wo({ visibleFrom: e, color: t, height: n = 36, testId: r }) {
	return /* @__PURE__ */ H(M, {
		visibleFrom: e,
		display: "flex",
		style: { alignItems: "center" },
		"data-testid": r,
		children: /* @__PURE__ */ H(Be, {
			orientation: "vertical",
			h: n,
			color: t
		})
	});
}
//#endregion
//#region src/components/layout/Header/HeaderNavButton.tsx
function To({ icon: e, label: t, to: n, href: r, onClick: i, external: a = !1, badge: o, badgeColor: s, size: c = "lg", variant: l = "subtle", color: u, disabled: d = !1, visibleFrom: f, testId: p }) {
	let m = {
		variant: l,
		size: c,
		color: u,
		disabled: d,
		"aria-label": t,
		"data-testid": p
	}, h = /* @__PURE__ */ H(e, {
		size: 20,
		stroke: 1.5
	}), g;
	g = n ? /* @__PURE__ */ H(dt, {
		label: t,
		children: /* @__PURE__ */ H(A, {
			component: vr,
			to: n,
			...m,
			children: h
		})
	}) : r ? /* @__PURE__ */ H(dt, {
		label: t,
		children: /* @__PURE__ */ H(A, {
			component: "a",
			href: r,
			...a && {
				target: "_blank",
				rel: "noopener noreferrer"
			},
			...m,
			children: h
		})
	}) : /* @__PURE__ */ H(dt, {
		label: t,
		children: /* @__PURE__ */ H(A, {
			onClick: i,
			...m,
			children: h
		})
	});
	let _ = o !== void 0 && o !== 0 && o !== "0" ? /* @__PURE__ */ H(Ge, {
		label: o,
		size: 16,
		offset: 4,
		color: s,
		children: g
	}) : g;
	return f ? /* @__PURE__ */ H(M, {
		visibleFrom: f,
		"data-testid": p ? `${p}-wrapper` : void 0,
		children: _
	}) : _;
}
//#endregion
//#region src/components/layout/Header/HeaderPreferences.tsx
function Eo({ languages: e = fo, currentLanguage: t, onLanguageChange: n, currencies: r = ho, currentCurrency: i, onCurrencyChange: a, showTheme: o = !0, showLanguage: s = !0, showCurrency: c = !0, size: l = "lg", themeLabels: u, languageTooltip: d, currencyTooltip: f, testId: p }) {
	return !o && !s && !c ? null : /* @__PURE__ */ U(I, {
		gap: "xs",
		wrap: "nowrap",
		"data-testid": p,
		children: [
			o && /* @__PURE__ */ H(mo, {
				size: l,
				lightModeLabel: u?.light,
				darkModeLabel: u?.dark,
				testId: p ? `${p}-theme` : void 0
			}),
			s && /* @__PURE__ */ H(po, {
				languages: e,
				currentLanguage: t,
				onLanguageChange: n,
				variant: "icon",
				size: l,
				tooltip: d,
				menuLabel: d
			}),
			c && /* @__PURE__ */ H(go, {
				currencies: r,
				currentCurrency: i,
				onCurrencyChange: a,
				variant: "icon",
				size: l,
				tooltip: f,
				menuLabel: f
			})
		]
	});
}
var Do = { avatar: "_avatar_1invm_8" };
//#endregion
//#region src/components/layout/Header/HeaderUserSection.tsx
function Oo({ user: e, profileHref: t = "/profile", openProfileInNewTab: n = !1, onLogout: r, isLoggingOut: i, showNameOnDesktop: a = !0, size: o = "sm", profileTooltip: s = "Profile", logoutTooltip: c = "Logout", logoutConfirmTitle: l = "Confirm Logout", logoutConfirmMessage: u = "Are you sure you want to logout?", cancelLabel: d = "Cancel", confirmLabel: f = "Logout", testId: p }) {
	let [m, { open: h, close: g }] = lr(!1), [_, v] = Y(!1), y = e?.name || e?.email?.split("@")[0] || "", b = G(async () => {
		v(!0);
		try {
			await r(), g();
		} catch {} finally {
			v(!1);
		}
	}, [r, g]), x = i ?? _;
	if (!e) return null;
	let S = /* @__PURE__ */ U(I, {
		gap: "xs",
		wrap: "nowrap",
		children: [/* @__PURE__ */ H(yr, {
			name: y,
			src: e.avatarUrl,
			size: o,
			className: Do.avatar
		}), a && /* @__PURE__ */ H(B, {
			size: "sm",
			fw: 500,
			visibleFrom: "sm",
			children: y
		})]
	});
	return /* @__PURE__ */ U(Gn, { children: [/* @__PURE__ */ U(I, {
		gap: "xs",
		"data-testid": p,
		children: [/* @__PURE__ */ H(dt, {
			label: s,
			children: n ? /* @__PURE__ */ H(ft, {
				component: "a",
				href: t,
				target: "_blank",
				rel: "noopener noreferrer",
				"data-testid": p ? `${p}-profile` : void 0,
				children: S
			}) : /* @__PURE__ */ H(ft, {
				component: vr,
				to: t,
				"data-testid": p ? `${p}-profile` : void 0,
				children: S
			})
		}), /* @__PURE__ */ H(dt, {
			label: c,
			children: /* @__PURE__ */ H(A, {
				variant: "subtle",
				size: "lg",
				color: "red",
				onClick: h,
				"aria-label": c,
				"data-testid": p ? `${p}-logout` : void 0,
				children: /* @__PURE__ */ H(dn, {
					size: 20,
					stroke: 1.5
				})
			})
		})]
	}), /* @__PURE__ */ H(qe, {
		opened: m,
		onClose: g,
		title: l,
		centered: !0,
		size: "sm",
		children: /* @__PURE__ */ U(z, {
			gap: "md",
			children: [/* @__PURE__ */ H(B, {
				size: "sm",
				children: u
			}), /* @__PURE__ */ U(I, {
				justify: "flex-end",
				gap: "sm",
				children: [/* @__PURE__ */ H(N, {
					variant: "default",
					onClick: g,
					disabled: x,
					children: d
				}), /* @__PURE__ */ H(N, {
					color: "red",
					onClick: b,
					loading: x,
					children: f
				})]
			})]
		})
	})] });
}
var ko = {
	root: "_root_qfjjx_3",
	dot: "_dot_qfjjx_8",
	personal: "_personal_qfjjx_20",
	shops: "_shops_qfjjx_26"
};
//#endregion
//#region src/components/layout/Header/MessagesHeaderButton.tsx
function Ao({ unreadCount: e = 0, unreadDots: t, to: n, href: r, onClick: i, label: a = "Messages", testId: o = "messages-btn" }) {
	let s = /* @__PURE__ */ H(To, {
		icon: mn,
		label: a,
		to: n,
		href: r,
		onClick: i,
		external: !!r,
		badge: t ? void 0 : e,
		badgeColor: "#228be6",
		testId: o
	});
	return t ? /* @__PURE__ */ U(M, {
		className: ko.root,
		children: [
			s,
			t.personal && /* @__PURE__ */ H("span", {
				className: `${ko.dot} ${ko.personal}`,
				"aria-hidden": "true",
				"data-testid": `${o}-dot-personal`
			}),
			t.shops && /* @__PURE__ */ H("span", {
				className: `${ko.dot} ${ko.shops}`,
				"aria-hidden": "true",
				"data-testid": `${o}-dot-shops`
			})
		]
	}) : s;
}
var jo = { card: "_card_1s6ng_2" }, Mo = {
	addToCart: "Agregar al carrito",
	goToStore: "Ir a la tienda",
	outOfStock: "Sin stock"
}, No = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ctext font-size='40' text-anchor='middle' dominant-baseline='central' x='50' y='50'%3E📦%3C/text%3E%3C/svg%3E";
function Po({ rating: e, count: t, testId: n, iconSize: r = 14 }) {
	return /* @__PURE__ */ U(I, {
		gap: 2,
		wrap: "nowrap",
		"data-testid": n,
		children: [
			/* @__PURE__ */ H(Mn, {
				size: r,
				style: {
					fill: "var(--mantine-color-yellow-6)",
					color: "var(--mantine-color-yellow-6)"
				}
			}),
			/* @__PURE__ */ H(B, {
				size: "xs",
				fw: 500,
				children: e.toFixed(1)
			}),
			/* @__PURE__ */ U(B, {
				size: "xs",
				c: "dimmed",
				children: [
					"(",
					t,
					")"
				]
			})
		]
	});
}
function Fo({ product: e, variant: t = "storefront", onAction: n, onAddToCart: r, addToCartLoading: i = !1, onClick: a, wishlistSlot: o, showMerchantInfo: s = !0, showCategory: c = !0, stockDisplayMode: l = "status", labels: u, "data-testid": d = "product-card", displayCurrency: f, exchangeRate: p }) {
	let m = {
		...Mo,
		...u
	}, h = t === "marketplace", g = e.stockStatus === "out_of_stock", _ = h && !!r, v = e.averageRating != null && (e.totalReviews ?? 0) > 0, y = e.merchantRating != null && (e.merchantTotalReviews ?? 0) > 0, b = e.images[0]?.url || No, x = e.gpc_brick_name ? e.brandName ? `${e.brandName} - ${e.gpc_brick_name}` : e.gpc_brick_name : [e.brandName, e.categoryName].filter(Boolean).join(" - "), S = () => {
		a && a(e);
	}, C = (t) => {
		t.stopPropagation(), n && n(e);
	}, ee = (t) => {
		t.stopPropagation(), r && r(e);
	}, te = h ? {
		label: m.goToStore,
		icon: /* @__PURE__ */ H(Tt, { size: 16 }),
		color: "blue"
	} : {
		label: m.addToCart,
		icon: /* @__PURE__ */ H(jn, { size: 16 }),
		color: "blue"
	};
	return /* @__PURE__ */ U(P, {
		shadow: "sm",
		padding: "lg",
		radius: "md",
		withBorder: !0,
		h: "100%",
		className: jo.card,
		style: {
			display: "flex",
			flexDirection: "column",
			cursor: a ? "pointer" : void 0
		},
		onClick: S,
		"data-testid": d,
		children: [
			/* @__PURE__ */ U(P.Section, {
				pos: "relative",
				children: [/* @__PURE__ */ H(je, {
					ratio: 1,
					bg: "gray.1",
					children: /* @__PURE__ */ H(We, {
						src: b,
						alt: e.name,
						fit: "contain",
						fallbackSrc: No,
						"data-testid": "product-card-image"
					})
				}), o && /* @__PURE__ */ H(M, {
					pos: "absolute",
					top: 8,
					right: 8,
					onClick: (e) => e.stopPropagation(),
					"data-testid": "product-card-wishlist-slot",
					children: o
				})]
			}),
			/* @__PURE__ */ U(z, {
				gap: "xs",
				style: { flex: 1 },
				mt: "md",
				children: [
					/* @__PURE__ */ U(I, {
						justify: "space-between",
						align: "flex-start",
						wrap: "nowrap",
						gap: "xs",
						children: [/* @__PURE__ */ H(B, {
							fw: 500,
							lineClamp: 2,
							"data-testid": "product-card-name",
							style: {
								flex: 1,
								minWidth: 0
							},
							children: e.name
						}), v && /* @__PURE__ */ H(M, {
							style: { flexShrink: 0 },
							children: /* @__PURE__ */ H(Po, {
								rating: e.averageRating,
								count: e.totalReviews,
								testId: "product-card-rating"
							})
						})]
					}),
					c && x && /* @__PURE__ */ H(B, {
						size: "sm",
						c: "dimmed",
						lineClamp: 1,
						"data-testid": "product-card-category",
						children: x
					}),
					/* @__PURE__ */ U(z, {
						gap: 4,
						mt: "auto",
						children: [/* @__PURE__ */ U(I, {
							gap: "xs",
							align: "baseline",
							wrap: "nowrap",
							children: [/* @__PURE__ */ H(fa, {
								price: e.price,
								compareAtPrice: e.compareAtPrice,
								currency: e.currency,
								layout: "vertical",
								size: "md",
								"data-testid": "product-card-price",
								displayCurrency: f,
								exchangeRate: p ?? void 0
							}), e.sellingUnit && /* @__PURE__ */ U(B, {
								size: "xs",
								c: "dimmed",
								"data-testid": "product-card-unit",
								children: ["/ ", e.sellingUnit]
							})]
						}), /* @__PURE__ */ H(ya, {
							status: e.stockStatus,
							displayMode: l,
							quantity: e.stockQuantity,
							variant: "text",
							size: "xs"
						})]
					}),
					h && s && e.merchantName && /* @__PURE__ */ U(I, {
						gap: "xs",
						mt: "xs",
						"data-testid": "product-card-merchant",
						children: [
							/* @__PURE__ */ H(B, {
								size: "sm",
								c: "blue",
								children: e.merchantName
							}),
							y && /* @__PURE__ */ H(Po, {
								rating: e.merchantRating,
								count: e.merchantTotalReviews,
								testId: "seller-rating",
								iconSize: 12
							}),
							e.merchantLocation && /* @__PURE__ */ H(B, {
								size: "xs",
								c: "dimmed",
								children: e.merchantLocation
							})
						]
					})
				]
			}),
			_ ? /* @__PURE__ */ U(z, {
				gap: "xs",
				mt: "md",
				children: [/* @__PURE__ */ H(N, {
					fullWidth: !0,
					radius: "md",
					color: "blue",
					disabled: g,
					loading: i,
					leftSection: /* @__PURE__ */ H(jn, { size: 16 }),
					onClick: ee,
					"data-testid": "add-to-cart-button",
					children: g ? m.outOfStock : m.addToCart
				}), /* @__PURE__ */ H(N, {
					fullWidth: !0,
					radius: "md",
					variant: "light",
					color: "blue",
					leftSection: /* @__PURE__ */ H(Tt, { size: 16 }),
					onClick: C,
					"data-testid": "go-to-store-button",
					children: m.goToStore
				})]
			}) : /* @__PURE__ */ H(N, {
				fullWidth: !0,
				mt: "md",
				radius: "md",
				color: te.color,
				disabled: g && t === "storefront",
				leftSection: te.icon,
				onClick: C,
				"data-testid": "product-card-cta",
				children: g && t === "storefront" ? m.outOfStock : te.label
			})
		]
	});
}
//#endregion
//#region src/components/commerce/WishlistButton/WishlistButton.tsx
var Io = {
	sm: {
		button: "sm",
		icon: 16
	},
	md: {
		button: "md",
		icon: 20
	},
	lg: {
		button: "lg",
		icon: 24
	}
}, Lo = {
	add: "Agregar a favoritos",
	remove: "Quitar de favoritos"
};
function Ro({ productId: e, isInWishlist: t, isLoading: n = !1, size: r = "md", onToggle: i, labels: a, "data-testid": o = "wishlist-button" }) {
	let [s, c] = Y(!1), l = J(null);
	K(() => () => {
		l.current && clearTimeout(l.current);
	}, []);
	let u = {
		...Lo,
		...a
	}, d = Io[r], f = t ? u.remove : u.add, p = G((n) => {
		n.preventDefault(), n.stopPropagation(), t || (c(!0), l.current && clearTimeout(l.current), l.current = setTimeout(() => c(!1), 300)), i(e);
	}, [
		t,
		i,
		e
	]);
	return /* @__PURE__ */ H(dt, {
		label: f,
		withArrow: !0,
		position: "top",
		children: /* @__PURE__ */ H(A, {
			variant: t ? "filled" : "default",
			color: t ? "red" : "gray",
			size: d.button,
			radius: "xl",
			onClick: p,
			loading: n,
			"aria-label": f,
			className: s ? "heart-beat" : void 0,
			"data-testid": o,
			"data-in-wishlist": t,
			"data-size": r,
			children: t ? /* @__PURE__ */ H(rn, {
				size: d.icon,
				"data-testid": `${o}-heart-filled`
			}) : /* @__PURE__ */ H(nn, {
				size: d.icon,
				"data-testid": `${o}-heart-outline`
			})
		})
	});
}
//#endregion
//#region src/components/commerce/MultiCartDrawer/MerchantCartCard.tsx
var zo = 3, Bo = {
	viewCart: "Ver carrito",
	checkout: "Pagar",
	unavailable: "No disponible",
	items: "productos"
};
function Vo({ merchant: e, onViewCart: t, onCheckout: n, formatPrice: r, labels: i, "data-testid": a = "merchant-cart-card" }) {
	let o = {
		...Bo,
		...i
	}, s = (e, t) => r ? r(e, t) : `${t} ${e.toLocaleString("es-AR", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	})}`, c = e.status === "unavailable";
	return /* @__PURE__ */ U(P, {
		withBorder: !0,
		p: "md",
		radius: "md",
		opacity: c ? .6 : 1,
		"data-testid": a,
		children: [
			/* @__PURE__ */ U(I, {
				justify: "space-between",
				mb: "sm",
				children: [/* @__PURE__ */ U(I, {
					gap: "sm",
					children: [/* @__PURE__ */ H(Me, {
						src: e.merchantLogo,
						alt: e.merchantName,
						radius: "sm",
						size: "md",
						"data-testid": "merchant-cart-card-logo",
						children: e.merchantName.charAt(0).toUpperCase()
					}), /* @__PURE__ */ U(z, {
						gap: 0,
						children: [/* @__PURE__ */ H(B, {
							fw: 500,
							size: "sm",
							"data-testid": "merchant-cart-card-name",
							children: e.merchantName
						}), /* @__PURE__ */ U(B, {
							size: "xs",
							c: "dimmed",
							"data-testid": "merchant-cart-card-items",
							children: [
								e.itemCount,
								" ",
								o.items
							]
						})]
					})]
				}), c && /* @__PURE__ */ H(j, {
					color: "red",
					variant: "light",
					"data-testid": "merchant-cart-card-unavailable",
					children: o.unavailable
				})]
			}),
			!c && e.items && e.items.length > 0 && /* @__PURE__ */ U(z, {
				gap: 4,
				"data-testid": "merchant-cart-card-items-list",
				children: [e.items.slice(0, zo).map((e) => /* @__PURE__ */ U(I, {
					gap: "xs",
					wrap: "nowrap",
					children: [
						/* @__PURE__ */ H(Me, {
							src: e.imageUrl,
							alt: e.productName,
							size: "sm",
							radius: "sm",
							children: e.productName.charAt(0).toUpperCase()
						}),
						/* @__PURE__ */ H(B, {
							size: "xs",
							lineClamp: 1,
							style: { flex: 1 },
							children: e.productName
						}),
						/* @__PURE__ */ U(B, {
							size: "xs",
							c: "dimmed",
							style: { whiteSpace: "nowrap" },
							children: [
								e.quantity,
								" × ",
								s(e.unitPrice, e.currency)
							]
						})
					]
				}, e.productGuid)), e.items.length > zo && /* @__PURE__ */ U(B, {
					size: "xs",
					c: "dimmed",
					ta: "center",
					"data-testid": "merchant-cart-card-more-items",
					children: [
						"+",
						e.items.length - zo,
						" more"
					]
				})]
			}),
			/* @__PURE__ */ U(I, {
				justify: "space-between",
				mt: "md",
				children: [/* @__PURE__ */ H(B, {
					fw: 600,
					size: "md",
					"data-testid": "merchant-cart-card-subtotal",
					children: s(e.subtotal, e.currency)
				}), /* @__PURE__ */ U(I, {
					gap: "xs",
					children: [/* @__PURE__ */ H(N, {
						variant: "light",
						size: "xs",
						leftSection: /* @__PURE__ */ H(jn, { size: 14 }),
						onClick: () => {
							t && t(e);
						},
						disabled: c,
						"data-testid": "merchant-cart-card-view-btn",
						children: o.viewCart
					}), /* @__PURE__ */ H(N, {
						size: "xs",
						leftSection: /* @__PURE__ */ H(Gt, { size: 14 }),
						onClick: () => {
							n && n(e);
						},
						disabled: c,
						"data-testid": "merchant-cart-card-checkout-btn",
						children: o.checkout
					})]
				})]
			})
		]
	});
}
//#endregion
//#region src/components/commerce/MultiCartDrawer/EmptyCartState.tsx
var Ho = {
	title: "Tus carritos estan vacios",
	description: "Explora tiendas y agrega productos a tu carrito",
	browseStores: "Explorar tiendas"
};
function Uo({ onBrowseStores: e, labels: t, "data-testid": n = "empty-cart-state" }) {
	let r = {
		...Ho,
		...t
	};
	return /* @__PURE__ */ H(Pe, {
		h: "100%",
		py: "xl",
		"data-testid": n,
		children: /* @__PURE__ */ U(z, {
			align: "center",
			gap: "md",
			children: [
				/* @__PURE__ */ H(ct, {
					size: 64,
					variant: "light",
					color: "gray",
					radius: "xl",
					"data-testid": "empty-cart-state-icon",
					children: /* @__PURE__ */ H(jn, { size: 32 })
				}),
				/* @__PURE__ */ H(B, {
					size: "lg",
					fw: 500,
					c: "dimmed",
					ta: "center",
					"data-testid": "empty-cart-state-title",
					children: r.title
				}),
				/* @__PURE__ */ H(B, {
					size: "sm",
					c: "dimmed",
					ta: "center",
					"data-testid": "empty-cart-state-description",
					children: r.description
				}),
				e && /* @__PURE__ */ H(N, {
					variant: "filled",
					onClick: e,
					"data-testid": "empty-cart-state-action",
					children: r.browseStores
				})
			]
		})
	});
}
//#endregion
//#region src/components/commerce/MultiCartDrawer/MultiCartDrawer.tsx
var Wo = {
	title: "Mis carritos",
	itemsAcrossStores: "productos en {stores} tiendas",
	total: "Total",
	errorTitle: "Error",
	errorMessage: "No se pudieron cargar los carritos",
	viewAll: "Ver todos los carritos"
};
function Go() {
	return /* @__PURE__ */ U(z, {
		gap: "md",
		"data-testid": "multi-cart-drawer-loading",
		children: [
			/* @__PURE__ */ H(R, {
				height: 100,
				radius: "md"
			}),
			/* @__PURE__ */ H(R, {
				height: 100,
				radius: "md"
			}),
			/* @__PURE__ */ H(R, {
				height: 100,
				radius: "md"
			})
		]
	});
}
function Ko({ labels: e }) {
	return /* @__PURE__ */ H(ke, {
		icon: /* @__PURE__ */ H(vt, { size: 16 }),
		color: "red",
		title: e.errorTitle,
		"data-testid": "multi-cart-drawer-error",
		children: e.errorMessage
	});
}
function qo({ totalItems: e, totalAmount: t, currency: n, storeCount: r, labels: i, formatPrice: a, onViewAll: o }) {
	let s = i.itemsAcrossStores.replace("{stores}", String(r)), c = a ? a(t, n) : `${n} ${t.toLocaleString("es-AR", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	})}`;
	return /* @__PURE__ */ U(z, {
		gap: "xs",
		"data-testid": "multi-cart-drawer-footer",
		children: [
			/* @__PURE__ */ H(Be, {}),
			/* @__PURE__ */ U(I, {
				justify: "space-between",
				py: "xs",
				children: [/* @__PURE__ */ U(B, {
					size: "sm",
					c: "dimmed",
					"data-testid": "multi-cart-drawer-summary",
					children: [
						e,
						" ",
						s
					]
				}), /* @__PURE__ */ U(B, {
					size: "lg",
					fw: 700,
					"data-testid": "multi-cart-drawer-total",
					children: [
						i.total,
						": ",
						c
					]
				})]
			}),
			o && /* @__PURE__ */ H(N, {
				variant: "subtle",
				fullWidth: !0,
				rightSection: /* @__PURE__ */ H(xt, { size: 16 }),
				onClick: o,
				"data-testid": "multi-cart-drawer-view-all",
				children: i.viewAll
			})
		]
	});
}
function Jo({ open: e, onClose: t, carts: n, isLoading: r = !1, error: i = null, totalItems: a, totalAmount: o, currency: s = "ARS", onViewCart: c, onCheckout: l, onBrowseStores: u, onViewAll: d, formatPrice: f, labels: p, cardLabels: m, emptyLabels: h, "data-testid": g = "multi-cart-drawer" }) {
	let _ = {
		...Wo,
		...p
	}, v = (e) => {
		c ? c(e) : window.open(e.cartUrl, "_blank");
	}, y = (e) => {
		l ? l(e) : window.open(e.checkoutUrl, "_blank");
	}, b = () => {
		u ? u() : (t(), window.location.href = "/merchants");
	}, x = () => {
		d && (t(), d());
	}, S = a ?? n.reduce((e, t) => e + t.itemCount, 0), C = o ?? n.reduce((e, t) => e + t.convertedSubtotal, 0);
	return /* @__PURE__ */ H(Ve, {
		opened: e,
		onClose: t,
		title: _.title,
		position: "right",
		size: "md",
		padding: "md",
		"data-testid": g,
		children: r ? /* @__PURE__ */ H(Go, {}) : i ? /* @__PURE__ */ H(Ko, { labels: _ }) : n.length === 0 ? /* @__PURE__ */ H(Uo, {
			onBrowseStores: b,
			labels: h
		}) : /* @__PURE__ */ U(z, {
			h: "100%",
			gap: 0,
			children: [/* @__PURE__ */ H(tt, {
				flex: 1,
				offsetScrollbars: !0,
				"data-testid": "multi-cart-drawer-scroll",
				children: /* @__PURE__ */ H(z, {
					gap: "md",
					children: n.map((e) => /* @__PURE__ */ H(Vo, {
						merchant: e,
						onViewCart: v,
						onCheckout: y,
						formatPrice: f,
						labels: m
					}, e.merchantGuid))
				})
			}), C > 0 && /* @__PURE__ */ H(qo, {
				totalItems: S,
				totalAmount: C,
				currency: s,
				storeCount: n.length,
				labels: _,
				formatPrice: f,
				onViewAll: d ? x : void 0
			})]
		})
	});
}
//#endregion
//#region src/components/commerce/FavoritesDrawer/FavoritesDrawerItem.tsx
var Yo = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ctext font-size='40' text-anchor='middle' dominant-baseline='central' x='50' y='50'%3E📦%3C/text%3E%3C/svg%3E";
function Xo({ image: e, name: t, subtitle: n, price: r, currency: i, productUrl: a, onRemove: o, onAddToCart: s, isLoading: c = !1, testId: l = "favorites-drawer-item", displayCurrency: u, exchangeRate: d }) {
	let f = () => {
		window.location.href = a;
	};
	return /* @__PURE__ */ U(I, {
		gap: "md",
		wrap: "nowrap",
		align: "flex-start",
		className: "favorites-drawer-item",
		"data-testid": l,
		children: [/* @__PURE__ */ H(ft, {
			onClick: f,
			"data-testid": `${l}-link`,
			children: /* @__PURE__ */ H(We, {
				src: re(e, "thumb"),
				alt: t,
				w: 60,
				h: 60,
				radius: "sm",
				fallbackSrc: Yo,
				"data-testid": `${l}-image`
			})
		}), /* @__PURE__ */ U(z, {
			gap: 4,
			style: {
				flex: 1,
				minWidth: 0
			},
			children: [
				/* @__PURE__ */ H(ft, {
					onClick: f,
					className: "favorites-drawer-item__name-link",
					children: /* @__PURE__ */ H(B, {
						fw: 500,
						lineClamp: 1,
						size: "sm",
						"data-testid": `${l}-name`,
						children: t
					})
				}),
				n && /* @__PURE__ */ H(B, {
					size: "xs",
					c: "dimmed",
					lineClamp: 1,
					"data-testid": `${l}-subtitle`,
					children: n
				}),
				/* @__PURE__ */ U(I, {
					justify: "space-between",
					mt: 4,
					children: [/* @__PURE__ */ H(fa, {
						price: r,
						currency: i,
						displayCurrency: u,
						exchangeRate: d,
						size: "sm",
						showOriginalPrice: u != null && u !== i,
						showDiscountBadge: !1,
						"data-testid": `${l}-price`
					}), /* @__PURE__ */ U(I, {
						gap: "xs",
						children: [s && /* @__PURE__ */ H(A, {
							variant: "subtle",
							color: "blue",
							size: "sm",
							onClick: s,
							disabled: c,
							"aria-label": "Add to cart",
							"data-testid": `${l}-add-to-cart`,
							children: /* @__PURE__ */ H(jn, { size: 16 })
						}), /* @__PURE__ */ H(A, {
							variant: "subtle",
							color: "red",
							size: "sm",
							onClick: o,
							disabled: c,
							"aria-label": "Remove from favorites",
							"data-testid": `${l}-remove`,
							children: /* @__PURE__ */ H(Fn, { size: 16 })
						})]
					})]
				})
			]
		})]
	});
}
//#endregion
//#region src/components/commerce/MerchantCard/MerchantCardLayout.tsx
function Zo(e) {
	let t = e || "#228be6";
	return `linear-gradient(135deg, ${t}, ${t}99)`;
}
function Qo({ businessName: e, merchantType: t, description: n, address: r, businessHours: i, isOpen: a, bannerUrl: o, logoUrl: s, primaryColor: c, ratingSlot: l, actionsSlot: u, footerSlot: d, compact: f, onCoverClick: p, merchantTypeLabel: m, openLabel: h, closedLabel: g, statusSlot: _ }) {
	return /* @__PURE__ */ U(P, {
		shadow: "sm",
		padding: "lg",
		radius: "md",
		withBorder: !0,
		h: "100%",
		style: {
			display: "flex",
			flexDirection: "column",
			background: "var(--mantine-color-body)"
		},
		children: [/* @__PURE__ */ U(P.Section, {
			pos: "relative",
			children: [
				o ? /* @__PURE__ */ H(We, {
					src: o,
					height: 120,
					alt: e,
					fallbackSrc: void 0,
					style: {
						cursor: p ? "pointer" : void 0,
						objectFit: "cover"
					},
					onClick: p
				}) : /* @__PURE__ */ H(M, {
					h: 120,
					style: {
						background: Zo(c),
						cursor: p ? "pointer" : void 0
					},
					onClick: p
				}),
				u && /* @__PURE__ */ H(I, {
					gap: "xs",
					style: {
						position: "absolute",
						top: 8,
						right: 8
					},
					children: u
				}),
				/* @__PURE__ */ H(Me, {
					src: s,
					alt: e,
					size: 48,
					radius: "xl",
					style: {
						position: "absolute",
						bottom: -24,
						left: 12,
						border: "3px solid var(--mantine-color-body)"
					},
					children: e.charAt(0).toUpperCase()
				})
			]
		}), /* @__PURE__ */ U("div", {
			style: {
				flex: 1,
				display: "flex",
				flexDirection: "column",
				paddingTop: 28
			},
			children: [
				/* @__PURE__ */ U(I, {
					justify: "space-between",
					mb: "xs",
					wrap: "nowrap",
					children: [/* @__PURE__ */ H(B, {
						fw: 600,
						size: "lg",
						lineClamp: 1,
						style: { flex: 1 },
						children: e
					}), /* @__PURE__ */ U(I, {
						gap: 4,
						wrap: "nowrap",
						children: [
							/* @__PURE__ */ H(j, {
								variant: "light",
								size: "sm",
								children: m || t
							}),
							_,
							a != null && /* @__PURE__ */ H(j, {
								color: a ? "green" : "red",
								variant: "filled",
								size: "xs",
								children: a ? h || "Open" : g || "Closed"
							})
						]
					})]
				}),
				n && /* @__PURE__ */ H(B, {
					size: "sm",
					c: "dimmed",
					lineClamp: 2,
					mb: "xs",
					children: n
				}),
				/* @__PURE__ */ U(z, {
					gap: "xs",
					mb: "md",
					children: [
						l,
						r && /* @__PURE__ */ U(I, {
							gap: 4,
							children: [/* @__PURE__ */ H(fn, { size: 14 }), /* @__PURE__ */ H(B, {
								size: "sm",
								c: "dimmed",
								lineClamp: 1,
								children: r
							})]
						}),
						i && i.length > 0 && /* @__PURE__ */ H(z, {
							gap: 2,
							children: i.map((e, t) => /* @__PURE__ */ U(I, {
								gap: 4,
								wrap: "nowrap",
								children: [t === 0 ? /* @__PURE__ */ H(Lt, {
									size: 14,
									style: { flexShrink: 0 }
								}) : /* @__PURE__ */ H(M, {
									w: 14,
									style: { flexShrink: 0 }
								}), /* @__PURE__ */ H(B, {
									size: "sm",
									c: "dimmed",
									children: e
								})]
							}, t))
						})
					]
				}),
				!f && d && /* @__PURE__ */ H("div", {
					style: { marginTop: "auto" },
					children: d
				})
			]
		})]
	});
}
//#endregion
//#region src/components/commerce/MerchantCard/MerchantCardSkeleton.tsx
function $o() {
	return /* @__PURE__ */ U(P, {
		shadow: "sm",
		padding: "lg",
		radius: "md",
		withBorder: !0,
		children: [
			/* @__PURE__ */ H(P.Section, { children: /* @__PURE__ */ H(R, { height: 120 }) }),
			/* @__PURE__ */ U(I, {
				mt: 30,
				mb: "xs",
				children: [/* @__PURE__ */ H(R, {
					height: 48,
					width: 48,
					circle: !0
				}), /* @__PURE__ */ U(z, {
					gap: 4,
					style: { flex: 1 },
					children: [/* @__PURE__ */ H(R, {
						height: 18,
						width: "70%"
					}), /* @__PURE__ */ H(R, {
						height: 14,
						width: "40%"
					})]
				})]
			}),
			/* @__PURE__ */ H(R, {
				height: 14,
				mt: 6
			}),
			/* @__PURE__ */ H(R, {
				height: 14,
				mt: 6,
				width: "60%"
			}),
			/* @__PURE__ */ H(I, {
				justify: "flex-end",
				mt: "md",
				children: /* @__PURE__ */ H(R, {
					height: 36,
					width: 120
				})
			})
		]
	});
}
//#endregion
//#region src/components/chat/MessageStatus.tsx
var es = 14;
function ts({ status: e, onRetry: t, size: n = es }) {
	switch (e) {
		case "sending": return /* @__PURE__ */ H(Ke, {
			size: n,
			type: "dots"
		});
		case "sent": return /* @__PURE__ */ H(Dt, {
			size: n,
			style: { color: "var(--mantine-color-dimmed)" }
		});
		case "read": return /* @__PURE__ */ H(Ot, {
			size: n,
			style: { color: "var(--mantine-color-blue-filled)" }
		});
		case "failed": return t ? /* @__PURE__ */ H(A, {
			variant: "transparent",
			size: n + 4,
			color: "red",
			onClick: t,
			"aria-label": "Retry",
			children: /* @__PURE__ */ H(vt, { size: n })
		}) : /* @__PURE__ */ H(vt, {
			size: n,
			style: { color: "var(--mantine-color-red-filled)" }
		});
		default: return null;
	}
}
//#endregion
//#region src/components/chat/ChatAttachmentContext.tsx
var ns = Qn(null);
function rs({ fetchBlob: e, children: t }) {
	return /* @__PURE__ */ H(ns.Provider, {
		value: e,
		children: t
	});
}
function is() {
	return nr(ns);
}
//#endregion
//#region src/components/chat/ImageThumbnail.tsx
function as({ attachment: e }) {
	let [t, n] = Y(null), [r, i] = Y(!1), [a, o] = Y(!1), s = is(), c = J(null);
	return K(() => {
		let t = !1;
		return c.current &&= (URL.revokeObjectURL(c.current), null), n(null), i(!1), o(!1), s ? s(e.url).then((e) => {
			if (!t) {
				let t = URL.createObjectURL(e);
				c.current = t, n(t);
			}
		}).catch(() => {
			t || o(!0);
		}) : n(e.url), () => {
			t = !0, c.current &&= (URL.revokeObjectURL(c.current), null);
		};
	}, [e.url, s]), a ? /* @__PURE__ */ H(M, {
		style: {
			width: 120,
			height: 80,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			background: "var(--mantine-color-default)",
			borderRadius: "var(--mantine-radius-sm)"
		},
		children: /* @__PURE__ */ H(bn, {
			size: 32,
			color: "var(--mantine-color-dimmed)"
		})
	}) : /* @__PURE__ */ U(M, {
		style: {
			position: "relative",
			cursor: "pointer"
		},
		children: [!r && /* @__PURE__ */ H(R, {
			width: 200,
			height: 200,
			radius: "sm"
		}), t && /* @__PURE__ */ H("img", {
			src: t,
			alt: e.filename,
			onLoad: () => i(!0),
			onError: () => o(!0),
			onClick: () => {
				t && window.open(t, "_blank");
			},
			style: {
				display: r ? "block" : "none",
				maxWidth: 300,
				maxHeight: 200,
				objectFit: "contain",
				borderRadius: "var(--mantine-radius-sm)"
			}
		})]
	});
}
//#endregion
//#region src/components/chat/AttachmentPreview.tsx
function os(e) {
	return e < 1024 ? `${e} B` : e < 1024 * 1024 ? `${(e / 1024).toFixed(0)} KB` : `${(e / (1024 * 1024)).toFixed(1)} MB`;
}
function ss({ attachments: e, onRemove: t }) {
	let { t: n } = W();
	return e.length === 0 ? null : /* @__PURE__ */ H(tt, {
		scrollbarSize: 4,
		type: "auto",
		style: { padding: "8px 12px 0" },
		children: /* @__PURE__ */ H(I, {
			gap: "xs",
			wrap: "nowrap",
			children: e.map((e) => /* @__PURE__ */ U(Ze, {
				p: "xs",
				radius: "sm",
				withBorder: !0,
				style: {
					position: "relative",
					minWidth: 80,
					maxWidth: 120,
					flexShrink: 0
				},
				children: [
					/* @__PURE__ */ H(A, {
						size: "xs",
						variant: "filled",
						color: "red",
						radius: "xl",
						onClick: () => t(e.id),
						"aria-label": n("messages.attachments.remove", {
							filename: e.file.name,
							defaultValue: `Remove attachment: ${e.file.name}`
						}),
						style: {
							position: "absolute",
							top: -6,
							right: -6,
							zIndex: 1
						},
						children: /* @__PURE__ */ H(V, { size: 10 })
					}),
					e.file.type.startsWith("image/") && e.preview ? /* @__PURE__ */ H(We, {
						src: e.preview,
						w: 64,
						h: 64,
						fit: "cover",
						radius: "sm",
						alt: e.file.name
					}) : /* @__PURE__ */ H(M, {
						style: {
							display: "flex",
							justifyContent: "center",
							padding: "8px 0"
						},
						children: /* @__PURE__ */ H(Yt, {
							size: 32,
							color: "var(--mantine-color-dimmed)"
						})
					}),
					/* @__PURE__ */ H(B, {
						size: "xs",
						truncate: !0,
						mt: 4,
						title: e.file.name,
						children: e.file.name
					}),
					/* @__PURE__ */ H(B, {
						size: "xs",
						c: "dimmed",
						children: os(e.file.size)
					})
				]
			}, e.id))
		})
	});
}
//#endregion
//#region src/components/chat/AttachmentCard.tsx
var cs = 30;
function ls(e) {
	if (e.length <= cs) return e;
	let t = e.lastIndexOf(".");
	if (t > 0) {
		let n = e.slice(t);
		return `${e.slice(0, cs - n.length - 1)}\u2026${n}`;
	}
	return e.slice(0, cs) + "…";
}
function us(e) {
	return e === "application/pdf" ? Qt : e.includes("zip") || e.includes("compressed") || e.includes("archive") ? $t : e.includes("spreadsheet") || e.includes("excel") || e === "text/csv" ? Xt : e.startsWith("text/") ? Zt : Yt;
}
function ds({ attachment: e }) {
	let { t } = W(), n = us(e.type), r = is(), [i, a] = Y(!1), o = G(async () => {
		if (!r) {
			window.open(e.url, "_blank");
			return;
		}
		a(!0);
		try {
			let t = await r(e.url), n = URL.createObjectURL(t), i = document.createElement("a");
			i.href = n, i.download = e.filename, document.body.appendChild(i), i.click(), document.body.removeChild(i), URL.revokeObjectURL(n);
		} catch {
			window.open(e.url, "_blank");
		} finally {
			a(!1);
		}
	}, [e, r]);
	return /* @__PURE__ */ H(Ze, {
		p: "xs",
		radius: "sm",
		withBorder: !0,
		children: /* @__PURE__ */ U(I, {
			gap: "xs",
			wrap: "nowrap",
			children: [
				/* @__PURE__ */ H(n, {
					size: 24,
					color: "var(--mantine-color-dimmed)",
					style: { flexShrink: 0 }
				}),
				/* @__PURE__ */ U("div", {
					style: {
						flex: 1,
						minWidth: 0
					},
					children: [/* @__PURE__ */ H(B, {
						size: "sm",
						truncate: !0,
						title: e.filename,
						children: ls(e.filename)
					}), /* @__PURE__ */ H(B, {
						size: "xs",
						c: "dimmed",
						children: os(e.size)
					})]
				}),
				/* @__PURE__ */ H(A, {
					onClick: o,
					loading: i,
					variant: "subtle",
					size: "sm",
					"aria-label": t("messages.attachment.download", {
						filename: e.filename,
						defaultValue: `Download ${e.filename}`
					}),
					children: /* @__PURE__ */ H(Jt, { size: 16 })
				})
			]
		})
	});
}
//#endregion
//#region src/components/chat/ContextCard.tsx
function fs(e, t, n) {
	try {
		return new Intl.NumberFormat(n, {
			style: "currency",
			currency: t,
			minimumFractionDigits: 2
		}).format(e);
	} catch {
		return `${e.toFixed(2)} ${t}`;
	}
}
function ps({ snapshot: e, locale: t, t: n }) {
	let r = e.orderNumber, i = e.orderTotal, a = e.orderCurrency || "ARS", o = e.orderStatus, s = e.orderItemCount;
	return /* @__PURE__ */ U(He, {
		align: "center",
		gap: "sm",
		children: [/* @__PURE__ */ H(vn, {
			size: 28,
			stroke: 1.5,
			style: { flexShrink: 0 }
		}), /* @__PURE__ */ U(M, {
			style: { minWidth: 0 },
			children: [/* @__PURE__ */ U(B, {
				size: "sm",
				fw: 600,
				truncate: !0,
				children: [
					n("chat.context.orderTitle"),
					" ",
					r || "—"
				]
			}), /* @__PURE__ */ U(He, {
				align: "center",
				gap: "xs",
				wrap: "wrap",
				children: [
					i != null && /* @__PURE__ */ H(B, {
						size: "xs",
						c: "dimmed",
						children: fs(i, a, t)
					}),
					s != null && /* @__PURE__ */ U(B, {
						size: "xs",
						c: "dimmed",
						children: [
							"· ",
							s,
							" ",
							n("chat.context.items")
						]
					}),
					o && /* @__PURE__ */ H(j, {
						size: "xs",
						variant: "light",
						radius: "sm",
						children: o
					})
				]
			})]
		})]
	});
}
function ms({ snapshot: e, locale: t, t: n }) {
	let r = e.productName, i = e.productImage, a = e.productPrice, o = e.productCurrency || "ARS";
	return /* @__PURE__ */ U(He, {
		align: "center",
		gap: "sm",
		children: [
			i ? /* @__PURE__ */ H(We, {
				src: i,
				w: 48,
				h: 48,
				radius: "sm",
				fit: "cover",
				style: { flexShrink: 0 },
				fallbackSrc: void 0,
				onError: (e) => {
					e.currentTarget.style.display = "none";
					let t = e.currentTarget.nextElementSibling;
					t && (t.style.display = "flex");
				}
			}) : null,
			/* @__PURE__ */ H(He, {
				align: "center",
				justify: "center",
				w: 48,
				h: 48,
				style: {
					flexShrink: 0,
					borderRadius: "var(--mantine-radius-sm)",
					background: "var(--mantine-color-gray-2)",
					display: i ? "none" : "flex"
				},
				children: /* @__PURE__ */ H(An, {
					size: 24,
					stroke: 1.5
				})
			}),
			/* @__PURE__ */ U(M, {
				style: { minWidth: 0 },
				children: [/* @__PURE__ */ H(B, {
					size: "sm",
					fw: 600,
					truncate: !0,
					children: r || n("chat.context.productInquiry")
				}), a != null && /* @__PURE__ */ H(B, {
					size: "xs",
					c: "dimmed",
					children: fs(a, o, t)
				})]
			})
		]
	});
}
function hs({ snapshot: e, t }) {
	let n = (e) => typeof e == "string" && e.trim() !== "" ? e.trim() : null, r = n(e.counterpartName), i = n(e.subject), a = n(e.lastMessagePreview);
	return /* @__PURE__ */ U(He, {
		align: "flex-start",
		gap: "sm",
		children: [/* @__PURE__ */ H(pn, {
			size: 28,
			stroke: 1.5,
			style: { flexShrink: 0 },
			"aria-hidden": !0
		}), /* @__PURE__ */ U(M, {
			style: { minWidth: 0 },
			children: [
				/* @__PURE__ */ H(B, {
					size: "sm",
					fw: 600,
					truncate: !0,
					"data-testid": "context-card-counterpart",
					children: r ?? t("chat.context.conversationTitle", "Conversation")
				}),
				i && /* @__PURE__ */ H(B, {
					size: "xs",
					c: "dimmed",
					truncate: !0,
					"data-testid": "context-card-subject",
					children: i
				}),
				a && /* @__PURE__ */ H(B, {
					size: "xs",
					lineClamp: 2,
					"data-testid": "context-card-preview",
					children: a
				})
			]
		})]
	});
}
function gs({ type: e, snapshot: t, onClick: n, hoverContent: r, compact: i }) {
	let { t: a, i18n: o } = W(), s = o.language, c = e === "order_context" ? /* @__PURE__ */ H(ps, {
		snapshot: t,
		locale: s,
		t: a
	}) : e === "product_context" ? /* @__PURE__ */ H(ms, {
		snapshot: t,
		locale: s,
		t: a
	}) : e === "conversation_context" ? /* @__PURE__ */ H(hs, {
		snapshot: t,
		t: a
	}) : null;
	if (!c) return null;
	if (i) return /* @__PURE__ */ H(M, {
		"data-testid": "context-card",
		style: { fontSize: "0.9em" },
		children: c
	});
	let l = /* @__PURE__ */ H(Ze, {
		radius: "md",
		px: "md",
		py: "sm",
		bg: "var(--mantine-color-default)",
		withBorder: !0,
		maw: 400,
		w: "100%",
		style: n ? { cursor: "pointer" } : void 0,
		"data-testid": "context-card",
		children: c
	}), u = n ? /* @__PURE__ */ H(ft, {
		onClick: n,
		maw: 400,
		w: "100%",
		children: l
	}) : l;
	return /* @__PURE__ */ H(He, {
		justify: "center",
		my: "xs",
		"data-testid": "context-card-wrapper",
		children: r ? /* @__PURE__ */ U(Ue, {
			position: "top",
			withArrow: !0,
			shadow: "md",
			openDelay: 300,
			closeDelay: 100,
			children: [/* @__PURE__ */ H(Ue.Target, { children: u }), /* @__PURE__ */ H(Ue.Dropdown, { children: r })]
		}) : u
	});
}
var _s = {
	chip: "_chip_1s6it_8",
	selected: "_selected_1s6it_20"
};
//#endregion
//#region src/components/chat/MentionChip.tsx
function vs({ children: e, selected: t = !1 }) {
	return /* @__PURE__ */ H("span", {
		className: t ? `${_s.chip} ${_s.selected}` : _s.chip,
		"data-testid": "mention-chip",
		children: e
	});
}
function ys({ node: e, selected: t }) {
	let n = e.attrs.label ?? e.attrs.id;
	return /* @__PURE__ */ H(Sr, {
		as: "span",
		"data-mention-id": e.attrs.id,
		children: /* @__PURE__ */ U(vs, {
			selected: t,
			children: ["@", n]
		})
	});
}
var bs = {
	incomingBubble: "_incomingBubble_1wrwd_8",
	messageContent: "_messageContent_1wrwd_15",
	noteBubble: "_noteBubble_1wrwd_95",
	noteHeader: "_noteHeader_1wrwd_101",
	internalSystem: "_internalSystem_1wrwd_118",
	internalSystemHeader: "_internalSystemHeader_1wrwd_129",
	internalSystemText: "_internalSystemText_1wrwd_138"
}, xs = [
	"p",
	"br",
	"strong",
	"em",
	"code",
	"pre",
	"ul",
	"ol",
	"li",
	"a"
], Ss = { a: ({ href: e, children: t }) => /* @__PURE__ */ H("a", {
	href: e,
	target: "_blank",
	rel: "noopener noreferrer",
	children: t
}) }, Cs = new Set(["strong", "em"]), ws = "shop", Ts = "staff", Es = 32;
function Ds(e) {
	try {
		return new Date(e).toLocaleTimeString(void 0, {
			hour: "2-digit",
			minute: "2-digit"
		});
	} catch {
		return "";
	}
}
function Os(e) {
	let t = [...new Set((e ?? []).map((e) => e.displayName).filter(Boolean))];
	if (t.length === 0) return null;
	let n = t.sort((e, t) => t.length - e.length).map((e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
	return RegExp(`@(?:${n.join("|")})(?![\\p{L}\\p{N}_])`, "gu");
}
function ks(e, t) {
	return t ? qn.map(e, (e) => {
		if (typeof e == "string") {
			let n = [], r = 0;
			for (let i of e.matchAll(t)) {
				let t = i.index ?? 0;
				t > 0 && /[\p{L}\p{N}_.]/u.test(e[t - 1]) || (t > r && n.push(e.slice(r, t)), n.push(/* @__PURE__ */ H(vs, { children: i[0] }, `${t}-${i[0]}`)), r = t + i[0].length);
			}
			return n.length === 0 ? e : (r < e.length && n.push(e.slice(r)), n);
		}
		return er(e) && typeof e.type == "string" && Cs.has(e.type) ? Zn(e, void 0, ks(e.props.children, t)) : e;
	}) : e;
}
function As(e) {
	let t = e?.context;
	return t?.type !== "conversation" || typeof t.entityGuid != "string" || t.entityGuid === "" || !t.snapshot || typeof t.snapshot != "object" ? null : t;
}
function js(e) {
	try {
		let t = JSON.parse(e);
		if (t && typeof t.type == "string" && t.type.endsWith("_context") && typeof t.entityGuid == "string" && t.snapshot && typeof t.snapshot == "object") return {
			type: t.type,
			entityGuid: t.entityGuid,
			snapshot: t.snapshot
		};
	} catch {}
	return null;
}
function Ms({ shop: e, staff: t }) {
	let { t: n } = W(), r = n("messages.sender_with_staff", {
		shop: ws,
		staff: Ts,
		defaultValue: "{{shop}} · {{staff}}"
	}), i = r.indexOf(ws), a = r.indexOf(Ts), [o, s] = i >= 0 && a > i ? [r.slice(0, i), r.slice(i + 6).replace(Ts, t)] : ["", ` · ${t}`];
	return /* @__PURE__ */ U(B, {
		size: "sm",
		mb: 2,
		"data-testid": "message-sender-line",
		children: [
			o,
			/* @__PURE__ */ H(B, {
				span: !0,
				fw: 600,
				inherit: !0,
				children: e
			}),
			/* @__PURE__ */ H(B, {
				span: !0,
				c: "dimmed",
				inherit: !0,
				children: s
			})
		]
	});
}
function Ns() {
	let { t: e } = W();
	return /* @__PURE__ */ U(I, {
		gap: 4,
		wrap: "nowrap",
		c: "gray.6",
		"data-testid": "message-autoreply-tag",
		children: [/* @__PURE__ */ H(Lt, {
			size: 12,
			"aria-hidden": !0
		}), /* @__PURE__ */ H(B, {
			size: "sm",
			span: !0,
			c: "gray.6",
			"data-testid": "message-autoreply-tag-text",
			children: e("messages.autoReply", "Auto-reply")
		})]
	});
}
function Ps({ sender: e, legacyName: t }) {
	if (!e) return t ? /* @__PURE__ */ H(B, {
		size: "xs",
		fw: 600,
		c: "dimmed",
		mb: 2,
		children: t
	}) : null;
	let n = e.onBehalfOf?.displayName || null, r = e.displayName || null;
	if (n && r) return /* @__PURE__ */ H(Ms, {
		shop: n,
		staff: r
	});
	let i = n ?? r;
	return i ? /* @__PURE__ */ H(B, {
		size: "sm",
		fw: 600,
		mb: 2,
		"data-testid": "message-sender-line",
		children: i
	}) : null;
}
function Fs({ sender: e }) {
	let t = e?.displayName || null;
	return t ? /* @__PURE__ */ H(B, {
		size: "xs",
		fw: 600,
		c: "dimmed",
		mb: 2,
		"data-testid": "message-author-line",
		children: t
	}) : null;
}
function Is({ message: e, isOutgoing: t, sender: n = e.sender, visibility: r = e.visibility, autoReply: i = e.autoReply ?? !1, isSeriesStart: a = !0, showOutgoingAuthor: o = !1, avatar: s, onRetry: c, onOpenConversation: l, getContextCardProps: u, renderDeliveryStatus: d }) {
	let { t: f } = W(), p = c ? () => c(e.messageId) : void 0, m = t && e.status !== "sending" && e.status !== "failed" ? d?.(e) ?? null : null, h = !t && s !== void 0, g = r === "internal", _ = e.metadata?.mentions, v = As(e.metadata), y = q(() => g ? Os(_) : null, [g, _]), b = q(() => ({
		...Ss,
		p: ({ children: e }) => /* @__PURE__ */ H("p", { children: ks(e, y) }),
		li: ({ children: e }) => /* @__PURE__ */ H("li", { children: ks(e, y) })
	}), [y]);
	if (e.messageType === "system_notification" && g) return /* @__PURE__ */ U(M, {
		"data-testid": "message-bubble-system",
		"data-visibility": "internal",
		className: bs.internalSystem,
		children: [
			/* @__PURE__ */ U("div", {
				className: bs.internalSystemHeader,
				children: [/* @__PURE__ */ H(un, {
					size: 12,
					"aria-hidden": !0
				}), /* @__PURE__ */ H("span", { children: f("messages.note.teamOnly", "Team only") })]
			}),
			/* @__PURE__ */ H("div", {
				className: bs.internalSystemText,
				children: e.content
			}),
			/* @__PURE__ */ H(B, {
				size: "xs",
				c: "dimmed",
				mt: 2,
				children: Ds(e.createdAt)
			})
		]
	});
	if (e.messageType === "system_notification") {
		let t = js(e.content);
		if (t) {
			let n = u?.(t);
			return /* @__PURE__ */ U(M, {
				"data-testid": "message-bubble-system",
				children: [/* @__PURE__ */ H(gs, {
					...t,
					onClick: n?.onClick,
					hoverContent: n?.hoverContent
				}), /* @__PURE__ */ H(B, {
					size: "xs",
					c: "dimmed",
					ta: "center",
					mt: -4,
					mb: "xs",
					children: Ds(e.createdAt)
				})]
			});
		}
		return /* @__PURE__ */ H(M, {
			"data-testid": "message-bubble-system",
			children: /* @__PURE__ */ H(B, {
				size: "xs",
				c: "dimmed",
				ta: "center",
				my: "xs",
				children: e.content
			})
		});
	}
	return /* @__PURE__ */ U(He, {
		justify: t ? "flex-end" : "flex-start",
		align: "flex-start",
		gap: "xs",
		"data-testid": `message-bubble-${t ? "outgoing" : "incoming"}`,
		children: [h && (a ? /* @__PURE__ */ H(Me, {
			src: s.src,
			size: Es,
			radius: "xl",
			color: "brand",
			alt: s.name,
			"data-testid": "message-sender-avatar",
			children: s.name.charAt(0).toUpperCase()
		}) : /* @__PURE__ */ H(M, {
			w: Es,
			style: { flexShrink: 0 }
		})), /* @__PURE__ */ U(M, {
			maw: "70%",
			px: "sm",
			py: "xs",
			className: g ? bs.noteBubble : t ? void 0 : bs.incomingBubble,
			"data-visibility": g ? "internal" : void 0,
			style: {
				background: t && !g ? "var(--mantine-color-blue-light)" : void 0,
				borderRadius: "var(--mantine-radius-md) var(--mantine-radius-md) " + (t ? "0 var(--mantine-radius-md)" : "var(--mantine-radius-md) 0")
			},
			children: [
				g ? /* @__PURE__ */ U("div", {
					className: bs.noteHeader,
					"data-testid": "note-header",
					children: [/* @__PURE__ */ H(un, {
						size: 12,
						"aria-hidden": !0
					}), /* @__PURE__ */ U("span", { children: [
						f("messages.note.teamOnly", "Team only"),
						(n?.displayName || e.senderName) && ` · ${n?.displayName || e.senderName}`,
						` · ${Ds(e.createdAt)}`
					] })]
				}) : /* @__PURE__ */ H(Gn, { children: i ? /* @__PURE__ */ U(He, {
					align: "baseline",
					gap: "xs",
					wrap: "wrap",
					mb: 2,
					children: [!t && a && /* @__PURE__ */ H(Ps, {
						sender: n,
						legacyName: e.senderName
					}), /* @__PURE__ */ H(Ns, {})]
				}) : /* @__PURE__ */ U(Gn, { children: [!t && a && /* @__PURE__ */ H(Ps, {
					sender: n,
					legacyName: e.senderName
				}), t && a && o && /* @__PURE__ */ H(Fs, { sender: n })] }) }),
				/* @__PURE__ */ H(M, {
					className: bs.messageContent,
					c: t && !g ? "var(--mantine-color-blue-light-color)" : void 0,
					children: /* @__PURE__ */ H(br, {
						remarkPlugins: [xr],
						allowedElements: xs,
						unwrapDisallowed: !0,
						components: g ? b : Ss,
						urlTransform: (e) => e,
						children: e.content
					})
				}),
				v && /* @__PURE__ */ H(M, {
					mt: "xs",
					"data-testid": "shared-conversation-card",
					children: /* @__PURE__ */ H(gs, {
						type: "conversation_context",
						entityGuid: v.entityGuid,
						snapshot: v.snapshot,
						onClick: l ? () => l(v.entityGuid) : void 0
					})
				}),
				e.attachments && e.attachments.length > 0 && /* @__PURE__ */ H(z, {
					gap: "xs",
					mt: "xs",
					children: e.attachments.map((e) => e.type.startsWith("image/") ? /* @__PURE__ */ H(as, { attachment: e }, e.url) : /* @__PURE__ */ H(ds, { attachment: e }, e.url))
				}),
				(!g || e.status === "sending" || e.status === "failed") && /* @__PURE__ */ U(I, {
					gap: 4,
					justify: "flex-end",
					mt: 2,
					children: [!g && /* @__PURE__ */ H(B, {
						size: "xs",
						c: "dimmed",
						children: Ds(e.createdAt)
					}), t && (m ?? /* @__PURE__ */ H(ts, {
						status: e.status,
						onRetry: p
					}))]
				})
			]
		})]
	});
}
//#endregion
//#region src/components/chat/DateSeparator.tsx
function Ls(e, t) {
	return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}
function Rs(e, t, n) {
	let r = /* @__PURE__ */ new Date();
	if (Ls(e, r)) return t("messages.today");
	let i = new Date(r);
	return i.setDate(i.getDate() - 1), Ls(e, i) ? t("messages.yesterday") : new Intl.DateTimeFormat(n, {
		day: "numeric",
		month: "long",
		year: e.getFullYear() === r.getFullYear() ? void 0 : "numeric"
	}).format(e);
}
function zs({ date: e }) {
	let { t, i18n: n } = W();
	return /* @__PURE__ */ H(Be, {
		my: "sm",
		label: Rs(new Date(e), t, n.language),
		labelPosition: "center",
		color: "dimmed",
		"data-testid": "date-separator"
	});
}
//#endregion
//#region src/components/chat/MessageList.tsx
function Bs(e) {
	let t = new Date(e);
	return `${t.getFullYear()}-${t.getMonth()}-${t.getDate()}`;
}
function Vs(e) {
	return !e.sender || e.messageType === "system_notification" ? null : `${e.sender.guid}|${e.visibility ?? "external"}${e.autoReply ? "|auto" : ""}`;
}
function Hs() {
	return typeof window > "u" ? !1 : window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function Us({ messages: e, currentUserGuid: t, onLoadMore: n, isLoadingMore: r, hasMore: i, onRetry: a, conversationId: o, getContextCardProps: s, onOpenConversation: c, isOutgoing: l, showOutgoingAuthor: u, getSenderAvatar: d, renderDeliveryStatus: f }) {
	let { t: p } = W(), m = J(null), h = J(null), g = J(void 0), _ = J(o), v = J(0), y = J(0), b = Hs();
	K(() => {
		o !== _.current && (g.current = void 0, v.current = 0, _.current = o);
	}, [o]), ar(() => {
		let t = m.current;
		if (!t || e.length === 0) return;
		let n = e[e.length - 1]?.messageId, r = v.current;
		return g.current ? n && n !== g.current ? t.scrollTo({
			top: t.scrollHeight,
			behavior: b ? "instant" : "smooth"
		}) : r > 0 && t.scrollHeight > r && (t.scrollTop += t.scrollHeight - r) : (t.scrollTop = t.scrollHeight, cancelAnimationFrame(y.current), y.current = requestAnimationFrame(() => {
			t.scrollTop = t.scrollHeight;
		})), g.current = n, v.current = t.scrollHeight, () => cancelAnimationFrame(y.current);
	}, [e, b]), K(() => {
		let e = h.current, t = m.current;
		if (!e || !t || !n || !i) return;
		let a = new IntersectionObserver((e) => {
			e[0].isIntersecting && !r && n();
		}, {
			root: t,
			threshold: .1
		});
		return a.observe(e), () => a.disconnect();
	}, [
		n,
		i,
		r
	]);
	let x = G(() => {
		let n = [], r = "", i = null;
		for (let o of e) {
			let e = Bs(o.createdAt);
			e !== r && (r = e, i = null, n.push(/* @__PURE__ */ H(zs, { date: o.createdAt }, `date-${e}`)));
			let p = Vs(o), m = p === null || p !== i;
			i = p, n.push(/* @__PURE__ */ H(Is, {
				message: o,
				isOutgoing: l ? l(o) : o.senderGuid === t,
				isSeriesStart: m,
				showOutgoingAuthor: u,
				avatar: d?.(o),
				onRetry: a,
				getContextCardProps: s,
				onOpenConversation: c,
				renderDeliveryStatus: f
			}, o.messageId));
		}
		return n;
	}, [
		e,
		t,
		a,
		s,
		c,
		l,
		u,
		d,
		f
	]);
	return /* @__PURE__ */ H(tt, {
		h: "100%",
		viewportRef: m,
		viewportProps: {
			role: "log",
			"aria-live": "polite",
			"aria-label": p("messages.aria.message_list"),
			tabIndex: 0
		},
		"data-testid": "message-list",
		children: /* @__PURE__ */ U(z, {
			gap: "xs",
			px: "md",
			py: "sm",
			children: [
				i && /* @__PURE__ */ H("div", {
					ref: h,
					style: { height: 1 }
				}),
				r && /* @__PURE__ */ H(Pe, {
					py: "xs",
					children: /* @__PURE__ */ H(Ke, { size: "sm" })
				}),
				x()
			]
		})
	});
}
//#endregion
//#region ../node_modules/prop-types/node_modules/react-is/cjs/react-is.production.min.js
var Ws = /* @__PURE__ */ Kr(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function x(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return x(e) || b(e) === l;
	}, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), Gs = /* @__PURE__ */ Kr(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
		function b(e) {
			return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
		}
		function x(e) {
			if (typeof e == "object" && e) {
				var t = e.$$typeof;
				switch (t) {
					case n:
						var p = e.type;
						switch (p) {
							case l:
							case u:
							case i:
							case o:
							case a:
							case f: return p;
							default:
								var g = p && p.$$typeof;
								switch (g) {
									case c:
									case d:
									case h:
									case m:
									case s: return g;
									default: return t;
								}
						}
					case r: return t;
				}
			}
		}
		var S = l, C = u, ee = c, te = s, ne = n, re = d, ie = i, ae = h, w = m, T = r, E = o, oe = a, D = f, se = !1;
		function ce(e) {
			return se || (se = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), le(e) || x(e) === l;
		}
		function le(e) {
			return x(e) === u;
		}
		function ue(e) {
			return x(e) === c;
		}
		function de(e) {
			return x(e) === s;
		}
		function O(e) {
			return typeof e == "object" && !!e && e.$$typeof === n;
		}
		function fe(e) {
			return x(e) === d;
		}
		function pe(e) {
			return x(e) === i;
		}
		function me(e) {
			return x(e) === h;
		}
		function he(e) {
			return x(e) === m;
		}
		function ge(e) {
			return x(e) === r;
		}
		function _e(e) {
			return x(e) === o;
		}
		function ve(e) {
			return x(e) === a;
		}
		function k(e) {
			return x(e) === f;
		}
		e.AsyncMode = S, e.ConcurrentMode = C, e.ContextConsumer = ee, e.ContextProvider = te, e.Element = ne, e.ForwardRef = re, e.Fragment = ie, e.Lazy = ae, e.Memo = w, e.Portal = T, e.Profiler = E, e.StrictMode = oe, e.Suspense = D, e.isAsyncMode = ce, e.isConcurrentMode = le, e.isContextConsumer = ue, e.isContextProvider = de, e.isElement = O, e.isForwardRef = fe, e.isFragment = pe, e.isLazy = me, e.isMemo = he, e.isPortal = ge, e.isProfiler = _e, e.isStrictMode = ve, e.isSuspense = k, e.isValidElementType = b, e.typeOf = x;
	})();
})), Ks = /* @__PURE__ */ Kr(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = Ws() : t.exports = Gs();
})), qs = /* @__PURE__ */ Kr(((e, t) => {
	var n = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
	function a(e) {
		if (e == null) throw TypeError("Object.assign cannot be called with null or undefined");
		return Object(e);
	}
	function o() {
		try {
			if (!Object.assign) return !1;
			var e = /* @__PURE__ */ new String("abc");
			if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
			for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
			if (Object.getOwnPropertyNames(t).map(function(e) {
				return t[e];
			}).join("") !== "0123456789") return !1;
			var r = {};
			return "abcdefghijklmnopqrst".split("").forEach(function(e) {
				r[e] = e;
			}), Object.keys(Object.assign({}, r)).join("") === "abcdefghijklmnopqrst";
		} catch {
			return !1;
		}
	}
	t.exports = o() ? Object.assign : function(e, t) {
		for (var o, s = a(e), c, l = 1; l < arguments.length; l++) {
			for (var u in o = Object(arguments[l]), o) r.call(o, u) && (s[u] = o[u]);
			if (n) {
				c = n(o);
				for (var d = 0; d < c.length; d++) i.call(o, c[d]) && (s[c[d]] = o[c[d]]);
			}
		}
		return s;
	};
})), Js = /* @__PURE__ */ Kr(((e, t) => {
	t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
})), Ys = /* @__PURE__ */ Kr(((e, t) => {
	t.exports = Function.call.bind(Object.prototype.hasOwnProperty);
})), Xs = /* @__PURE__ */ Kr(((e, t) => {
	var n = function() {};
	if (process.env.NODE_ENV !== "production") {
		var r = Js(), i = {}, a = Ys();
		n = function(e) {
			var t = "Warning: " + e;
			typeof console < "u" && console.error(t);
			try {
				throw Error(t);
			} catch {}
		};
	}
	function o(e, t, o, s, c) {
		if (process.env.NODE_ENV !== "production") {
			for (var l in e) if (a(e, l)) {
				var u;
				try {
					if (typeof e[l] != "function") {
						var d = Error((s || "React class") + ": " + o + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
						throw d.name = "Invariant Violation", d;
					}
					u = e[l](t, l, s, o, null, r);
				} catch (e) {
					u = e;
				}
				if (u && !(u instanceof Error) && n((s || "React class") + ": type specification of " + o + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in i)) {
					i[u.message] = !0;
					var f = c ? c() : "";
					n("Failed " + o + " type: " + u.message + (f ?? ""));
				}
			}
		}
	}
	o.resetWarningCache = function() {
		process.env.NODE_ENV !== "production" && (i = {});
	}, t.exports = o;
})), Zs = /* @__PURE__ */ Kr(((e, t) => {
	var n = Ks(), r = qs(), i = Js(), a = Ys(), o = Xs(), s = function() {};
	process.env.NODE_ENV !== "production" && (s = function(e) {
		var t = "Warning: " + e;
		typeof console < "u" && console.error(t);
		try {
			throw Error(t);
		} catch {}
	});
	function c() {
		return null;
	}
	t.exports = function(e, t) {
		var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
		function d(e) {
			var t = e && (l && e[l] || e[u]);
			if (typeof t == "function") return t;
		}
		var f = "<<anonymous>>", p = {
			array: _("array"),
			bigint: _("bigint"),
			bool: _("boolean"),
			func: _("function"),
			number: _("number"),
			object: _("object"),
			string: _("string"),
			symbol: _("symbol"),
			any: v(),
			arrayOf: y,
			element: b(),
			elementType: x(),
			instanceOf: S,
			node: ne(),
			objectOf: ee,
			oneOf: C,
			oneOfType: te,
			shape: ie,
			exact: ae
		};
		function m(e, t) {
			return e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
		}
		function h(e, t) {
			this.message = e, this.data = t && typeof t == "object" ? t : {}, this.stack = "";
		}
		h.prototype = Error.prototype;
		function g(e) {
			if (process.env.NODE_ENV !== "production") var n = {}, r = 0;
			function a(a, o, c, l, u, d, p) {
				if (l ||= f, d ||= c, p !== i) {
					if (t) {
						var m = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
						throw m.name = "Invariant Violation", m;
					} else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
						var g = l + ":" + c;
						!n[g] && r < 3 && (s("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[g] = !0, r++);
					}
				}
				return o[c] == null ? a ? o[c] === null ? new h("The " + u + " `" + d + "` is marked as required " + ("in `" + l + "`, but its value is `null`.")) : new h("The " + u + " `" + d + "` is marked as required in " + ("`" + l + "`, but its value is `undefined`.")) : null : e(o, c, l, u, d);
			}
			var o = a.bind(null, !1);
			return o.isRequired = a.bind(null, !0), o;
		}
		function _(e) {
			function t(t, n, r, i, a, o) {
				var s = t[n];
				if (E(s) !== e) {
					var c = oe(s);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("`" + e + "`."), { expectedType: e });
				}
				return null;
			}
			return g(t);
		}
		function v() {
			return g(c);
		}
		function y(e) {
			function t(t, n, r, a, o) {
				if (typeof e != "function") return new h("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
				var s = t[n];
				if (!Array.isArray(s)) {
					var c = E(s);
					return new h("Invalid " + a + " `" + o + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected an array."));
				}
				for (var l = 0; l < s.length; l++) {
					var u = e(s, l, r, a, o + "[" + l + "]", i);
					if (u instanceof Error) return u;
				}
				return null;
			}
			return g(t);
		}
		function b() {
			function t(t, n, r, i, a) {
				var o = t[n];
				if (!e(o)) {
					var s = E(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement."));
				}
				return null;
			}
			return g(t);
		}
		function x() {
			function e(e, t, r, i, a) {
				var o = e[t];
				if (!n.isValidElementType(o)) {
					var s = E(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement type."));
				}
				return null;
			}
			return g(e);
		}
		function S(e) {
			function t(t, n, r, i, a) {
				if (!(t[n] instanceof e)) {
					var o = e.name || f, s = se(t[n]);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected ") + ("instance of `" + o + "`."));
				}
				return null;
			}
			return g(t);
		}
		function C(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : s("Invalid argument supplied to oneOf, expected an array.")), c;
			function t(t, n, r, i, a) {
				for (var o = t[n], s = 0; s < e.length; s++) if (m(o, e[s])) return null;
				var c = JSON.stringify(e, function(e, t) {
					return oe(t) === "symbol" ? String(t) : t;
				});
				return new h("Invalid " + i + " `" + a + "` of value `" + String(o) + "` " + ("supplied to `" + r + "`, expected one of " + c + "."));
			}
			return g(t);
		}
		function ee(e) {
			function t(t, n, r, o, s) {
				if (typeof e != "function") return new h("Property `" + s + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
				var c = t[n], l = E(c);
				if (l !== "object") return new h("Invalid " + o + " `" + s + "` of type " + ("`" + l + "` supplied to `" + r + "`, expected an object."));
				for (var u in c) if (a(c, u)) {
					var d = e(c, u, r, o, s + "." + u, i);
					if (d instanceof Error) return d;
				}
				return null;
			}
			return g(t);
		}
		function te(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), c;
			for (var t = 0; t < e.length; t++) {
				var n = e[t];
				if (typeof n != "function") return s("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + D(n) + " at index " + t + "."), c;
			}
			function r(t, n, r, o, s) {
				for (var c = [], l = 0; l < e.length; l++) {
					var u = e[l], d = u(t, n, r, o, s, i);
					if (d == null) return null;
					d.data && a(d.data, "expectedType") && c.push(d.data.expectedType);
				}
				var f = c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "";
				return new h("Invalid " + o + " `" + s + "` supplied to " + ("`" + r + "`" + f + "."));
			}
			return g(r);
		}
		function ne() {
			function e(e, t, n, r, i) {
				return w(e[t]) ? null : new h("Invalid " + r + " `" + i + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
			}
			return g(e);
		}
		function re(e, t, n, r, i) {
			return new h((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + i + "`.");
		}
		function ie(e) {
			function t(t, n, r, a, o) {
				var s = t[n], c = E(s);
				if (c !== "object") return new h("Invalid " + a + " `" + o + "` of type `" + c + "` " + ("supplied to `" + r + "`, expected `object`."));
				for (var l in e) {
					var u = e[l];
					if (typeof u != "function") return re(r, a, o, l, oe(u));
					var d = u(s, l, r, a, o + "." + l, i);
					if (d) return d;
				}
				return null;
			}
			return g(t);
		}
		function ae(e) {
			function t(t, n, o, s, c) {
				var l = t[n], u = E(l);
				if (u !== "object") return new h("Invalid " + s + " `" + c + "` of type `" + u + "` " + ("supplied to `" + o + "`, expected `object`."));
				for (var d in r({}, t[n], e)) {
					var f = e[d];
					if (a(e, d) && typeof f != "function") return re(o, s, c, d, oe(f));
					if (!f) return new h("Invalid " + s + " `" + c + "` key `" + d + "` supplied to `" + o + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
					var p = f(l, d, o, s, c + "." + d, i);
					if (p) return p;
				}
				return null;
			}
			return g(t);
		}
		function w(t) {
			switch (typeof t) {
				case "number":
				case "string":
				case "undefined": return !0;
				case "boolean": return !t;
				case "object":
					if (Array.isArray(t)) return t.every(w);
					if (t === null || e(t)) return !0;
					var n = d(t);
					if (n) {
						var r = n.call(t), i;
						if (n !== t.entries) {
							for (; !(i = r.next()).done;) if (!w(i.value)) return !1;
						} else for (; !(i = r.next()).done;) {
							var a = i.value;
							if (a && !w(a[1])) return !1;
						}
					} else return !1;
					return !0;
				default: return !1;
			}
		}
		function T(e, t) {
			return e === "symbol" ? !0 : t ? t["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && t instanceof Symbol : !1;
		}
		function E(e) {
			var t = typeof e;
			return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : T(t, e) ? "symbol" : t;
		}
		function oe(e) {
			if (e == null) return "" + e;
			var t = E(e);
			if (t === "object") {
				if (e instanceof Date) return "date";
				if (e instanceof RegExp) return "regexp";
			}
			return t;
		}
		function D(e) {
			var t = oe(e);
			switch (t) {
				case "array":
				case "object": return "an " + t;
				case "boolean":
				case "date":
				case "regexp": return "a " + t;
				default: return t;
			}
		}
		function se(e) {
			return !e.constructor || !e.constructor.name ? f : e.constructor.name;
		}
		return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
	};
})), Qs = /* @__PURE__ */ Kr(((e, t) => {
	var n = Js();
	function r() {}
	function i() {}
	i.resetWarningCache = r, t.exports = function() {
		function e(e, t, r, i, a, o) {
			if (o !== n) {
				var s = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
				throw s.name = "Invariant Violation", s;
			}
		}
		e.isRequired = e;
		function t() {
			return e;
		}
		var a = {
			array: e,
			bigint: e,
			bool: e,
			func: e,
			number: e,
			object: e,
			string: e,
			symbol: e,
			any: e,
			arrayOf: t,
			element: e,
			elementType: e,
			instanceOf: t,
			node: e,
			objectOf: t,
			oneOf: t,
			oneOfType: t,
			shape: t,
			exact: t,
			checkPropTypes: i,
			resetWarningCache: r
		};
		return a.PropTypes = a, a;
	};
})), $s = /* @__PURE__ */ Kr(((e, t) => {
	if (process.env.NODE_ENV !== "production") {
		var n = Ks();
		t.exports = Zs()(n.isElement, !0);
	} else t.exports = Qs()();
}));
//#endregion
//#region ../node_modules/tslib/tslib.es6.mjs
function ec(e, t, n, r) {
	function i(e) {
		return e instanceof n ? e : new n(function(t) {
			t(e);
		});
	}
	return new (n ||= Promise)(function(n, a) {
		function o(e) {
			try {
				c(r.next(e));
			} catch (e) {
				a(e);
			}
		}
		function s(e) {
			try {
				c(r.throw(e));
			} catch (e) {
				a(e);
			}
		}
		function c(e) {
			e.done ? n(e.value) : i(e.value).then(o, s);
		}
		c((r = r.apply(e, t || [])).next());
	});
}
//#endregion
//#region ../node_modules/file-selector/dist/es2015/file.js
var tc = new Map([
	["1km", "application/vnd.1000minds.decision-model+xml"],
	["3dml", "text/vnd.in3d.3dml"],
	["3ds", "image/x-3ds"],
	["3g2", "video/3gpp2"],
	["3gp", "video/3gp"],
	["3gpp", "video/3gpp"],
	["3mf", "model/3mf"],
	["7z", "application/x-7z-compressed"],
	["7zip", "application/x-7z-compressed"],
	["123", "application/vnd.lotus-1-2-3"],
	["aab", "application/x-authorware-bin"],
	["aac", "audio/x-acc"],
	["aam", "application/x-authorware-map"],
	["aas", "application/x-authorware-seg"],
	["abw", "application/x-abiword"],
	["ac", "application/vnd.nokia.n-gage.ac+xml"],
	["ac3", "audio/ac3"],
	["acc", "application/vnd.americandynamics.acc"],
	["ace", "application/x-ace-compressed"],
	["acu", "application/vnd.acucobol"],
	["acutc", "application/vnd.acucorp"],
	["adp", "audio/adpcm"],
	["aep", "application/vnd.audiograph"],
	["afm", "application/x-font-type1"],
	["afp", "application/vnd.ibm.modcap"],
	["ahead", "application/vnd.ahead.space"],
	["ai", "application/pdf"],
	["aif", "audio/x-aiff"],
	["aifc", "audio/x-aiff"],
	["aiff", "audio/x-aiff"],
	["air", "application/vnd.adobe.air-application-installer-package+zip"],
	["ait", "application/vnd.dvb.ait"],
	["ami", "application/vnd.amiga.ami"],
	["amr", "audio/amr"],
	["apk", "application/vnd.android.package-archive"],
	["apng", "image/apng"],
	["appcache", "text/cache-manifest"],
	["application", "application/x-ms-application"],
	["apr", "application/vnd.lotus-approach"],
	["arc", "application/x-freearc"],
	["arj", "application/x-arj"],
	["asc", "application/pgp-signature"],
	["asf", "video/x-ms-asf"],
	["asm", "text/x-asm"],
	["aso", "application/vnd.accpac.simply.aso"],
	["asx", "video/x-ms-asf"],
	["atc", "application/vnd.acucorp"],
	["atom", "application/atom+xml"],
	["atomcat", "application/atomcat+xml"],
	["atomdeleted", "application/atomdeleted+xml"],
	["atomsvc", "application/atomsvc+xml"],
	["atx", "application/vnd.antix.game-component"],
	["au", "audio/x-au"],
	["avi", "video/x-msvideo"],
	["avif", "image/avif"],
	["aw", "application/applixware"],
	["azf", "application/vnd.airzip.filesecure.azf"],
	["azs", "application/vnd.airzip.filesecure.azs"],
	["azv", "image/vnd.airzip.accelerator.azv"],
	["azw", "application/vnd.amazon.ebook"],
	["b16", "image/vnd.pco.b16"],
	["bat", "application/x-msdownload"],
	["bcpio", "application/x-bcpio"],
	["bdf", "application/x-font-bdf"],
	["bdm", "application/vnd.syncml.dm+wbxml"],
	["bdoc", "application/x-bdoc"],
	["bed", "application/vnd.realvnc.bed"],
	["bh2", "application/vnd.fujitsu.oasysprs"],
	["bin", "application/octet-stream"],
	["blb", "application/x-blorb"],
	["blorb", "application/x-blorb"],
	["bmi", "application/vnd.bmi"],
	["bmml", "application/vnd.balsamiq.bmml+xml"],
	["bmp", "image/bmp"],
	["book", "application/vnd.framemaker"],
	["box", "application/vnd.previewsystems.box"],
	["boz", "application/x-bzip2"],
	["bpk", "application/octet-stream"],
	["bpmn", "application/octet-stream"],
	["bsp", "model/vnd.valve.source.compiled-map"],
	["btif", "image/prs.btif"],
	["buffer", "application/octet-stream"],
	["bz", "application/x-bzip"],
	["bz2", "application/x-bzip2"],
	["c", "text/x-c"],
	["c4d", "application/vnd.clonk.c4group"],
	["c4f", "application/vnd.clonk.c4group"],
	["c4g", "application/vnd.clonk.c4group"],
	["c4p", "application/vnd.clonk.c4group"],
	["c4u", "application/vnd.clonk.c4group"],
	["c11amc", "application/vnd.cluetrust.cartomobile-config"],
	["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
	["cab", "application/vnd.ms-cab-compressed"],
	["caf", "audio/x-caf"],
	["cap", "application/vnd.tcpdump.pcap"],
	["car", "application/vnd.curl.car"],
	["cat", "application/vnd.ms-pki.seccat"],
	["cb7", "application/x-cbr"],
	["cba", "application/x-cbr"],
	["cbr", "application/x-cbr"],
	["cbt", "application/x-cbr"],
	["cbz", "application/x-cbr"],
	["cc", "text/x-c"],
	["cco", "application/x-cocoa"],
	["cct", "application/x-director"],
	["ccxml", "application/ccxml+xml"],
	["cdbcmsg", "application/vnd.contact.cmsg"],
	["cda", "application/x-cdf"],
	["cdf", "application/x-netcdf"],
	["cdfx", "application/cdfx+xml"],
	["cdkey", "application/vnd.mediastation.cdkey"],
	["cdmia", "application/cdmi-capability"],
	["cdmic", "application/cdmi-container"],
	["cdmid", "application/cdmi-domain"],
	["cdmio", "application/cdmi-object"],
	["cdmiq", "application/cdmi-queue"],
	["cdr", "application/cdr"],
	["cdx", "chemical/x-cdx"],
	["cdxml", "application/vnd.chemdraw+xml"],
	["cdy", "application/vnd.cinderella"],
	["cer", "application/pkix-cert"],
	["cfs", "application/x-cfs-compressed"],
	["cgm", "image/cgm"],
	["chat", "application/x-chat"],
	["chm", "application/vnd.ms-htmlhelp"],
	["chrt", "application/vnd.kde.kchart"],
	["cif", "chemical/x-cif"],
	["cii", "application/vnd.anser-web-certificate-issue-initiation"],
	["cil", "application/vnd.ms-artgalry"],
	["cjs", "application/node"],
	["cla", "application/vnd.claymore"],
	["class", "application/octet-stream"],
	["clkk", "application/vnd.crick.clicker.keyboard"],
	["clkp", "application/vnd.crick.clicker.palette"],
	["clkt", "application/vnd.crick.clicker.template"],
	["clkw", "application/vnd.crick.clicker.wordbank"],
	["clkx", "application/vnd.crick.clicker"],
	["clp", "application/x-msclip"],
	["cmc", "application/vnd.cosmocaller"],
	["cmdf", "chemical/x-cmdf"],
	["cml", "chemical/x-cml"],
	["cmp", "application/vnd.yellowriver-custom-menu"],
	["cmx", "image/x-cmx"],
	["cod", "application/vnd.rim.cod"],
	["coffee", "text/coffeescript"],
	["com", "application/x-msdownload"],
	["conf", "text/plain"],
	["cpio", "application/x-cpio"],
	["cpp", "text/x-c"],
	["cpt", "application/mac-compactpro"],
	["crd", "application/x-mscardfile"],
	["crl", "application/pkix-crl"],
	["crt", "application/x-x509-ca-cert"],
	["crx", "application/x-chrome-extension"],
	["cryptonote", "application/vnd.rig.cryptonote"],
	["csh", "application/x-csh"],
	["csl", "application/vnd.citationstyles.style+xml"],
	["csml", "chemical/x-csml"],
	["csp", "application/vnd.commonspace"],
	["csr", "application/octet-stream"],
	["css", "text/css"],
	["cst", "application/x-director"],
	["csv", "text/csv"],
	["cu", "application/cu-seeme"],
	["curl", "text/vnd.curl"],
	["cww", "application/prs.cww"],
	["cxt", "application/x-director"],
	["cxx", "text/x-c"],
	["dae", "model/vnd.collada+xml"],
	["daf", "application/vnd.mobius.daf"],
	["dart", "application/vnd.dart"],
	["dataless", "application/vnd.fdsn.seed"],
	["davmount", "application/davmount+xml"],
	["dbf", "application/vnd.dbf"],
	["dbk", "application/docbook+xml"],
	["dcr", "application/x-director"],
	["dcurl", "text/vnd.curl.dcurl"],
	["dd2", "application/vnd.oma.dd2+xml"],
	["ddd", "application/vnd.fujixerox.ddd"],
	["ddf", "application/vnd.syncml.dmddf+xml"],
	["dds", "image/vnd.ms-dds"],
	["deb", "application/x-debian-package"],
	["def", "text/plain"],
	["deploy", "application/octet-stream"],
	["der", "application/x-x509-ca-cert"],
	["dfac", "application/vnd.dreamfactory"],
	["dgc", "application/x-dgc-compressed"],
	["dic", "text/x-c"],
	["dir", "application/x-director"],
	["dis", "application/vnd.mobius.dis"],
	["disposition-notification", "message/disposition-notification"],
	["dist", "application/octet-stream"],
	["distz", "application/octet-stream"],
	["djv", "image/vnd.djvu"],
	["djvu", "image/vnd.djvu"],
	["dll", "application/octet-stream"],
	["dmg", "application/x-apple-diskimage"],
	["dmn", "application/octet-stream"],
	["dmp", "application/vnd.tcpdump.pcap"],
	["dms", "application/octet-stream"],
	["dna", "application/vnd.dna"],
	["doc", "application/msword"],
	["docm", "application/vnd.ms-word.template.macroEnabled.12"],
	["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
	["dot", "application/msword"],
	["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
	["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
	["dp", "application/vnd.osgi.dp"],
	["dpg", "application/vnd.dpgraph"],
	["dra", "audio/vnd.dra"],
	["drle", "image/dicom-rle"],
	["dsc", "text/prs.lines.tag"],
	["dssc", "application/dssc+der"],
	["dtb", "application/x-dtbook+xml"],
	["dtd", "application/xml-dtd"],
	["dts", "audio/vnd.dts"],
	["dtshd", "audio/vnd.dts.hd"],
	["dump", "application/octet-stream"],
	["dvb", "video/vnd.dvb.file"],
	["dvi", "application/x-dvi"],
	["dwd", "application/atsc-dwd+xml"],
	["dwf", "model/vnd.dwf"],
	["dwg", "image/vnd.dwg"],
	["dxf", "image/vnd.dxf"],
	["dxp", "application/vnd.spotfire.dxp"],
	["dxr", "application/x-director"],
	["ear", "application/java-archive"],
	["ecelp4800", "audio/vnd.nuera.ecelp4800"],
	["ecelp7470", "audio/vnd.nuera.ecelp7470"],
	["ecelp9600", "audio/vnd.nuera.ecelp9600"],
	["ecma", "application/ecmascript"],
	["edm", "application/vnd.novadigm.edm"],
	["edx", "application/vnd.novadigm.edx"],
	["efif", "application/vnd.picsel"],
	["ei6", "application/vnd.pg.osasli"],
	["elc", "application/octet-stream"],
	["emf", "image/emf"],
	["eml", "message/rfc822"],
	["emma", "application/emma+xml"],
	["emotionml", "application/emotionml+xml"],
	["emz", "application/x-msmetafile"],
	["eol", "audio/vnd.digital-winds"],
	["eot", "application/vnd.ms-fontobject"],
	["eps", "application/postscript"],
	["epub", "application/epub+zip"],
	["es", "application/ecmascript"],
	["es3", "application/vnd.eszigno3+xml"],
	["esa", "application/vnd.osgi.subsystem"],
	["esf", "application/vnd.epson.esf"],
	["et3", "application/vnd.eszigno3+xml"],
	["etx", "text/x-setext"],
	["eva", "application/x-eva"],
	["evy", "application/x-envoy"],
	["exe", "application/octet-stream"],
	["exi", "application/exi"],
	["exp", "application/express"],
	["exr", "image/aces"],
	["ext", "application/vnd.novadigm.ext"],
	["ez", "application/andrew-inset"],
	["ez2", "application/vnd.ezpix-album"],
	["ez3", "application/vnd.ezpix-package"],
	["f", "text/x-fortran"],
	["f4v", "video/mp4"],
	["f77", "text/x-fortran"],
	["f90", "text/x-fortran"],
	["fbs", "image/vnd.fastbidsheet"],
	["fcdt", "application/vnd.adobe.formscentral.fcdt"],
	["fcs", "application/vnd.isac.fcs"],
	["fdf", "application/vnd.fdf"],
	["fdt", "application/fdt+xml"],
	["fe_launch", "application/vnd.denovo.fcselayout-link"],
	["fg5", "application/vnd.fujitsu.oasysgp"],
	["fgd", "application/x-director"],
	["fh", "image/x-freehand"],
	["fh4", "image/x-freehand"],
	["fh5", "image/x-freehand"],
	["fh7", "image/x-freehand"],
	["fhc", "image/x-freehand"],
	["fig", "application/x-xfig"],
	["fits", "image/fits"],
	["flac", "audio/x-flac"],
	["fli", "video/x-fli"],
	["flo", "application/vnd.micrografx.flo"],
	["flv", "video/x-flv"],
	["flw", "application/vnd.kde.kivio"],
	["flx", "text/vnd.fmi.flexstor"],
	["fly", "text/vnd.fly"],
	["fm", "application/vnd.framemaker"],
	["fnc", "application/vnd.frogans.fnc"],
	["fo", "application/vnd.software602.filler.form+xml"],
	["for", "text/x-fortran"],
	["fpx", "image/vnd.fpx"],
	["frame", "application/vnd.framemaker"],
	["fsc", "application/vnd.fsc.weblaunch"],
	["fst", "image/vnd.fst"],
	["ftc", "application/vnd.fluxtime.clip"],
	["fti", "application/vnd.anser-web-funds-transfer-initiation"],
	["fvt", "video/vnd.fvt"],
	["fxp", "application/vnd.adobe.fxp"],
	["fxpl", "application/vnd.adobe.fxp"],
	["fzs", "application/vnd.fuzzysheet"],
	["g2w", "application/vnd.geoplan"],
	["g3", "image/g3fax"],
	["g3w", "application/vnd.geospace"],
	["gac", "application/vnd.groove-account"],
	["gam", "application/x-tads"],
	["gbr", "application/rpki-ghostbusters"],
	["gca", "application/x-gca-compressed"],
	["gdl", "model/vnd.gdl"],
	["gdoc", "application/vnd.google-apps.document"],
	["geo", "application/vnd.dynageo"],
	["geojson", "application/geo+json"],
	["gex", "application/vnd.geometry-explorer"],
	["ggb", "application/vnd.geogebra.file"],
	["ggt", "application/vnd.geogebra.tool"],
	["ghf", "application/vnd.groove-help"],
	["gif", "image/gif"],
	["gim", "application/vnd.groove-identity-message"],
	["glb", "model/gltf-binary"],
	["gltf", "model/gltf+json"],
	["gml", "application/gml+xml"],
	["gmx", "application/vnd.gmx"],
	["gnumeric", "application/x-gnumeric"],
	["gpg", "application/gpg-keys"],
	["gph", "application/vnd.flographit"],
	["gpx", "application/gpx+xml"],
	["gqf", "application/vnd.grafeq"],
	["gqs", "application/vnd.grafeq"],
	["gram", "application/srgs"],
	["gramps", "application/x-gramps-xml"],
	["gre", "application/vnd.geometry-explorer"],
	["grv", "application/vnd.groove-injector"],
	["grxml", "application/srgs+xml"],
	["gsf", "application/x-font-ghostscript"],
	["gsheet", "application/vnd.google-apps.spreadsheet"],
	["gslides", "application/vnd.google-apps.presentation"],
	["gtar", "application/x-gtar"],
	["gtm", "application/vnd.groove-tool-message"],
	["gtw", "model/vnd.gtw"],
	["gv", "text/vnd.graphviz"],
	["gxf", "application/gxf"],
	["gxt", "application/vnd.geonext"],
	["gz", "application/gzip"],
	["gzip", "application/gzip"],
	["h", "text/x-c"],
	["h261", "video/h261"],
	["h263", "video/h263"],
	["h264", "video/h264"],
	["hal", "application/vnd.hal+xml"],
	["hbci", "application/vnd.hbci"],
	["hbs", "text/x-handlebars-template"],
	["hdd", "application/x-virtualbox-hdd"],
	["hdf", "application/x-hdf"],
	["heic", "image/heic"],
	["heics", "image/heic-sequence"],
	["heif", "image/heif"],
	["heifs", "image/heif-sequence"],
	["hej2", "image/hej2k"],
	["held", "application/atsc-held+xml"],
	["hh", "text/x-c"],
	["hjson", "application/hjson"],
	["hlp", "application/winhlp"],
	["hpgl", "application/vnd.hp-hpgl"],
	["hpid", "application/vnd.hp-hpid"],
	["hps", "application/vnd.hp-hps"],
	["hqx", "application/mac-binhex40"],
	["hsj2", "image/hsj2"],
	["htc", "text/x-component"],
	["htke", "application/vnd.kenameaapp"],
	["htm", "text/html"],
	["html", "text/html"],
	["hvd", "application/vnd.yamaha.hv-dic"],
	["hvp", "application/vnd.yamaha.hv-voice"],
	["hvs", "application/vnd.yamaha.hv-script"],
	["i2g", "application/vnd.intergeo"],
	["icc", "application/vnd.iccprofile"],
	["ice", "x-conference/x-cooltalk"],
	["icm", "application/vnd.iccprofile"],
	["ico", "image/x-icon"],
	["ics", "text/calendar"],
	["ief", "image/ief"],
	["ifb", "text/calendar"],
	["ifm", "application/vnd.shana.informed.formdata"],
	["iges", "model/iges"],
	["igl", "application/vnd.igloader"],
	["igm", "application/vnd.insors.igm"],
	["igs", "model/iges"],
	["igx", "application/vnd.micrografx.igx"],
	["iif", "application/vnd.shana.informed.interchange"],
	["img", "application/octet-stream"],
	["imp", "application/vnd.accpac.simply.imp"],
	["ims", "application/vnd.ms-ims"],
	["in", "text/plain"],
	["ini", "text/plain"],
	["ink", "application/inkml+xml"],
	["inkml", "application/inkml+xml"],
	["install", "application/x-install-instructions"],
	["iota", "application/vnd.astraea-software.iota"],
	["ipfix", "application/ipfix"],
	["ipk", "application/vnd.shana.informed.package"],
	["irm", "application/vnd.ibm.rights-management"],
	["irp", "application/vnd.irepository.package+xml"],
	["iso", "application/x-iso9660-image"],
	["itp", "application/vnd.shana.informed.formtemplate"],
	["its", "application/its+xml"],
	["ivp", "application/vnd.immervision-ivp"],
	["ivu", "application/vnd.immervision-ivu"],
	["jad", "text/vnd.sun.j2me.app-descriptor"],
	["jade", "text/jade"],
	["jam", "application/vnd.jam"],
	["jar", "application/java-archive"],
	["jardiff", "application/x-java-archive-diff"],
	["java", "text/x-java-source"],
	["jhc", "image/jphc"],
	["jisp", "application/vnd.jisp"],
	["jls", "image/jls"],
	["jlt", "application/vnd.hp-jlyt"],
	["jng", "image/x-jng"],
	["jnlp", "application/x-java-jnlp-file"],
	["joda", "application/vnd.joost.joda-archive"],
	["jp2", "image/jp2"],
	["jpe", "image/jpeg"],
	["jpeg", "image/jpeg"],
	["jpf", "image/jpx"],
	["jpg", "image/jpeg"],
	["jpg2", "image/jp2"],
	["jpgm", "video/jpm"],
	["jpgv", "video/jpeg"],
	["jph", "image/jph"],
	["jpm", "video/jpm"],
	["jpx", "image/jpx"],
	["js", "application/javascript"],
	["json", "application/json"],
	["json5", "application/json5"],
	["jsonld", "application/ld+json"],
	["jsonl", "application/jsonl"],
	["jsonml", "application/jsonml+json"],
	["jsx", "text/jsx"],
	["jxr", "image/jxr"],
	["jxra", "image/jxra"],
	["jxrs", "image/jxrs"],
	["jxs", "image/jxs"],
	["jxsc", "image/jxsc"],
	["jxsi", "image/jxsi"],
	["jxss", "image/jxss"],
	["kar", "audio/midi"],
	["karbon", "application/vnd.kde.karbon"],
	["kdb", "application/octet-stream"],
	["kdbx", "application/x-keepass2"],
	["key", "application/x-iwork-keynote-sffkey"],
	["kfo", "application/vnd.kde.kformula"],
	["kia", "application/vnd.kidspiration"],
	["kml", "application/vnd.google-earth.kml+xml"],
	["kmz", "application/vnd.google-earth.kmz"],
	["kne", "application/vnd.kinar"],
	["knp", "application/vnd.kinar"],
	["kon", "application/vnd.kde.kontour"],
	["kpr", "application/vnd.kde.kpresenter"],
	["kpt", "application/vnd.kde.kpresenter"],
	["kpxx", "application/vnd.ds-keypoint"],
	["ksp", "application/vnd.kde.kspread"],
	["ktr", "application/vnd.kahootz"],
	["ktx", "image/ktx"],
	["ktx2", "image/ktx2"],
	["ktz", "application/vnd.kahootz"],
	["kwd", "application/vnd.kde.kword"],
	["kwt", "application/vnd.kde.kword"],
	["lasxml", "application/vnd.las.las+xml"],
	["latex", "application/x-latex"],
	["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
	["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
	["les", "application/vnd.hhe.lesson-player"],
	["less", "text/less"],
	["lgr", "application/lgr+xml"],
	["lha", "application/octet-stream"],
	["link66", "application/vnd.route66.link66+xml"],
	["list", "text/plain"],
	["list3820", "application/vnd.ibm.modcap"],
	["listafp", "application/vnd.ibm.modcap"],
	["litcoffee", "text/coffeescript"],
	["lnk", "application/x-ms-shortcut"],
	["log", "text/plain"],
	["lostxml", "application/lost+xml"],
	["lrf", "application/octet-stream"],
	["lrm", "application/vnd.ms-lrm"],
	["ltf", "application/vnd.frogans.ltf"],
	["lua", "text/x-lua"],
	["luac", "application/x-lua-bytecode"],
	["lvp", "audio/vnd.lucent.voice"],
	["lwp", "application/vnd.lotus-wordpro"],
	["lzh", "application/octet-stream"],
	["m1v", "video/mpeg"],
	["m2a", "audio/mpeg"],
	["m2v", "video/mpeg"],
	["m3a", "audio/mpeg"],
	["m3u", "text/plain"],
	["m3u8", "application/vnd.apple.mpegurl"],
	["m4a", "audio/x-m4a"],
	["m4p", "application/mp4"],
	["m4s", "video/iso.segment"],
	["m4u", "application/vnd.mpegurl"],
	["m4v", "video/x-m4v"],
	["m13", "application/x-msmediaview"],
	["m14", "application/x-msmediaview"],
	["m21", "application/mp21"],
	["ma", "application/mathematica"],
	["mads", "application/mads+xml"],
	["maei", "application/mmt-aei+xml"],
	["mag", "application/vnd.ecowin.chart"],
	["maker", "application/vnd.framemaker"],
	["man", "text/troff"],
	["manifest", "text/cache-manifest"],
	["map", "application/json"],
	["mar", "application/octet-stream"],
	["markdown", "text/markdown"],
	["mathml", "application/mathml+xml"],
	["mb", "application/mathematica"],
	["mbk", "application/vnd.mobius.mbk"],
	["mbox", "application/mbox"],
	["mc1", "application/vnd.medcalcdata"],
	["mcd", "application/vnd.mcd"],
	["mcurl", "text/vnd.curl.mcurl"],
	["md", "text/markdown"],
	["mdb", "application/x-msaccess"],
	["mdi", "image/vnd.ms-modi"],
	["mdx", "text/mdx"],
	["me", "text/troff"],
	["mesh", "model/mesh"],
	["meta4", "application/metalink4+xml"],
	["metalink", "application/metalink+xml"],
	["mets", "application/mets+xml"],
	["mfm", "application/vnd.mfmp"],
	["mft", "application/rpki-manifest"],
	["mgp", "application/vnd.osgeo.mapguide.package"],
	["mgz", "application/vnd.proteus.magazine"],
	["mid", "audio/midi"],
	["midi", "audio/midi"],
	["mie", "application/x-mie"],
	["mif", "application/vnd.mif"],
	["mime", "message/rfc822"],
	["mj2", "video/mj2"],
	["mjp2", "video/mj2"],
	["mjs", "application/javascript"],
	["mk3d", "video/x-matroska"],
	["mka", "audio/x-matroska"],
	["mkd", "text/x-markdown"],
	["mks", "video/x-matroska"],
	["mkv", "video/x-matroska"],
	["mlp", "application/vnd.dolby.mlp"],
	["mmd", "application/vnd.chipnuts.karaoke-mmd"],
	["mmf", "application/vnd.smaf"],
	["mml", "text/mathml"],
	["mmr", "image/vnd.fujixerox.edmics-mmr"],
	["mng", "video/x-mng"],
	["mny", "application/x-msmoney"],
	["mobi", "application/x-mobipocket-ebook"],
	["mods", "application/mods+xml"],
	["mov", "video/quicktime"],
	["movie", "video/x-sgi-movie"],
	["mp2", "audio/mpeg"],
	["mp2a", "audio/mpeg"],
	["mp3", "audio/mpeg"],
	["mp4", "video/mp4"],
	["mp4a", "audio/mp4"],
	["mp4s", "application/mp4"],
	["mp4v", "video/mp4"],
	["mp21", "application/mp21"],
	["mpc", "application/vnd.mophun.certificate"],
	["mpd", "application/dash+xml"],
	["mpe", "video/mpeg"],
	["mpeg", "video/mpeg"],
	["mpg", "video/mpeg"],
	["mpg4", "video/mp4"],
	["mpga", "audio/mpeg"],
	["mpkg", "application/vnd.apple.installer+xml"],
	["mpm", "application/vnd.blueice.multipass"],
	["mpn", "application/vnd.mophun.application"],
	["mpp", "application/vnd.ms-project"],
	["mpt", "application/vnd.ms-project"],
	["mpy", "application/vnd.ibm.minipay"],
	["mqy", "application/vnd.mobius.mqy"],
	["mrc", "application/marc"],
	["mrcx", "application/marcxml+xml"],
	["ms", "text/troff"],
	["mscml", "application/mediaservercontrol+xml"],
	["mseed", "application/vnd.fdsn.mseed"],
	["mseq", "application/vnd.mseq"],
	["msf", "application/vnd.epson.msf"],
	["msg", "application/vnd.ms-outlook"],
	["msh", "model/mesh"],
	["msi", "application/x-msdownload"],
	["msl", "application/vnd.mobius.msl"],
	["msm", "application/octet-stream"],
	["msp", "application/octet-stream"],
	["msty", "application/vnd.muvee.style"],
	["mtl", "model/mtl"],
	["mts", "model/vnd.mts"],
	["mus", "application/vnd.musician"],
	["musd", "application/mmt-usd+xml"],
	["musicxml", "application/vnd.recordare.musicxml+xml"],
	["mvb", "application/x-msmediaview"],
	["mvt", "application/vnd.mapbox-vector-tile"],
	["mwf", "application/vnd.mfer"],
	["mxf", "application/mxf"],
	["mxl", "application/vnd.recordare.musicxml"],
	["mxmf", "audio/mobile-xmf"],
	["mxml", "application/xv+xml"],
	["mxs", "application/vnd.triscape.mxs"],
	["mxu", "video/vnd.mpegurl"],
	["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
	["n3", "text/n3"],
	["nb", "application/mathematica"],
	["nbp", "application/vnd.wolfram.player"],
	["nc", "application/x-netcdf"],
	["ncx", "application/x-dtbncx+xml"],
	["nfo", "text/x-nfo"],
	["ngdat", "application/vnd.nokia.n-gage.data"],
	["nitf", "application/vnd.nitf"],
	["nlu", "application/vnd.neurolanguage.nlu"],
	["nml", "application/vnd.enliven"],
	["nnd", "application/vnd.noblenet-directory"],
	["nns", "application/vnd.noblenet-sealer"],
	["nnw", "application/vnd.noblenet-web"],
	["npx", "image/vnd.net-fpx"],
	["nq", "application/n-quads"],
	["nsc", "application/x-conference"],
	["nsf", "application/vnd.lotus-notes"],
	["nt", "application/n-triples"],
	["ntf", "application/vnd.nitf"],
	["numbers", "application/x-iwork-numbers-sffnumbers"],
	["nzb", "application/x-nzb"],
	["oa2", "application/vnd.fujitsu.oasys2"],
	["oa3", "application/vnd.fujitsu.oasys3"],
	["oas", "application/vnd.fujitsu.oasys"],
	["obd", "application/x-msbinder"],
	["obgx", "application/vnd.openblox.game+xml"],
	["obj", "model/obj"],
	["oda", "application/oda"],
	["odb", "application/vnd.oasis.opendocument.database"],
	["odc", "application/vnd.oasis.opendocument.chart"],
	["odf", "application/vnd.oasis.opendocument.formula"],
	["odft", "application/vnd.oasis.opendocument.formula-template"],
	["odg", "application/vnd.oasis.opendocument.graphics"],
	["odi", "application/vnd.oasis.opendocument.image"],
	["odm", "application/vnd.oasis.opendocument.text-master"],
	["odp", "application/vnd.oasis.opendocument.presentation"],
	["ods", "application/vnd.oasis.opendocument.spreadsheet"],
	["odt", "application/vnd.oasis.opendocument.text"],
	["oga", "audio/ogg"],
	["ogex", "model/vnd.opengex"],
	["ogg", "audio/ogg"],
	["ogv", "video/ogg"],
	["ogx", "application/ogg"],
	["omdoc", "application/omdoc+xml"],
	["onepkg", "application/onenote"],
	["onetmp", "application/onenote"],
	["onetoc", "application/onenote"],
	["onetoc2", "application/onenote"],
	["opf", "application/oebps-package+xml"],
	["opml", "text/x-opml"],
	["oprc", "application/vnd.palm"],
	["opus", "audio/ogg"],
	["org", "text/x-org"],
	["osf", "application/vnd.yamaha.openscoreformat"],
	["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
	["osm", "application/vnd.openstreetmap.data+xml"],
	["otc", "application/vnd.oasis.opendocument.chart-template"],
	["otf", "font/otf"],
	["otg", "application/vnd.oasis.opendocument.graphics-template"],
	["oth", "application/vnd.oasis.opendocument.text-web"],
	["oti", "application/vnd.oasis.opendocument.image-template"],
	["otp", "application/vnd.oasis.opendocument.presentation-template"],
	["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
	["ott", "application/vnd.oasis.opendocument.text-template"],
	["ova", "application/x-virtualbox-ova"],
	["ovf", "application/x-virtualbox-ovf"],
	["owl", "application/rdf+xml"],
	["oxps", "application/oxps"],
	["oxt", "application/vnd.openofficeorg.extension"],
	["p", "text/x-pascal"],
	["p7a", "application/x-pkcs7-signature"],
	["p7b", "application/x-pkcs7-certificates"],
	["p7c", "application/pkcs7-mime"],
	["p7m", "application/pkcs7-mime"],
	["p7r", "application/x-pkcs7-certreqresp"],
	["p7s", "application/pkcs7-signature"],
	["p8", "application/pkcs8"],
	["p10", "application/x-pkcs10"],
	["p12", "application/x-pkcs12"],
	["pac", "application/x-ns-proxy-autoconfig"],
	["pages", "application/x-iwork-pages-sffpages"],
	["pas", "text/x-pascal"],
	["paw", "application/vnd.pawaafile"],
	["pbd", "application/vnd.powerbuilder6"],
	["pbm", "image/x-portable-bitmap"],
	["pcap", "application/vnd.tcpdump.pcap"],
	["pcf", "application/x-font-pcf"],
	["pcl", "application/vnd.hp-pcl"],
	["pclxl", "application/vnd.hp-pclxl"],
	["pct", "image/x-pict"],
	["pcurl", "application/vnd.curl.pcurl"],
	["pcx", "image/x-pcx"],
	["pdb", "application/x-pilot"],
	["pde", "text/x-processing"],
	["pdf", "application/pdf"],
	["pem", "application/x-x509-user-cert"],
	["pfa", "application/x-font-type1"],
	["pfb", "application/x-font-type1"],
	["pfm", "application/x-font-type1"],
	["pfr", "application/font-tdpfr"],
	["pfx", "application/x-pkcs12"],
	["pgm", "image/x-portable-graymap"],
	["pgn", "application/x-chess-pgn"],
	["pgp", "application/pgp"],
	["php", "application/x-httpd-php"],
	["php3", "application/x-httpd-php"],
	["php4", "application/x-httpd-php"],
	["phps", "application/x-httpd-php-source"],
	["phtml", "application/x-httpd-php"],
	["pic", "image/x-pict"],
	["pkg", "application/octet-stream"],
	["pki", "application/pkixcmp"],
	["pkipath", "application/pkix-pkipath"],
	["pkpass", "application/vnd.apple.pkpass"],
	["pl", "application/x-perl"],
	["plb", "application/vnd.3gpp.pic-bw-large"],
	["plc", "application/vnd.mobius.plc"],
	["plf", "application/vnd.pocketlearn"],
	["pls", "application/pls+xml"],
	["pm", "application/x-perl"],
	["pml", "application/vnd.ctc-posml"],
	["png", "image/png"],
	["pnm", "image/x-portable-anymap"],
	["portpkg", "application/vnd.macports.portpkg"],
	["pot", "application/vnd.ms-powerpoint"],
	["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
	["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
	["ppa", "application/vnd.ms-powerpoint"],
	["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
	["ppd", "application/vnd.cups-ppd"],
	["ppm", "image/x-portable-pixmap"],
	["pps", "application/vnd.ms-powerpoint"],
	["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
	["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
	["ppt", "application/powerpoint"],
	["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
	["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
	["pqa", "application/vnd.palm"],
	["prc", "application/x-pilot"],
	["pre", "application/vnd.lotus-freelance"],
	["prf", "application/pics-rules"],
	["provx", "application/provenance+xml"],
	["ps", "application/postscript"],
	["psb", "application/vnd.3gpp.pic-bw-small"],
	["psd", "application/x-photoshop"],
	["psf", "application/x-font-linux-psf"],
	["pskcxml", "application/pskc+xml"],
	["pti", "image/prs.pti"],
	["ptid", "application/vnd.pvi.ptid1"],
	["pub", "application/x-mspublisher"],
	["pvb", "application/vnd.3gpp.pic-bw-var"],
	["pwn", "application/vnd.3m.post-it-notes"],
	["pya", "audio/vnd.ms-playready.media.pya"],
	["pyv", "video/vnd.ms-playready.media.pyv"],
	["qam", "application/vnd.epson.quickanime"],
	["qbo", "application/vnd.intu.qbo"],
	["qfx", "application/vnd.intu.qfx"],
	["qps", "application/vnd.publishare-delta-tree"],
	["qt", "video/quicktime"],
	["qwd", "application/vnd.quark.quarkxpress"],
	["qwt", "application/vnd.quark.quarkxpress"],
	["qxb", "application/vnd.quark.quarkxpress"],
	["qxd", "application/vnd.quark.quarkxpress"],
	["qxl", "application/vnd.quark.quarkxpress"],
	["qxt", "application/vnd.quark.quarkxpress"],
	["ra", "audio/x-realaudio"],
	["ram", "audio/x-pn-realaudio"],
	["raml", "application/raml+yaml"],
	["rapd", "application/route-apd+xml"],
	["rar", "application/x-rar"],
	["ras", "image/x-cmu-raster"],
	["rcprofile", "application/vnd.ipunplugged.rcprofile"],
	["rdf", "application/rdf+xml"],
	["rdz", "application/vnd.data-vision.rdz"],
	["relo", "application/p2p-overlay+xml"],
	["rep", "application/vnd.businessobjects"],
	["res", "application/x-dtbresource+xml"],
	["rgb", "image/x-rgb"],
	["rif", "application/reginfo+xml"],
	["rip", "audio/vnd.rip"],
	["ris", "application/x-research-info-systems"],
	["rl", "application/resource-lists+xml"],
	["rlc", "image/vnd.fujixerox.edmics-rlc"],
	["rld", "application/resource-lists-diff+xml"],
	["rm", "audio/x-pn-realaudio"],
	["rmi", "audio/midi"],
	["rmp", "audio/x-pn-realaudio-plugin"],
	["rms", "application/vnd.jcp.javame.midlet-rms"],
	["rmvb", "application/vnd.rn-realmedia-vbr"],
	["rnc", "application/relax-ng-compact-syntax"],
	["rng", "application/xml"],
	["roa", "application/rpki-roa"],
	["roff", "text/troff"],
	["rp9", "application/vnd.cloanto.rp9"],
	["rpm", "audio/x-pn-realaudio-plugin"],
	["rpss", "application/vnd.nokia.radio-presets"],
	["rpst", "application/vnd.nokia.radio-preset"],
	["rq", "application/sparql-query"],
	["rs", "application/rls-services+xml"],
	["rsa", "application/x-pkcs7"],
	["rsat", "application/atsc-rsat+xml"],
	["rsd", "application/rsd+xml"],
	["rsheet", "application/urc-ressheet+xml"],
	["rss", "application/rss+xml"],
	["rtf", "text/rtf"],
	["rtx", "text/richtext"],
	["run", "application/x-makeself"],
	["rusd", "application/route-usd+xml"],
	["rv", "video/vnd.rn-realvideo"],
	["s", "text/x-asm"],
	["s3m", "audio/s3m"],
	["saf", "application/vnd.yamaha.smaf-audio"],
	["sass", "text/x-sass"],
	["sbml", "application/sbml+xml"],
	["sc", "application/vnd.ibm.secure-container"],
	["scd", "application/x-msschedule"],
	["scm", "application/vnd.lotus-screencam"],
	["scq", "application/scvp-cv-request"],
	["scs", "application/scvp-cv-response"],
	["scss", "text/x-scss"],
	["scurl", "text/vnd.curl.scurl"],
	["sda", "application/vnd.stardivision.draw"],
	["sdc", "application/vnd.stardivision.calc"],
	["sdd", "application/vnd.stardivision.impress"],
	["sdkd", "application/vnd.solent.sdkm+xml"],
	["sdkm", "application/vnd.solent.sdkm+xml"],
	["sdp", "application/sdp"],
	["sdw", "application/vnd.stardivision.writer"],
	["sea", "application/octet-stream"],
	["see", "application/vnd.seemail"],
	["seed", "application/vnd.fdsn.seed"],
	["sema", "application/vnd.sema"],
	["semd", "application/vnd.semd"],
	["semf", "application/vnd.semf"],
	["senmlx", "application/senml+xml"],
	["sensmlx", "application/sensml+xml"],
	["ser", "application/java-serialized-object"],
	["setpay", "application/set-payment-initiation"],
	["setreg", "application/set-registration-initiation"],
	["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
	["sfs", "application/vnd.spotfire.sfs"],
	["sfv", "text/x-sfv"],
	["sgi", "image/sgi"],
	["sgl", "application/vnd.stardivision.writer-global"],
	["sgm", "text/sgml"],
	["sgml", "text/sgml"],
	["sh", "application/x-sh"],
	["shar", "application/x-shar"],
	["shex", "text/shex"],
	["shf", "application/shf+xml"],
	["shtml", "text/html"],
	["sid", "image/x-mrsid-image"],
	["sieve", "application/sieve"],
	["sig", "application/pgp-signature"],
	["sil", "audio/silk"],
	["silo", "model/mesh"],
	["sis", "application/vnd.symbian.install"],
	["sisx", "application/vnd.symbian.install"],
	["sit", "application/x-stuffit"],
	["sitx", "application/x-stuffitx"],
	["siv", "application/sieve"],
	["skd", "application/vnd.koan"],
	["skm", "application/vnd.koan"],
	["skp", "application/vnd.koan"],
	["skt", "application/vnd.koan"],
	["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
	["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
	["slim", "text/slim"],
	["slm", "text/slim"],
	["sls", "application/route-s-tsid+xml"],
	["slt", "application/vnd.epson.salt"],
	["sm", "application/vnd.stepmania.stepchart"],
	["smf", "application/vnd.stardivision.math"],
	["smi", "application/smil"],
	["smil", "application/smil"],
	["smv", "video/x-smv"],
	["smzip", "application/vnd.stepmania.package"],
	["snd", "audio/basic"],
	["snf", "application/x-font-snf"],
	["so", "application/octet-stream"],
	["spc", "application/x-pkcs7-certificates"],
	["spdx", "text/spdx"],
	["spf", "application/vnd.yamaha.smaf-phrase"],
	["spl", "application/x-futuresplash"],
	["spot", "text/vnd.in3d.spot"],
	["spp", "application/scvp-vp-response"],
	["spq", "application/scvp-vp-request"],
	["spx", "audio/ogg"],
	["sql", "application/x-sql"],
	["src", "application/x-wais-source"],
	["srt", "application/x-subrip"],
	["sru", "application/sru+xml"],
	["srx", "application/sparql-results+xml"],
	["ssdl", "application/ssdl+xml"],
	["sse", "application/vnd.kodak-descriptor"],
	["ssf", "application/vnd.epson.ssf"],
	["ssml", "application/ssml+xml"],
	["sst", "application/octet-stream"],
	["st", "application/vnd.sailingtracker.track"],
	["stc", "application/vnd.sun.xml.calc.template"],
	["std", "application/vnd.sun.xml.draw.template"],
	["stf", "application/vnd.wt.stf"],
	["sti", "application/vnd.sun.xml.impress.template"],
	["stk", "application/hyperstudio"],
	["stl", "model/stl"],
	["stpx", "model/step+xml"],
	["stpxz", "model/step-xml+zip"],
	["stpz", "model/step+zip"],
	["str", "application/vnd.pg.format"],
	["stw", "application/vnd.sun.xml.writer.template"],
	["styl", "text/stylus"],
	["stylus", "text/stylus"],
	["sub", "text/vnd.dvb.subtitle"],
	["sus", "application/vnd.sus-calendar"],
	["susp", "application/vnd.sus-calendar"],
	["sv4cpio", "application/x-sv4cpio"],
	["sv4crc", "application/x-sv4crc"],
	["svc", "application/vnd.dvb.service"],
	["svd", "application/vnd.svd"],
	["svg", "image/svg+xml"],
	["svgz", "image/svg+xml"],
	["swa", "application/x-director"],
	["swf", "application/x-shockwave-flash"],
	["swi", "application/vnd.aristanetworks.swi"],
	["swidtag", "application/swid+xml"],
	["sxc", "application/vnd.sun.xml.calc"],
	["sxd", "application/vnd.sun.xml.draw"],
	["sxg", "application/vnd.sun.xml.writer.global"],
	["sxi", "application/vnd.sun.xml.impress"],
	["sxm", "application/vnd.sun.xml.math"],
	["sxw", "application/vnd.sun.xml.writer"],
	["t", "text/troff"],
	["t3", "application/x-t3vm-image"],
	["t38", "image/t38"],
	["taglet", "application/vnd.mynfc"],
	["tao", "application/vnd.tao.intent-module-archive"],
	["tap", "image/vnd.tencent.tap"],
	["tar", "application/x-tar"],
	["tcap", "application/vnd.3gpp2.tcap"],
	["tcl", "application/x-tcl"],
	["td", "application/urc-targetdesc+xml"],
	["teacher", "application/vnd.smart.teacher"],
	["tei", "application/tei+xml"],
	["teicorpus", "application/tei+xml"],
	["tex", "application/x-tex"],
	["texi", "application/x-texinfo"],
	["texinfo", "application/x-texinfo"],
	["text", "text/plain"],
	["tfi", "application/thraud+xml"],
	["tfm", "application/x-tex-tfm"],
	["tfx", "image/tiff-fx"],
	["tga", "image/x-tga"],
	["tgz", "application/x-tar"],
	["thmx", "application/vnd.ms-officetheme"],
	["tif", "image/tiff"],
	["tiff", "image/tiff"],
	["tk", "application/x-tcl"],
	["tmo", "application/vnd.tmobile-livetv"],
	["toml", "application/toml"],
	["torrent", "application/x-bittorrent"],
	["tpl", "application/vnd.groove-tool-template"],
	["tpt", "application/vnd.trid.tpt"],
	["tr", "text/troff"],
	["tra", "application/vnd.trueapp"],
	["trig", "application/trig"],
	["trm", "application/x-msterminal"],
	["ts", "video/mp2t"],
	["tsd", "application/timestamped-data"],
	["tsv", "text/tab-separated-values"],
	["ttc", "font/collection"],
	["ttf", "font/ttf"],
	["ttl", "text/turtle"],
	["ttml", "application/ttml+xml"],
	["twd", "application/vnd.simtech-mindmapper"],
	["twds", "application/vnd.simtech-mindmapper"],
	["txd", "application/vnd.genomatix.tuxedo"],
	["txf", "application/vnd.mobius.txf"],
	["txt", "text/plain"],
	["u8dsn", "message/global-delivery-status"],
	["u8hdr", "message/global-headers"],
	["u8mdn", "message/global-disposition-notification"],
	["u8msg", "message/global"],
	["u32", "application/x-authorware-bin"],
	["ubj", "application/ubjson"],
	["udeb", "application/x-debian-package"],
	["ufd", "application/vnd.ufdl"],
	["ufdl", "application/vnd.ufdl"],
	["ulx", "application/x-glulx"],
	["umj", "application/vnd.umajin"],
	["unityweb", "application/vnd.unity"],
	["uoml", "application/vnd.uoml+xml"],
	["uri", "text/uri-list"],
	["uris", "text/uri-list"],
	["urls", "text/uri-list"],
	["usdz", "model/vnd.usdz+zip"],
	["ustar", "application/x-ustar"],
	["utz", "application/vnd.uiq.theme"],
	["uu", "text/x-uuencode"],
	["uva", "audio/vnd.dece.audio"],
	["uvd", "application/vnd.dece.data"],
	["uvf", "application/vnd.dece.data"],
	["uvg", "image/vnd.dece.graphic"],
	["uvh", "video/vnd.dece.hd"],
	["uvi", "image/vnd.dece.graphic"],
	["uvm", "video/vnd.dece.mobile"],
	["uvp", "video/vnd.dece.pd"],
	["uvs", "video/vnd.dece.sd"],
	["uvt", "application/vnd.dece.ttml+xml"],
	["uvu", "video/vnd.uvvu.mp4"],
	["uvv", "video/vnd.dece.video"],
	["uvva", "audio/vnd.dece.audio"],
	["uvvd", "application/vnd.dece.data"],
	["uvvf", "application/vnd.dece.data"],
	["uvvg", "image/vnd.dece.graphic"],
	["uvvh", "video/vnd.dece.hd"],
	["uvvi", "image/vnd.dece.graphic"],
	["uvvm", "video/vnd.dece.mobile"],
	["uvvp", "video/vnd.dece.pd"],
	["uvvs", "video/vnd.dece.sd"],
	["uvvt", "application/vnd.dece.ttml+xml"],
	["uvvu", "video/vnd.uvvu.mp4"],
	["uvvv", "video/vnd.dece.video"],
	["uvvx", "application/vnd.dece.unspecified"],
	["uvvz", "application/vnd.dece.zip"],
	["uvx", "application/vnd.dece.unspecified"],
	["uvz", "application/vnd.dece.zip"],
	["vbox", "application/x-virtualbox-vbox"],
	["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
	["vcard", "text/vcard"],
	["vcd", "application/x-cdlink"],
	["vcf", "text/x-vcard"],
	["vcg", "application/vnd.groove-vcard"],
	["vcs", "text/x-vcalendar"],
	["vcx", "application/vnd.vcx"],
	["vdi", "application/x-virtualbox-vdi"],
	["vds", "model/vnd.sap.vds"],
	["vhd", "application/x-virtualbox-vhd"],
	["vis", "application/vnd.visionary"],
	["viv", "video/vnd.vivo"],
	["vlc", "application/videolan"],
	["vmdk", "application/x-virtualbox-vmdk"],
	["vob", "video/x-ms-vob"],
	["vor", "application/vnd.stardivision.writer"],
	["vox", "application/x-authorware-bin"],
	["vrml", "model/vrml"],
	["vsd", "application/vnd.visio"],
	["vsf", "application/vnd.vsf"],
	["vss", "application/vnd.visio"],
	["vst", "application/vnd.visio"],
	["vsw", "application/vnd.visio"],
	["vtf", "image/vnd.valve.source.texture"],
	["vtt", "text/vtt"],
	["vtu", "model/vnd.vtu"],
	["vxml", "application/voicexml+xml"],
	["w3d", "application/x-director"],
	["wad", "application/x-doom"],
	["wadl", "application/vnd.sun.wadl+xml"],
	["war", "application/java-archive"],
	["wasm", "application/wasm"],
	["wav", "audio/x-wav"],
	["wax", "audio/x-ms-wax"],
	["wbmp", "image/vnd.wap.wbmp"],
	["wbs", "application/vnd.criticaltools.wbs+xml"],
	["wbxml", "application/wbxml"],
	["wcm", "application/vnd.ms-works"],
	["wdb", "application/vnd.ms-works"],
	["wdp", "image/vnd.ms-photo"],
	["weba", "audio/webm"],
	["webapp", "application/x-web-app-manifest+json"],
	["webm", "video/webm"],
	["webmanifest", "application/manifest+json"],
	["webp", "image/webp"],
	["wg", "application/vnd.pmi.widget"],
	["wgt", "application/widget"],
	["wks", "application/vnd.ms-works"],
	["wm", "video/x-ms-wm"],
	["wma", "audio/x-ms-wma"],
	["wmd", "application/x-ms-wmd"],
	["wmf", "image/wmf"],
	["wml", "text/vnd.wap.wml"],
	["wmlc", "application/wmlc"],
	["wmls", "text/vnd.wap.wmlscript"],
	["wmlsc", "application/vnd.wap.wmlscriptc"],
	["wmv", "video/x-ms-wmv"],
	["wmx", "video/x-ms-wmx"],
	["wmz", "application/x-msmetafile"],
	["woff", "font/woff"],
	["woff2", "font/woff2"],
	["word", "application/msword"],
	["wpd", "application/vnd.wordperfect"],
	["wpl", "application/vnd.ms-wpl"],
	["wps", "application/vnd.ms-works"],
	["wqd", "application/vnd.wqd"],
	["wri", "application/x-mswrite"],
	["wrl", "model/vrml"],
	["wsc", "message/vnd.wfa.wsc"],
	["wsdl", "application/wsdl+xml"],
	["wspolicy", "application/wspolicy+xml"],
	["wtb", "application/vnd.webturbo"],
	["wvx", "video/x-ms-wvx"],
	["x3d", "model/x3d+xml"],
	["x3db", "model/x3d+fastinfoset"],
	["x3dbz", "model/x3d+binary"],
	["x3dv", "model/x3d-vrml"],
	["x3dvz", "model/x3d+vrml"],
	["x3dz", "model/x3d+xml"],
	["x32", "application/x-authorware-bin"],
	["x_b", "model/vnd.parasolid.transmit.binary"],
	["x_t", "model/vnd.parasolid.transmit.text"],
	["xaml", "application/xaml+xml"],
	["xap", "application/x-silverlight-app"],
	["xar", "application/vnd.xara"],
	["xav", "application/xcap-att+xml"],
	["xbap", "application/x-ms-xbap"],
	["xbd", "application/vnd.fujixerox.docuworks.binder"],
	["xbm", "image/x-xbitmap"],
	["xca", "application/xcap-caps+xml"],
	["xcs", "application/calendar+xml"],
	["xdf", "application/xcap-diff+xml"],
	["xdm", "application/vnd.syncml.dm+xml"],
	["xdp", "application/vnd.adobe.xdp+xml"],
	["xdssc", "application/dssc+xml"],
	["xdw", "application/vnd.fujixerox.docuworks"],
	["xel", "application/xcap-el+xml"],
	["xenc", "application/xenc+xml"],
	["xer", "application/patch-ops-error+xml"],
	["xfdf", "application/vnd.adobe.xfdf"],
	["xfdl", "application/vnd.xfdl"],
	["xht", "application/xhtml+xml"],
	["xhtml", "application/xhtml+xml"],
	["xhvml", "application/xv+xml"],
	["xif", "image/vnd.xiff"],
	["xl", "application/excel"],
	["xla", "application/vnd.ms-excel"],
	["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
	["xlc", "application/vnd.ms-excel"],
	["xlf", "application/xliff+xml"],
	["xlm", "application/vnd.ms-excel"],
	["xls", "application/vnd.ms-excel"],
	["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
	["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
	["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
	["xlt", "application/vnd.ms-excel"],
	["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
	["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
	["xlw", "application/vnd.ms-excel"],
	["xm", "audio/xm"],
	["xml", "application/xml"],
	["xns", "application/xcap-ns+xml"],
	["xo", "application/vnd.olpc-sugar"],
	["xop", "application/xop+xml"],
	["xpi", "application/x-xpinstall"],
	["xpl", "application/xproc+xml"],
	["xpm", "image/x-xpixmap"],
	["xpr", "application/vnd.is-xpr"],
	["xps", "application/vnd.ms-xpsdocument"],
	["xpw", "application/vnd.intercon.formnet"],
	["xpx", "application/vnd.intercon.formnet"],
	["xsd", "application/xml"],
	["xsl", "application/xml"],
	["xslt", "application/xslt+xml"],
	["xsm", "application/vnd.syncml+xml"],
	["xspf", "application/xspf+xml"],
	["xul", "application/vnd.mozilla.xul+xml"],
	["xvm", "application/xv+xml"],
	["xvml", "application/xv+xml"],
	["xwd", "image/x-xwindowdump"],
	["xyz", "chemical/x-xyz"],
	["xz", "application/x-xz"],
	["yaml", "text/yaml"],
	["yang", "application/yang"],
	["yin", "application/yin+xml"],
	["yml", "text/yaml"],
	["ymp", "text/x-suse-ymp"],
	["z", "application/x-compress"],
	["z1", "application/x-zmachine"],
	["z2", "application/x-zmachine"],
	["z3", "application/x-zmachine"],
	["z4", "application/x-zmachine"],
	["z5", "application/x-zmachine"],
	["z6", "application/x-zmachine"],
	["z7", "application/x-zmachine"],
	["z8", "application/x-zmachine"],
	["zaz", "application/vnd.zzazz.deck+xml"],
	["zip", "application/zip"],
	["zir", "application/vnd.zul"],
	["zirz", "application/vnd.zul"],
	["zmm", "application/vnd.handheld-entertainment+xml"],
	["zsh", "text/x-scriptzsh"]
]);
function nc(e, t, n) {
	let r = rc(e), { webkitRelativePath: i } = e, a = typeof t == "string" ? t : typeof i == "string" && i.length > 0 ? i : `./${e.name}`;
	return typeof r.path != "string" && ic(r, "path", a), n !== void 0 && Object.defineProperty(r, "handle", {
		value: n,
		writable: !1,
		configurable: !1,
		enumerable: !0
	}), ic(r, "relativePath", a), r;
}
function rc(e) {
	let { name: t } = e;
	if (t && t.lastIndexOf(".") !== -1 && !e.type) {
		let n = t.split(".").pop().toLowerCase(), r = tc.get(n);
		r && Object.defineProperty(e, "type", {
			value: r,
			writable: !1,
			configurable: !1,
			enumerable: !0
		});
	}
	return e;
}
function ic(e, t, n) {
	Object.defineProperty(e, t, {
		value: n,
		writable: !1,
		configurable: !1,
		enumerable: !0
	});
}
//#endregion
//#region ../node_modules/file-selector/dist/es2015/file-selector.js
var ac = [".DS_Store", "Thumbs.db"];
function oc(e) {
	return ec(this, void 0, void 0, function* () {
		return lc(e) && sc(e.dataTransfer) ? fc(e.dataTransfer, e.type) : cc(e) ? uc(e) : Array.isArray(e) && e.every((e) => "getFile" in e && typeof e.getFile == "function") ? dc(e) : [];
	});
}
function sc(e) {
	return lc(e);
}
function cc(e) {
	return lc(e) && lc(e.target);
}
function lc(e) {
	return typeof e == "object" && !!e;
}
function uc(e) {
	return mc(e.target.files).map((e) => nc(e));
}
function dc(e) {
	return ec(this, void 0, void 0, function* () {
		return (yield Promise.all(e.map((e) => e.getFile()))).map((e) => nc(e));
	});
}
function fc(e, t) {
	return ec(this, void 0, void 0, function* () {
		if (e.items) {
			let n = mc(e.items).filter((e) => e.kind === "file");
			return t === "drop" ? pc(gc(yield Promise.all(n.map(hc)))) : n;
		}
		return pc(mc(e.files).map((e) => nc(e)));
	});
}
function pc(e) {
	return e.filter((e) => ac.indexOf(e.name) === -1);
}
function mc(e) {
	if (e === null) return [];
	let t = [];
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		t.push(r);
	}
	return t;
}
function hc(e) {
	if (typeof e.webkitGetAsEntry != "function") return _c(e);
	let t = e.webkitGetAsEntry();
	return t && t.isDirectory ? yc(t) : _c(e, t);
}
function gc(e) {
	return e.reduce((e, t) => [...e, ...Array.isArray(t) ? gc(t) : [t]], []);
}
function _c(e, t) {
	return ec(this, void 0, void 0, function* () {
		if (globalThis.isSecureContext && typeof e.getAsFileSystemHandle == "function") {
			let t = yield e.getAsFileSystemHandle();
			if (t === null) throw Error(`${e} is not a File`);
			if (t !== void 0) {
				let e = yield t.getFile();
				return e.handle = t, nc(e);
			}
		}
		let n = e.getAsFile();
		if (!n) throw Error(`${e} is not a File`);
		return nc(n, t?.fullPath ?? void 0);
	});
}
function vc(e) {
	return ec(this, void 0, void 0, function* () {
		return e.isDirectory ? yc(e) : bc(e);
	});
}
function yc(e) {
	let t = e.createReader();
	return new Promise((e, n) => {
		let r = [];
		function i() {
			t.readEntries((t) => ec(this, void 0, void 0, function* () {
				if (t.length) {
					let e = Promise.all(t.map(vc));
					r.push(e), i();
				} else try {
					e(yield Promise.all(r));
				} catch (e) {
					n(e);
				}
			}), (e) => {
				n(e);
			});
		}
		i();
	});
}
function bc(e) {
	return ec(this, void 0, void 0, function* () {
		return new Promise((t, n) => {
			e.file((n) => {
				t(nc(n, e.fullPath));
			}, (e) => {
				n(e);
			});
		});
	});
}
//#endregion
//#region ../node_modules/react-dropzone/dist/es/utils/index.js
var xc = /* @__PURE__ */ Jr((/* @__PURE__ */ Kr(((e) => {
	e.__esModule = !0, e.default = function(e, t) {
		if (e && t) {
			var n = Array.isArray(t) ? t : t.split(",");
			if (n.length === 0) return !0;
			var r = e.name || "", i = (e.type || "").toLowerCase(), a = i.replace(/\/.*$/, "");
			return n.some(function(e) {
				var t = e.trim().toLowerCase();
				return t.charAt(0) === "." ? r.toLowerCase().endsWith(t) : t.endsWith("/*") ? a === t.replace(/\/.*$/, "") : i === t;
			});
		}
		return !0;
	};
})))());
function Sc(e) {
	return Tc(e) || wc(e) || jc(e) || Cc();
}
function Cc() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function wc(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Tc(e) {
	if (Array.isArray(e)) return Mc(e);
}
function Ec(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Dc(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Ec(Object(n), !0).forEach(function(t) {
			Oc(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ec(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function Oc(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function kc(e, t) {
	return Pc(e) || Nc(e, t) || jc(e, t) || Ac();
}
function Ac() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function jc(e, t) {
	if (e) {
		if (typeof e == "string") return Mc(e, t);
		var n = Object.prototype.toString.call(e).slice(8, -1);
		if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
		if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Mc(e, t);
	}
}
function Mc(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function Nc(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r = [], i = !0, a = !1, o, s;
		try {
			for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0);
		} catch (e) {
			a = !0, s = e;
		} finally {
			try {
				!i && n.return != null && n.return();
			} finally {
				if (a) throw s;
			}
		}
		return r;
	}
}
function Pc(e) {
	if (Array.isArray(e)) return e;
}
var Fc = typeof xc.default == "function" ? xc.default : xc.default.default, Ic = "file-invalid-type", Lc = "file-too-large", Rc = "file-too-small", zc = "too-many-files", Bc = function() {
	var e = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "").split(",");
	return {
		code: Ic,
		message: `File type must be ${e.length > 1 ? `one of ${e.join(", ")}` : e[0]}`
	};
}, Vc = function(e) {
	return {
		code: Lc,
		message: `File is larger than ${e} ${e === 1 ? "byte" : "bytes"}`
	};
}, Hc = function(e) {
	return {
		code: Rc,
		message: `File is smaller than ${e} ${e === 1 ? "byte" : "bytes"}`
	};
}, Uc = {
	code: zc,
	message: "Too many files"
};
function Wc(e) {
	return e.type === "" && typeof e.getAsFile == "function";
}
function Gc(e, t) {
	var n = e.type === "application/x-moz-file" || Fc(e, t) || Wc(e);
	return [n, n ? null : Bc(t)];
}
function Kc(e, t, n) {
	if (qc(e.size)) {
		if (qc(t) && qc(n)) {
			if (e.size > n) return [!1, Vc(n)];
			if (e.size < t) return [!1, Hc(t)];
		} else if (qc(t) && e.size < t) return [!1, Hc(t)];
		else if (qc(n) && e.size > n) return [!1, Vc(n)];
	}
	return [!0, null];
}
function qc(e) {
	return e != null;
}
function Jc(e) {
	var t = e.files, n = e.accept, r = e.minSize, i = e.maxSize, a = e.multiple, o = e.maxFiles, s = e.validator;
	return !a && t.length > 1 || a && o >= 1 && t.length > o ? !1 : t.every(function(e) {
		var t = kc(Gc(e, n), 1)[0], a = kc(Kc(e, r, i), 1)[0], o = s ? s(e) : null;
		return t && a && !o;
	});
}
function Yc(e) {
	return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : e.cancelBubble === void 0 ? !1 : e.cancelBubble;
}
function Xc(e) {
	return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(e) {
		return e === "Files" || e === "application/x-moz-file";
	}) : !!e.target && !!e.target.files;
}
function Zc(e) {
	e.preventDefault();
}
function Qc(e) {
	return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function $c(e) {
	return e.indexOf("Edge/") !== -1;
}
function el() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
	return Qc(e) || $c(e);
}
function tl() {
	var e = [...arguments];
	return function(t) {
		var n = [...arguments].slice(1);
		return e.some(function(e) {
			return !Yc(t) && e && e.apply(void 0, [t].concat(n)), Yc(t);
		});
	};
}
function nl() {
	return "showOpenFilePicker" in window;
}
function rl(e) {
	return qc(e) ? [{
		description: "Files",
		accept: Object.entries(e).filter(function(e) {
			var t = kc(e, 2), n = t[0], r = t[1], i = !0;
			return sl(n) || (console.warn(`Skipped "${n}" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.`), i = !1), (!Array.isArray(r) || !r.every(cl)) && (console.warn(`Skipped "${n}" because an invalid file extension was provided.`), i = !1), i;
		}).reduce(function(e, t) {
			var n = kc(t, 2), r = n[0], i = n[1];
			return Dc(Dc({}, e), {}, Oc({}, r, i));
		}, {})
	}] : e;
}
function il(e) {
	if (qc(e)) return Object.entries(e).reduce(function(e, t) {
		var n = kc(t, 2), r = n[0], i = n[1];
		return [].concat(Sc(e), [r], Sc(i));
	}, []).filter(function(e) {
		return sl(e) || cl(e);
	}).join(",");
}
function al(e) {
	return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function ol(e) {
	return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function sl(e) {
	return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || e === "application/*" || /\w+\/[-+.\w]+/g.test(e);
}
function cl(e) {
	return /^.*\.[\w]+$/.test(e);
}
//#endregion
//#region ../node_modules/react-dropzone/dist/es/index.js
var Q = /* @__PURE__ */ Jr($s()), ll = ["children"], ul = ["open"], dl = [
	"refKey",
	"role",
	"onKeyDown",
	"onFocus",
	"onBlur",
	"onClick",
	"onDragEnter",
	"onDragOver",
	"onDragLeave",
	"onDrop"
], fl = [
	"refKey",
	"onChange",
	"onClick"
];
function pl(e) {
	return gl(e) || hl(e) || yl(e) || ml();
}
function ml() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function hl(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function gl(e) {
	if (Array.isArray(e)) return bl(e);
}
function _l(e, t) {
	return Sl(e) || xl(e, t) || yl(e, t) || vl();
}
function vl() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function yl(e, t) {
	if (e) {
		if (typeof e == "string") return bl(e, t);
		var n = Object.prototype.toString.call(e).slice(8, -1);
		if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
		if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return bl(e, t);
	}
}
function bl(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function xl(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r = [], i = !0, a = !1, o, s;
		try {
			for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0);
		} catch (e) {
			a = !0, s = e;
		} finally {
			try {
				!i && n.return != null && n.return();
			} finally {
				if (a) throw s;
			}
		}
		return r;
	}
}
function Sl(e) {
	if (Array.isArray(e)) return e;
}
function Cl(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function $(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Cl(Object(n), !0).forEach(function(t) {
			wl(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Cl(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function wl(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Tl(e, t) {
	if (e == null) return {};
	var n = El(e, t), r, i;
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (i = 0; i < a.length; i++) r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
	}
	return n;
}
function El(e, t) {
	if (e == null) return {};
	var n = {}, r = Object.keys(e), i, a;
	for (a = 0; a < r.length; a++) i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
	return n;
}
var Dl = /*#__PURE__*/ $n(function(e, t) {
	var n = e.children, r = Al(Tl(e, ll)), i = r.open, a = Tl(r, ul);
	return ir(t, function() {
		return { open: i };
	}, [i]), /*#__PURE__*/ Kn.createElement(Yn, null, n($($({}, a), {}, { open: i })));
});
Dl.displayName = "Dropzone";
var Ol = {
	disabled: !1,
	getFilesFromEvent: oc,
	maxSize: Infinity,
	minSize: 0,
	multiple: !0,
	maxFiles: 0,
	preventDropOnDocument: !0,
	noClick: !1,
	noKeyboard: !1,
	noDrag: !1,
	noDragEventsBubbling: !1,
	validator: null,
	useFsAccessApi: !1,
	autoFocus: !1
};
Dl.defaultProps = Ol, Dl.propTypes = {
	children: Q.default.func,
	accept: Q.default.objectOf(Q.default.arrayOf(Q.default.string)),
	multiple: Q.default.bool,
	preventDropOnDocument: Q.default.bool,
	noClick: Q.default.bool,
	noKeyboard: Q.default.bool,
	noDrag: Q.default.bool,
	noDragEventsBubbling: Q.default.bool,
	minSize: Q.default.number,
	maxSize: Q.default.number,
	maxFiles: Q.default.number,
	disabled: Q.default.bool,
	getFilesFromEvent: Q.default.func,
	onFileDialogCancel: Q.default.func,
	onFileDialogOpen: Q.default.func,
	useFsAccessApi: Q.default.bool,
	autoFocus: Q.default.bool,
	onDragEnter: Q.default.func,
	onDragLeave: Q.default.func,
	onDragOver: Q.default.func,
	onDrop: Q.default.func,
	onDropAccepted: Q.default.func,
	onDropRejected: Q.default.func,
	onError: Q.default.func,
	validator: Q.default.func
};
var kl = {
	isFocused: !1,
	isFileDialogActive: !1,
	isDragActive: !1,
	isDragAccept: !1,
	isDragReject: !1,
	isDragGlobal: !1,
	acceptedFiles: [],
	fileRejections: []
};
function Al() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = $($({}, Ol), e), n = t.accept, r = t.disabled, i = t.getFilesFromEvent, a = t.maxSize, o = t.minSize, s = t.multiple, c = t.maxFiles, l = t.onDragEnter, u = t.onDragLeave, d = t.onDragOver, f = t.onDrop, p = t.onDropAccepted, m = t.onDropRejected, h = t.onFileDialogCancel, g = t.onFileDialogOpen, _ = t.useFsAccessApi, v = t.autoFocus, y = t.preventDropOnDocument, b = t.noClick, x = t.noKeyboard, S = t.noDrag, C = t.noDragEventsBubbling, ee = t.onError, te = t.validator, ne = q(function() {
		return il(n);
	}, [n]), re = q(function() {
		return rl(n);
	}, [n]), ie = q(function() {
		return typeof g == "function" ? g : Ml;
	}, [g]), ae = q(function() {
		return typeof h == "function" ? h : Ml;
	}, [h]), w = J(null), T = J(null), E = _l(or(jl, kl), 2), oe = E[0], D = E[1], se = oe.isFocused, ce = oe.isFileDialogActive, le = J(typeof window < "u" && window.isSecureContext && _ && nl()), ue = function() {
		!le.current && ce && setTimeout(function() {
			T.current && (T.current.files.length || (D({ type: "closeDialog" }), ae()));
		}, 300);
	};
	K(function() {
		return window.addEventListener("focus", ue, !1), function() {
			window.removeEventListener("focus", ue, !1);
		};
	}, [
		T,
		ce,
		ae,
		le
	]);
	var de = J([]), O = J([]), fe = function(e) {
		w.current && w.current.contains(e.target) || (e.preventDefault(), de.current = []);
	};
	K(function() {
		return y && (document.addEventListener("dragover", Zc, !1), document.addEventListener("drop", fe, !1)), function() {
			y && (document.removeEventListener("dragover", Zc), document.removeEventListener("drop", fe));
		};
	}, [w, y]), K(function() {
		var e = function(e) {
			O.current = [].concat(pl(O.current), [e.target]), Xc(e) && D({
				isDragGlobal: !0,
				type: "setDragGlobal"
			});
		}, t = function(e) {
			O.current = O.current.filter(function(t) {
				return t !== e.target && t !== null;
			}), !(O.current.length > 0) && D({
				isDragGlobal: !1,
				type: "setDragGlobal"
			});
		}, n = function() {
			O.current = [], D({
				isDragGlobal: !1,
				type: "setDragGlobal"
			});
		}, r = function() {
			O.current = [], D({
				isDragGlobal: !1,
				type: "setDragGlobal"
			});
		};
		return document.addEventListener("dragenter", e, !1), document.addEventListener("dragleave", t, !1), document.addEventListener("dragend", n, !1), document.addEventListener("drop", r, !1), function() {
			document.removeEventListener("dragenter", e), document.removeEventListener("dragleave", t), document.removeEventListener("dragend", n), document.removeEventListener("drop", r);
		};
	}, [w]), K(function() {
		return !r && v && w.current && w.current.focus(), function() {};
	}, [
		w,
		v,
		r
	]);
	var pe = G(function(e) {
		ee ? ee(e) : console.error(e);
	}, [ee]), me = G(function(e) {
		e.preventDefault(), e.persist(), Ee(e), de.current = [].concat(pl(de.current), [e.target]), Xc(e) && Promise.resolve(i(e)).then(function(t) {
			if (!(Yc(e) && !C)) {
				var n = t.length, r = n > 0 && Jc({
					files: t,
					accept: ne,
					minSize: o,
					maxSize: a,
					multiple: s,
					maxFiles: c,
					validator: te
				});
				D({
					isDragAccept: r,
					isDragReject: n > 0 && !r,
					isDragActive: !0,
					type: "setDraggedFiles"
				}), l && l(e);
			}
		}).catch(function(e) {
			return pe(e);
		});
	}, [
		i,
		l,
		pe,
		C,
		ne,
		o,
		a,
		s,
		c,
		te
	]), he = G(function(e) {
		e.preventDefault(), e.persist(), Ee(e);
		var t = Xc(e);
		if (t && e.dataTransfer) try {
			e.dataTransfer.dropEffect = "copy";
		} catch {}
		return t && d && d(e), !1;
	}, [d, C]), ge = G(function(e) {
		e.preventDefault(), e.persist(), Ee(e);
		var t = de.current.filter(function(e) {
			return w.current && w.current.contains(e);
		}), n = t.indexOf(e.target);
		n !== -1 && t.splice(n, 1), de.current = t, !(t.length > 0) && (D({
			type: "setDraggedFiles",
			isDragActive: !1,
			isDragAccept: !1,
			isDragReject: !1
		}), Xc(e) && u && u(e));
	}, [
		w,
		u,
		C
	]), _e = G(function(e, t) {
		var n = [], r = [];
		e.forEach(function(e) {
			var t = _l(Gc(e, ne), 2), i = t[0], s = t[1], c = _l(Kc(e, o, a), 2), l = c[0], u = c[1], d = te ? te(e) : null;
			if (i && l && !d) n.push(e);
			else {
				var f = [s, u];
				d && (f = f.concat(d)), r.push({
					file: e,
					errors: f.filter(function(e) {
						return e;
					})
				});
			}
		}), (!s && n.length > 1 || s && c >= 1 && n.length > c) && (n.forEach(function(e) {
			r.push({
				file: e,
				errors: [Uc]
			});
		}), n.splice(0)), D({
			acceptedFiles: n,
			fileRejections: r,
			type: "setFiles"
		}), f && f(n, r, t), r.length > 0 && m && m(r, t), n.length > 0 && p && p(n, t);
	}, [
		D,
		s,
		ne,
		o,
		a,
		c,
		f,
		p,
		m,
		te
	]), ve = G(function(e) {
		e.preventDefault(), e.persist(), Ee(e), de.current = [], Xc(e) && Promise.resolve(i(e)).then(function(t) {
			Yc(e) && !C || _e(t, e);
		}).catch(function(e) {
			return pe(e);
		}), D({ type: "reset" });
	}, [
		i,
		_e,
		pe,
		C
	]), k = G(function() {
		if (le.current) {
			D({ type: "openDialog" }), ie();
			var e = {
				multiple: s,
				types: re
			};
			window.showOpenFilePicker(e).then(function(e) {
				return i(e);
			}).then(function(e) {
				_e(e, null), D({ type: "closeDialog" });
			}).catch(function(e) {
				al(e) ? (ae(e), D({ type: "closeDialog" })) : ol(e) ? (le.current = !1, T.current ? (T.current.value = null, T.current.click()) : pe(/* @__PURE__ */ Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : pe(e);
			});
			return;
		}
		T.current && (D({ type: "openDialog" }), ie(), T.current.value = null, T.current.click());
	}, [
		D,
		ie,
		ae,
		_,
		_e,
		pe,
		re,
		s
	]), ye = G(function(e) {
		!w.current || !w.current.isEqualNode(e.target) || (e.key === " " || e.key === "Enter" || e.keyCode === 32 || e.keyCode === 13) && (e.preventDefault(), k());
	}, [w, k]), be = G(function() {
		D({ type: "focus" });
	}, []), xe = G(function() {
		D({ type: "blur" });
	}, []), Se = G(function() {
		b || (el() ? setTimeout(k, 0) : k());
	}, [b, k]), Ce = function(e) {
		return r ? null : e;
	}, we = function(e) {
		return x ? null : Ce(e);
	}, Te = function(e) {
		return S ? null : Ce(e);
	}, Ee = function(e) {
		C && e.stopPropagation();
	}, De = q(function() {
		return function() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.refKey, n = t === void 0 ? "ref" : t, i = e.role, a = e.onKeyDown, o = e.onFocus, s = e.onBlur, c = e.onClick, l = e.onDragEnter, u = e.onDragOver, d = e.onDragLeave, f = e.onDrop, p = Tl(e, dl);
			return $($(wl({
				onKeyDown: we(tl(a, ye)),
				onFocus: we(tl(o, be)),
				onBlur: we(tl(s, xe)),
				onClick: Ce(tl(c, Se)),
				onDragEnter: Te(tl(l, me)),
				onDragOver: Te(tl(u, he)),
				onDragLeave: Te(tl(d, ge)),
				onDrop: Te(tl(f, ve)),
				role: typeof i == "string" && i !== "" ? i : "presentation"
			}, n, w), !r && !x ? { tabIndex: 0 } : {}), p);
		};
	}, [
		w,
		ye,
		be,
		xe,
		Se,
		me,
		he,
		ge,
		ve,
		x,
		S,
		r
	]), Oe = G(function(e) {
		e.stopPropagation();
	}, []), A = q(function() {
		return function() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.refKey, n = t === void 0 ? "ref" : t, r = e.onChange, i = e.onClick, a = Tl(e, fl);
			return $($({}, wl({
				accept: ne,
				multiple: s,
				type: "file",
				style: {
					border: 0,
					clip: "rect(0, 0, 0, 0)",
					clipPath: "inset(50%)",
					height: "1px",
					margin: "0 -1px -1px 0",
					overflow: "hidden",
					padding: 0,
					position: "absolute",
					width: "1px",
					whiteSpace: "nowrap"
				},
				onChange: Ce(tl(r, ve)),
				onClick: Ce(tl(i, Oe)),
				tabIndex: -1
			}, n, T)), a);
		};
	}, [
		T,
		n,
		s,
		ve,
		r
	]);
	return $($({}, oe), {}, {
		isFocused: se && !r,
		getRootProps: De,
		getInputProps: A,
		rootRef: w,
		inputRef: T,
		open: Ce(k)
	});
}
function jl(e, t) {
	/* istanbul ignore next */
	switch (t.type) {
		case "focus": return $($({}, e), {}, { isFocused: !0 });
		case "blur": return $($({}, e), {}, { isFocused: !1 });
		case "openDialog": return $($({}, kl), {}, { isFileDialogActive: !0 });
		case "closeDialog": return $($({}, e), {}, { isFileDialogActive: !1 });
		case "setDraggedFiles": return $($({}, e), {}, {
			isDragActive: t.isDragActive,
			isDragAccept: t.isDragAccept,
			isDragReject: t.isDragReject
		});
		case "setFiles": return $($({}, e), {}, {
			acceptedFiles: t.acceptedFiles,
			fileRejections: t.fileRejections,
			isDragReject: !1
		});
		case "setDragGlobal": return $($({}, e), {}, { isDragGlobal: t.isDragGlobal });
		case "reset": return $({}, kl);
		default: return e;
	}
}
function Ml() {}
//#endregion
//#region src/components/chat/DropZoneOverlay.tsx
function Nl({ active: e }) {
	let { t } = W();
	return e ? /* @__PURE__ */ U(M, {
		"aria-dropeffect": "copy",
		style: {
			position: "absolute",
			inset: 0,
			zIndex: 10,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			flexDirection: "column",
			gap: 8,
			background: "color-mix(in srgb, var(--mantine-color-blue-1) 80%, transparent)",
			border: "2px dashed var(--mantine-color-blue-6)",
			borderRadius: "var(--mantine-radius-md)",
			pointerEvents: "none"
		},
		children: [/* @__PURE__ */ H(Vt, {
			size: 32,
			color: "var(--mantine-color-blue-6)"
		}), /* @__PURE__ */ H(B, {
			c: "blue.6",
			fw: 500,
			children: t("messages.dropzone.text", "Drop files here")
		})]
	}) : null;
}
var Pl = {
	wrapper: "_wrapper_5zob0_9",
	editorRoot: "_editorRoot_5zob0_17",
	nudge: "_nudge_5zob0_29",
	modeRow: "_modeRow_5zob0_42",
	mentionOption: "_mentionOption_5zob0_50"
};
//#endregion
//#region src/components/chat/MentionSuggestions.tsx
function Fl({ store: e, items: t, anchor: n, onSelect: r }) {
	let { t: i } = W();
	return /* @__PURE__ */ U(F, {
		store: e,
		onOptionSubmit: r,
		withinPortal: !0,
		position: "top-start",
		width: 260,
		transitionProps: {
			transition: "pop",
			duration: dr() ? 0 : 120
		},
		children: [/* @__PURE__ */ H(F.Target, {
			targetType: "button",
			withAriaAttributes: !1,
			withKeyboardNavigation: !1,
			children: /* @__PURE__ */ H("span", {
				"aria-hidden": !0,
				"data-testid": "mention-anchor",
				style: {
					position: "fixed",
					left: n?.left ?? 0,
					top: n?.top ?? 0,
					width: 1,
					height: n?.height ?? 0,
					pointerEvents: "none"
				}
			})
		}), /* @__PURE__ */ H(F.Dropdown, { children: /* @__PURE__ */ H(F.Options, {
			"aria-label": i("messages.mention.listLabel", "Team members"),
			children: t.length === 0 ? /* @__PURE__ */ H(F.Empty, { children: i("messages.mention.empty", "Nobody found") }) : t.map((e) => /* @__PURE__ */ H(F.Option, {
				value: e.guid,
				"data-testid": "mention-option",
				children: /* @__PURE__ */ U("div", {
					className: Pl.mentionOption,
					children: [
						/* @__PURE__ */ H(Me, {
							src: e.avatarUrl ?? null,
							size: 24,
							radius: "xl",
							alt: "",
							children: e.displayName.charAt(0).toUpperCase()
						}),
						/* @__PURE__ */ H(B, {
							size: "sm",
							style: { flex: 1 },
							truncate: !0,
							children: e.displayName
						}),
						/* @__PURE__ */ H(B, {
							size: "xs",
							c: "inherit",
							style: { opacity: .7 },
							children: i(`messages.mention.role.${e.role}`, e.role)
						})
					]
				})
			}, e.guid))
		}) })]
	});
}
//#endregion
//#region src/components/chat/QuickReplySuggestions.tsx
function Il(e) {
	return e.split("\n").find((e) => e.trim() !== "")?.trim() ?? "";
}
function Ll({ store: e, items: t, loading: n, anchor: r, onSelect: i }) {
	let { t: a } = W();
	return /* @__PURE__ */ U(F, {
		store: e,
		onOptionSubmit: i,
		withinPortal: !0,
		position: "top-start",
		width: 320,
		transitionProps: {
			transition: "pop",
			duration: dr() ? 0 : 120
		},
		children: [/* @__PURE__ */ H(F.Target, {
			targetType: "button",
			withAriaAttributes: !1,
			withKeyboardNavigation: !1,
			children: /* @__PURE__ */ H("span", {
				"aria-hidden": !0,
				"data-testid": "quick-reply-anchor",
				style: {
					position: "fixed",
					left: r?.left ?? 0,
					top: r?.top ?? 0,
					width: 1,
					height: r?.height ?? 0,
					pointerEvents: "none"
				}
			})
		}), /* @__PURE__ */ H(F.Dropdown, { children: /* @__PURE__ */ H(F.Options, {
			"aria-label": a("messages.quickReplies.listLabel", "Quick replies"),
			children: t.length === 0 ? /* @__PURE__ */ H(F.Empty, { children: n ? a("messages.quickReplies.loading", "Loading…") : a("messages.quickReplies.empty", "Nothing found") }) : t.map((e) => /* @__PURE__ */ H(F.Option, {
				value: e.id,
				"data-testid": "quick-reply-option",
				children: /* @__PURE__ */ U(I, {
					gap: "xs",
					wrap: "nowrap",
					children: [/* @__PURE__ */ U(B, {
						size: "sm",
						fw: 600,
						style: { flexShrink: 0 },
						children: ["/", e.shortcut]
					}), /* @__PURE__ */ H(B, {
						size: "sm",
						c: "inherit",
						style: {
							opacity: .7,
							flex: 1
						},
						truncate: !0,
						children: Il(e.body)
					})]
				})
			}, e.id))
		}) })]
	});
}
//#endregion
//#region src/components/chat/suggestionKeys.ts
function Rl(e) {
	e.getSelectedOptionIndex() < 0 && e.selectFirstOption(), e.clickSelectedOption();
}
function zl(e, t) {
	let n = t.attrs.label || t.attrs.id || "";
	e.write(`@${e.esc(n)}`);
}
var Bl = Mr.extend({
	priority: 1100,
	addStorage() {
		return { markdown: { serialize: zl } };
	},
	addNodeView() {
		return Cr(ys, { as: "span" });
	}
});
function Vl(e) {
	let t = [], n = (e) => {
		e.type === "mention" && typeof e.attrs?.id == "string" && (t.includes(e.attrs.id) || t.push(e.attrs.id)), e.content?.forEach(n);
	};
	return n(e), t;
}
//#endregion
//#region src/components/chat/extensions/QuickReplySuggestion.ts
var Hl = new Nr("quickReply"), Ul = Er.create({
	name: "quickReplySuggestion",
	priority: 1100,
	addOptions() {
		return { suggestion: {} };
	},
	addProseMirrorPlugins() {
		return [Pr({
			editor: this.editor,
			pluginKey: Hl,
			char: "/",
			allowedPrefixes: [" "],
			startOfLine: !1,
			items: () => [],
			...this.options.suggestion
		})];
	}
}), Wl = tr(() => import("emoji-picker-react")), Gl = 3e3, Kl = 10 * 1024 * 1024, ql = 5, Jl = 8, Yl = 50, Xl = /* @__PURE__ */ new Map(), Zl = (e, t) => `${e ?? ""}:${t}`;
function Ql() {
	Xl.clear();
}
var $l = {
	"image/*": [],
	"application/pdf": [".pdf"],
	"application/msword": [".doc"],
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
	"application/vnd.ms-excel": [".xls"],
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
	"text/plain": [".txt"]
}, eu = Er.create({
	name: "enterToSend",
	addOptions() {
		return { onSend: void 0 };
	},
	addKeyboardShortcuts() {
		return {
			Enter: () => (this.options.onSend?.(), !0),
			"Shift-Enter": () => (this.editor.commands.setHardBreak(), !0)
		};
	}
});
function tu(e) {
	return e ? e.isEmpty : !0;
}
function nu(e) {
	return e ? e.storage.markdown.getMarkdown().trim() : "";
}
function ru(e) {
	return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}
function iu(e, t) {
	let n = ru(t.trim());
	return e.filter((e) => n === "" || ru(e.displayName).includes(n)).slice(0, Jl);
}
function au(e, t) {
	let n = ru(t.trim());
	if (n === "") return e.slice(0, Yl);
	let r = e.filter((e) => ru(e.shortcut).startsWith(n)), i = e.filter((e) => !r.includes(e) && ru(Il(e.body)).includes(n));
	return [...r, ...i].slice(0, Yl);
}
function ou(e) {
	return e < 1024 ? `${e} B` : e < 1024 * 1024 ? `${(e / 1024).toFixed(0)} KB` : `${(e / (1024 * 1024)).toFixed(1)} MB`;
}
function su(e) {
	e.forEach((e) => {
		e.preview && URL.revokeObjectURL(e.preview);
	});
}
function cu({ onSend: e, onTyping: t, disabled: n = !1, placeholder: r, autoFocus: i = !1, focusKey: a, maxFileSize: o = Kl, acceptedFileTypes: s, maxAttachments: c = ql, hideToolbar: l = !1, onFileError: u, pendingContext: d, onDismissContext: f, modeSwitch: p = !1, mode: m = "reply", onModeChange: h, draftOwner: g, mentionCandidates: _, quickReplies: v, quickRepliesLoading: y = !1, onQuickRepliesOpen: b }) {
	let { t: x } = W(), S = p ? m : "reply", C = S === "note", ee = ur("(max-width: 61.99em)") ?? !1, te = J(0), [ne, { close: re, toggle: ie }] = lr(!1), [ae, w] = Y([]), T = J(e);
	T.current = e;
	let E = J(t);
	E.current = t;
	let oe = J(u);
	oe.current = u;
	let D = J(ae);
	D.current = ae;
	let se = J(S);
	se.current = S;
	let ce = J(p);
	ce.current = p;
	let le = J(h);
	le.current = h;
	let ue = J(_ ?? []);
	ue.current = _ ?? [];
	let de = J(r);
	de.current = r;
	let O = J(x);
	O.current = x;
	let fe = J(a), pe = J(g);
	pe.current = g;
	let me = (e) => Zl(pe.current, e), he = J(v ?? []);
	he.current = v ?? [];
	let ge = J(b);
	ge.current = b;
	let _e = J(void 0), ve = b !== void 0, [k, ye] = Y(null), be = J(k);
	be.current = k;
	let xe = mt({ opened: k !== null && C }), Se = J(xe);
	Se.current = xe;
	let [Ce, we] = Y(null), Te = J(Ce);
	Te.current = Ce;
	let Ee = Ce !== null && ve, De = mt({ opened: Ee }), Oe = J(De);
	Oe.current = De;
	let ke = q(() => Ce ? au(v ?? [], Ce.props.query) : [], [Ce, v]), Ae = J({
		onChange: () => void 0,
		onKeyDown: () => !1,
		onExit: () => void 0
	}), je = J(void 0), Me = J({
		onChange: () => void 0,
		onKeyDown: () => !1,
		onExit: () => void 0
	}), j = wr({
		shouldRerenderOnTransaction: !0,
		extensions: [
			Dr.configure({
				heading: !1,
				blockquote: !1,
				orderedList: !1,
				horizontalRule: !1,
				link: !1
			}),
			Or.configure({
				openOnClick: !1,
				autolink: !0
			}),
			kr.configure({ placeholder: () => se.current === "note" ? O.current("messages.composer.notePlaceholder", "🔒 Note — only the team sees it. @ — mention a colleague") : de.current ?? O.current("messages.composerPlaceholder") }),
			Ar.configure({
				html: !1,
				bulletListMarker: "-",
				transformPastedText: !0
			}),
			eu.configure({ onSend: () => je.current?.() }),
			Bl.configure({ suggestion: {
				char: "@",
				allow: () => ce.current,
				items: ({ query: e }) => iu(ue.current, e),
				render: () => ({
					onStart: (e) => Me.current.onChange(e),
					onUpdate: (e) => Me.current.onChange(e),
					onKeyDown: (e) => Me.current.onKeyDown(e),
					onExit: () => Me.current.onExit()
				})
			} }),
			Ul.configure({ suggestion: {
				allow: () => ge.current !== void 0,
				render: () => ({
					onStart: (e) => {
						ge.current?.(), Ae.current.onChange(e);
					},
					onUpdate: (e) => Ae.current.onChange(e),
					onKeyDown: (e) => Ae.current.onKeyDown(e),
					onExit: () => Ae.current.onExit()
				})
			} })
		],
		editable: !n,
		editorProps: { attributes: () => ({
			role: "textbox",
			"aria-label": se.current === "note" ? O.current("messages.composer.noteInputLabel", "Note text") : O.current("messages.composer.inputLabel", "Message text"),
			"aria-multiline": "true"
		}) },
		onUpdate: ({ editor: e }) => {
			if (e.isEmpty && (_e.current = void 0), E.current) {
				let e = Date.now();
				e - te.current >= Gl && (te.current = e, E.current());
			}
		}
	});
	je.current = G(() => {
		if (!j) return;
		let e = se.current === "note", t = !tu(j), n = !e && D.current.length > 0;
		if (!t && !n) return;
		let r = nu(j), i = n ? [...D.current] : void 0, a = _e.current;
		ce.current ? T.current(r, i, {
			visibility: e ? "internal" : "external",
			mentions: e ? Vl(j.getJSON()) : [],
			...a ? { quickReplyId: a } : {}
		}) : a ? T.current(r, i, {
			visibility: "external",
			mentions: [],
			quickReplyId: a
		}) : T.current(r, i), _e.current = void 0, j.commands.clearContent(!1), e && fe.current && Xl.delete(me(fe.current)), n && (su(D.current), w([]));
	}, [j]);
	let Ne = (e) => {
		let t = e.clientRect?.();
		return t ? {
			left: t.left,
			top: t.top,
			height: t.height
		} : null;
	};
	Me.current = {
		onChange: (e) => ye({
			props: e,
			anchor: Ne(e)
		}),
		onExit: () => {
			ye(null), Se.current.resetSelectedOption();
		},
		onKeyDown: ({ event: e }) => {
			let t = be.current;
			if (!t || se.current !== "note" || t.props.items.length === 0) return !1;
			let n = Se.current;
			return e.key === "ArrowDown" ? (P(n.selectNextOption()), !0) : e.key === "ArrowUp" ? (P(n.selectPreviousOption()), !0) : e.key === "Enter" || e.key === "Tab" ? (Rl(n), !0) : !1;
		}
	};
	function P(e) {
		let t = j?.view.dom;
		t && (e ? t.setAttribute("aria-activedescendant", e) : t.removeAttribute("aria-activedescendant"));
	}
	Ae.current = {
		onChange: (e) => we({
			props: e,
			anchor: Ne(e)
		}),
		onExit: () => {
			we(null), Oe.current.resetSelectedOption();
		},
		onKeyDown: ({ event: e }) => {
			if (!Te.current) return !1;
			let t = Oe.current;
			return e.key === "ArrowDown" ? (P(t.selectNextOption()), !0) : e.key === "ArrowUp" ? (P(t.selectPreviousOption()), !0) : e.key === "Enter" || e.key === "Tab" ? ke.length > 0 ? (Rl(t), !0) : y : !1;
		}
	};
	let Pe = k !== null && C;
	ar(() => {
		let e = j?.view.dom;
		if (!e) return;
		let t = Pe ? Se.current : Ee ? Oe.current : null;
		t ? (e.setAttribute("aria-haspopup", "listbox"), e.setAttribute("aria-expanded", "true"), P(t.selectFirstOption())) : (e.removeAttribute("aria-expanded"), e.removeAttribute("aria-activedescendant"));
	}, [
		j,
		Pe,
		k ? k.props.items.map((e) => e.guid).join("|") : "",
		Ee,
		Ee ? `${y}|${ke.map((e) => e.id).join("|")}` : ""
	]);
	let Fe = G((e) => {
		let t = be.current, n = t?.props.items.find((t) => t.guid === e);
		!t || !n || (t.props.command({
			id: n.guid,
			label: n.displayName
		}), ye(null));
	}, []), Le = G((e) => {
		let t = Te.current, n = t ? au(he.current, t.props.query).find((t) => t.id === e) : void 0;
		!j || !t || !n || (j.chain().focus().insertContentAt(t.props.range, n.body).run(), _e.current = n.id, we(null));
	}, [j]), Re = G((e) => {
		e !== se.current && le.current?.(e);
	}, []), [F, ze] = Y(""), Be = J(!0);
	K(() => {
		if (j && !j.isDestroyed && j.view.dispatch(j.state.tr), Be.current) {
			Be.current = !1;
			return;
		}
		if (p && (ze(S === "note" ? x("messages.composer.announceNote", "Note mode. The buyer will not see this message") : x("messages.composer.announceReply", "Reply mode. The message goes to the buyer")), S === "note" && j && j.isEmpty && fe.current)) {
			let e = Xl.get(me(fe.current));
			e && j.commands.setContent(e, { emitUpdate: !1 });
		}
	}, [S, j]), K(() => {
		j && j.setEditable(!n, !1);
	}, [j, n]), K(() => {
		if (i && !n && j) {
			let e = setTimeout(() => j.commands.focus(), 50);
			return () => clearTimeout(e);
		}
	}, [
		i,
		a,
		n,
		j
	]);
	let Ve = J(a);
	K(() => {
		if (fe.current = a, j && a !== Ve.current) {
			let e = Ve.current;
			Ve.current = a, e && se.current === "note" && !j.isEmpty && Xl.set(me(e), j.getJSON()), j.commands.clearContent(!1), su(D.current), w([]), ye(null), we(null), _e.current = void 0, se.current === "note" && le.current?.("reply");
		}
	}, [j, a]), K(() => () => {
		let e = fe.current;
		j && !j.isDestroyed && e && se.current === "note" && !j.isEmpty && Xl.set(me(e), j.getJSON());
	}, [j]), K(() => () => su(D.current), []);
	let He = q(() => s ? Object.fromEntries(s.map((e) => [e, []])) : $l, [s]), Ue = G((e) => {
		oe.current?.(e);
		let t;
		switch (e.type) {
			case "size":
				t = x("messages.attachments.fileTooLarge", {
					filename: e.file?.name ?? "",
					limit: ou(e.limit),
					defaultValue: `File "${e.file?.name}" exceeds ${ou(e.limit)} limit`
				});
				break;
			case "type":
				t = x("messages.attachments.invalidType", {
					filename: e.file?.name ?? "",
					defaultValue: `File type not accepted: ${e.file?.name}`
				});
				break;
			case "count":
				t = x("messages.attachments.tooMany", {
					limit: e.limit,
					defaultValue: `Maximum ${e.limit} files per message`
				});
				break;
		}
		Tr.show({
			title: x("messages.attachments.errorTitle", "File error"),
			message: t,
			color: "red"
		});
	}, [x]), { getRootProps: We, getInputProps: Ge, isDragActive: L, open: qe } = Al({
		accept: He,
		maxSize: o,
		noClick: !0,
		noKeyboard: !0,
		disabled: C,
		onDrop: G((e, t) => {
			for (let e of t) for (let t of e.errors) t.code === "file-too-large" ? Ue({
				type: "size",
				file: e.file,
				limit: o
			}) : t.code === "file-invalid-type" && Ue({
				type: "type",
				file: e.file,
				limit: 0
			});
			if (e.length === 0) return;
			let n = c - D.current.length;
			if (n <= 0) {
				Ue({
					type: "count",
					limit: c
				});
				return;
			}
			let r = e.slice(0, n);
			e.length > n && Ue({
				type: "count",
				limit: c
			});
			let i = r.map((e) => ({
				file: e,
				id: crypto.randomUUID(),
				preview: e.type.startsWith("image/") ? URL.createObjectURL(e) : void 0
			}));
			w((e) => [...e, ...i]);
		}, [
			c,
			o,
			Ue
		]),
		multiple: void 0,
		onDragEnter: void 0,
		onDragLeave: void 0,
		onDragOver: void 0
	}), Je = G((e) => {
		w((t) => {
			let n = t.find((t) => t.id === e);
			return n?.preview && URL.revokeObjectURL(n.preview), t.filter((t) => t.id !== e);
		});
	}, []), Ye = G(() => {
		je.current?.();
	}, []), Xe = G((e) => {
		j && j.chain().focus().insertContent(e.emoji).run(), re();
	}, [j, re]), Ze = tu(j) && (C || ae.length === 0), Qe = q(() => ({
		boldControlLabel: x("messages.toolbar.bold", "Bold"),
		italicControlLabel: x("messages.toolbar.italic", "Italic"),
		codeControlLabel: x("messages.toolbar.code", "Code"),
		bulletListControlLabel: x("messages.toolbar.list", "List")
	}), [x]), et = n;
	return /* @__PURE__ */ U("div", {
		"data-testid": "message-composer",
		"data-mode": S,
		className: Pl.wrapper,
		...We(),
		style: {
			padding: "8px 16px",
			position: "relative"
		},
		children: [
			/* @__PURE__ */ H("input", {
				...Ge(),
				"aria-label": x("messages.toolbar.attach", "Attach file")
			}),
			/* @__PURE__ */ H(Nl, { active: L }),
			p && /* @__PURE__ */ H("div", {
				className: Pl.modeRow,
				children: /* @__PURE__ */ H(nt, {
					name: "message-composer-mode",
					size: "xs",
					value: S,
					disabled: et,
					color: C ? "yellow" : void 0,
					autoContrast: !0,
					"aria-label": x("messages.composer.modeLabel", "Message type"),
					"data-testid": "message-composer-mode",
					onChange: (e) => Re(e),
					data: [{
						value: "reply",
						label: ee ? x("messages.composer.modeReplyShort", "Reply") : x("messages.composer.modeReply", "Reply to buyer")
					}, {
						value: "note",
						label: /* @__PURE__ */ U(I, {
							gap: 4,
							wrap: "nowrap",
							justify: "center",
							children: [/* @__PURE__ */ H(un, {
								size: 12,
								"aria-hidden": !0
							}), /* @__PURE__ */ H("span", { children: ee ? x("messages.composer.modeNoteShort", "Note") : x("messages.composer.modeNote", "Note for the team") })]
						})
					}]
				})
			}),
			/* @__PURE__ */ H(pt, {
				role: "status",
				"aria-live": "polite",
				"data-testid": "composer-mode-announcement",
				children: F
			}),
			p && k && !C && !n && /* @__PURE__ */ U("div", {
				className: Pl.nudge,
				role: "status",
				"data-testid": "mention-nudge",
				children: [
					/* @__PURE__ */ H(St, {
						size: 14,
						"aria-hidden": !0
					}),
					/* @__PURE__ */ H("span", {
						style: { flex: 1 },
						children: x("messages.mention.nudge", "Mentions work in notes. Switch to a note?")
					}),
					/* @__PURE__ */ H(N, {
						size: "compact-xs",
						variant: "light",
						color: "yellow",
						styles: { root: { "--button-color": "var(--composer-note-text)" } },
						onMouseDown: (e) => e.preventDefault(),
						onClick: () => Re("note"),
						"data-testid": "mention-nudge-switch",
						children: x("messages.mention.nudgeAction", "Switch to note")
					})
				]
			}),
			/* @__PURE__ */ U(jr, {
				editor: j,
				labels: Qe,
				classNames: { root: Pl.editorRoot },
				styles: {
					root: {
						border: `1px solid ${C ? "var(--composer-note-border)" : "var(--mantine-color-default-border)"}`,
						...C ? {
							borderTop: "3px solid var(--composer-note-stripe)",
							backgroundColor: "var(--composer-note-bg)",
							boxShadow: "inset 3px 0 0 var(--composer-note-stripe)"
						} : {},
						borderRadius: "var(--mantine-radius-md)",
						overflow: "hidden"
					},
					toolbar: {
						borderBottom: `1px solid ${C ? "var(--composer-note-border)" : "var(--mantine-color-default-border)"}`,
						padding: "2px 4px",
						minHeight: 32,
						gap: 0,
						...C ? { backgroundColor: "transparent" } : {}
					},
					content: {
						...C ? {
							backgroundColor: "transparent",
							color: "var(--composer-note-text)"
						} : {},
						"& .ProseMirror": {
							minHeight: "1.5em",
							maxHeight: "calc(1.5em * 6 + 1em)",
							overflowY: "auto",
							padding: "8px 12px"
						}
					}
				},
				children: [
					d && !C && /* @__PURE__ */ U(M, {
						style: {
							display: "flex",
							alignItems: "center",
							gap: 8,
							padding: "6px 12px",
							borderBottom: "1px solid var(--mantine-color-default-border)",
							backgroundColor: "var(--mantine-color-blue-light)"
						},
						"data-testid": "pending-context-banner",
						children: [/* @__PURE__ */ H(M, {
							style: { flex: 1 },
							children: /* @__PURE__ */ H(gs, {
								type: `${d.type}_context`,
								entityGuid: d.entityGuid,
								snapshot: d.snapshot,
								compact: !0
							})
						}), /* @__PURE__ */ H(Ie, {
							size: "sm",
							onClick: f,
							"aria-label": "Dismiss context"
						})]
					}),
					!C && /* @__PURE__ */ H(ss, {
						attachments: ae,
						onRemove: Je
					}),
					/* @__PURE__ */ U(jr.Toolbar, { children: [
						!l && /* @__PURE__ */ H(M, {
							visibleFrom: "sm",
							style: { display: "flex" },
							children: /* @__PURE__ */ U(jr.ControlsGroup, { children: [
								/* @__PURE__ */ H(jr.Bold, {}),
								/* @__PURE__ */ H(jr.Italic, {}),
								/* @__PURE__ */ H(jr.Code, {}),
								/* @__PURE__ */ H(jr.BulletList, {})
							] })
						}),
						!C && /* @__PURE__ */ H(jr.Control, {
							"aria-label": x("messages.toolbar.attach", "Attach file"),
							"data-testid": "message-composer-attach",
							onClick: qe,
							children: /* @__PURE__ */ H(yn, { size: 16 })
						}),
						/* @__PURE__ */ U($e, {
							opened: ne,
							onClose: re,
							position: "top-end",
							width: 352,
							shadow: "md",
							children: [/* @__PURE__ */ H($e.Target, { children: /* @__PURE__ */ H(jr.Control, {
								"aria-label": x("messages.toolbar.emoji", "Emoji"),
								"data-testid": "message-composer-emoji",
								onClick: ie,
								active: ne,
								children: /* @__PURE__ */ H(gn, { size: 16 })
							}) }), /* @__PURE__ */ H($e.Dropdown, {
								p: 0,
								children: /* @__PURE__ */ H(Xn, {
									fallback: /* @__PURE__ */ H(Ke, {
										size: "sm",
										m: "md"
									}),
									children: /* @__PURE__ */ H(Wl, {
										onEmojiClick: Xe,
										emojiStyle: "apple",
										theme: "auto",
										searchPlaceholder: x("messages.toolbar.emojiSearch", "Search emojis..."),
										width: 350,
										height: 400,
										lazyLoadEmojis: !0,
										previewConfig: { showPreview: !1 }
									})
								})
							})]
						}),
						/* @__PURE__ */ H("div", { style: { flex: 1 } }),
						C ? /* @__PURE__ */ H(N, {
							size: "compact-sm",
							color: "yellow",
							autoContrast: !0,
							leftSection: /* @__PURE__ */ H(un, {
								size: 14,
								"aria-hidden": !0
							}),
							onClick: Ye,
							disabled: n || Ze,
							"aria-label": x("messages.composer.saveNoteAria", "Save note for the team"),
							"data-testid": "message-composer-send",
							style: { marginRight: 2 },
							children: x("messages.composer.saveNote", "Save")
						}) : /* @__PURE__ */ H(A, {
							variant: "filled",
							color: "blue",
							size: "sm",
							onClick: Ye,
							disabled: n || Ze,
							"aria-label": x("messages.aria.send"),
							"data-testid": "message-composer-send",
							style: { marginRight: 2 },
							children: /* @__PURE__ */ H(Dn, { size: 14 })
						})
					] }),
					/* @__PURE__ */ H(jr.Content, { "data-testid": "message-composer-input" })
				]
			}),
			ve && /* @__PURE__ */ H(Ll, {
				store: De,
				items: ke,
				loading: y,
				anchor: Ce?.anchor ?? null,
				onSelect: Le
			}),
			p && C && /* @__PURE__ */ H(Fl, {
				store: xe,
				items: k?.props.items ?? [],
				anchor: k?.anchor ?? null,
				onSelect: Fe
			})
		]
	});
}
//#endregion
//#region src/components/chat/useClearNoteDraftsOnSignOut.ts
function lu(e) {
	K(() => {
		e || Ql();
	}, [e]);
}
//#endregion
//#region src/components/chat/TypingIndicator.tsx
var uu = "\n@keyframes typingDot {\n  0%, 60%, 100% { opacity: 0.2; }\n  30% { opacity: 1; }\n}\n", du = (e) => ({
	width: 4,
	height: 4,
	borderRadius: "50%",
	backgroundColor: "var(--mantine-color-dimmed)",
	animation: "typingDot 1.4s infinite ease-in-out both",
	animationDelay: `${e}s`
});
function fu({ userName: e }) {
	let { t } = W();
	return /* @__PURE__ */ U(I, {
		gap: 4,
		px: "md",
		py: 4,
		"data-testid": "typing-indicator",
		children: [
			/* @__PURE__ */ U("style", { children: [uu, "\n        @media (prefers-reduced-motion: reduce) {\n          @keyframes typingDot {\n            0%, 100% { opacity: 0.6; }\n          }\n        }\n      "] }),
			/* @__PURE__ */ H(B, {
				size: "sm",
				c: "dimmed",
				children: t("messages.typing", { name: e })
			}),
			/* @__PURE__ */ U(I, {
				gap: 2,
				align: "center",
				ml: 2,
				children: [
					/* @__PURE__ */ H("span", { style: du(0) }),
					/* @__PURE__ */ H("span", { style: du(.2) }),
					/* @__PURE__ */ H("span", { style: du(.4) })
				]
			})
		]
	});
}
//#endregion
//#region src/components/chat/ConversationListHeader.tsx
var pu = 44, mu = 8;
function hu({ unreadOnly: e, onUnreadOnlyChange: t, labels: n, size: r }) {
	return /* @__PURE__ */ H(Ge, {
		disabled: !e,
		size: mu,
		offset: 6,
		children: /* @__PURE__ */ U($e, {
			position: "bottom-end",
			shadow: "md",
			withinPortal: !0,
			children: [/* @__PURE__ */ H($e.Target, { children: /* @__PURE__ */ H(A, {
				variant: "subtle",
				color: "gray",
				size: r,
				"aria-label": n.filters,
				"data-testid": "conversation-list-filters",
				children: /* @__PURE__ */ H(_t, { size: 18 })
			}) }), /* @__PURE__ */ H($e.Dropdown, { children: /* @__PURE__ */ H(at, {
				checked: e,
				onChange: (e) => t(e.currentTarget.checked),
				label: n.unreadOnly,
				"data-testid": "conversation-list-unread-only"
			}) })]
		})
	});
}
var gu = [
	"mine",
	"unassigned",
	"all"
];
function _u({ label: e, count: t }) {
	return /* @__PURE__ */ U(I, {
		gap: 4,
		wrap: "nowrap",
		justify: "center",
		children: [/* @__PURE__ */ H(B, {
			size: "xs",
			span: !0,
			style: { whiteSpace: "nowrap" },
			children: e
		}), t > 0 && /* @__PURE__ */ H(j, {
			size: "xs",
			variant: "filled",
			circle: t < 10,
			children: t
		})]
	});
}
function vu({ filterGroups: e, onFilterChange: t, label: n, isMobile: r }) {
	let i = dr(), a = e.flatMap((e) => e.items).filter((e) => e.checked).length;
	return /* @__PURE__ */ H(Ge, {
		label: /* @__PURE__ */ H("span", {
			"data-testid": "conversation-list-filters-count",
			children: a
		}),
		disabled: a === 0,
		size: 16,
		offset: r ? 8 : 6,
		children: /* @__PURE__ */ U(L, {
			position: "bottom-end",
			shadow: "md",
			withinPortal: !0,
			transitionProps: {
				transition: "pop",
				duration: i ? 0 : 120
			},
			children: [/* @__PURE__ */ H(L.Target, { children: /* @__PURE__ */ H(A, {
				variant: "subtle",
				color: "gray",
				size: r ? pu : 36,
				"aria-label": n,
				title: n,
				"data-testid": "conversation-list-filters",
				children: /* @__PURE__ */ H(_t, { size: r ? 20 : 18 })
			}) }), /* @__PURE__ */ H(L.Dropdown, { children: e.map((e, n) => /* @__PURE__ */ U(M, { children: [
				n > 0 && /* @__PURE__ */ H(L.Divider, {}),
				e.label && /* @__PURE__ */ H(L.Label, { children: e.label }),
				e.items.map((e) => /* @__PURE__ */ H(L.CheckboxItem, {
					checked: e.checked,
					onChange: (n) => t(e.value, n),
					rightSection: e.icon,
					"data-testid": `conversation-list-filter-${e.value}`,
					children: e.label
				}, e.value))
			] }, e.label ?? n)) })]
		})
	});
}
function yu({ isMobile: e = !1, search: t, onSearchChange: n, onDebouncedSearchChange: r, axis: i, onAxisChange: a, axisBadges: o, status: s, onStatusChange: c, statusOptions: l, filterGroups: u, onFilterChange: d, labels: f }) {
	let [p, m] = Y(!1), h = dr(), g = /* @__PURE__ */ H(nt, {
		fullWidth: !0,
		size: "sm",
		styles: {
			control: { flex: "1 1 auto" },
			label: { paddingInline: 6 }
		},
		value: i,
		onChange: (e) => a(e),
		data: gu.map((e) => ({
			value: e,
			label: /* @__PURE__ */ H(_u, {
				label: f[e],
				count: o[e]
			})
		})),
		"data-testid": "conversation-list-axis"
	}), _ = /* @__PURE__ */ H(rt, {
		size: "sm",
		w: e ? 132 : 160,
		value: s,
		onChange: (e) => e && c(e),
		data: l,
		allowDeselect: !1,
		"aria-label": f.status,
		comboboxProps: {
			withinPortal: !0,
			transitionProps: { duration: h ? 0 : 120 }
		},
		"data-testid": "conversation-list-status"
	}), v = (e) => /* @__PURE__ */ H(M, {
		flex: 1,
		miw: 0,
		children: /* @__PURE__ */ H(to, {
			value: t,
			onChange: n,
			onDebouncedChange: r,
			placeholder: f.searchPlaceholder,
			size: "sm",
			autoFocus: e
		})
	}), y = /* @__PURE__ */ H(vu, {
		filterGroups: u,
		onFilterChange: d,
		label: f.filters,
		isMobile: e
	});
	if (e) return /* @__PURE__ */ U(z, {
		gap: "xs",
		px: "md",
		pt: "xs",
		pb: "xs",
		"data-testid": "conversation-list-header",
		children: [p ? /* @__PURE__ */ U(I, {
			gap: "xs",
			wrap: "nowrap",
			h: pu,
			children: [v(!0), /* @__PURE__ */ H(A, {
				variant: "subtle",
				color: "gray",
				size: pu,
				onClick: () => {
					n(""), m(!1);
				},
				"aria-label": f.closeSearch,
				children: /* @__PURE__ */ H(V, { size: 18 })
			})]
		}) : /* @__PURE__ */ U(I, {
			gap: "xs",
			wrap: "nowrap",
			h: pu,
			justify: "space-between",
			children: [/* @__PURE__ */ H(A, {
				variant: "subtle",
				color: "gray",
				size: pu,
				onClick: () => m(!0),
				"aria-label": f.openSearch,
				"data-testid": "conversation-list-open-search",
				children: /* @__PURE__ */ H(Tn, { size: 20 })
			}), /* @__PURE__ */ U(I, {
				gap: "xs",
				wrap: "nowrap",
				children: [_, y]
			})]
		}), g]
	});
	let b = u.flatMap((e) => e.items).filter((e) => e.checked);
	return /* @__PURE__ */ U(z, {
		gap: "xs",
		px: "md",
		pt: "md",
		pb: "xs",
		"data-testid": "conversation-list-header",
		children: [
			/* @__PURE__ */ U(I, {
				gap: "xs",
				wrap: "nowrap",
				children: [v(!1), _]
			}),
			/* @__PURE__ */ U(I, {
				gap: "xs",
				wrap: "nowrap",
				children: [/* @__PURE__ */ H(M, {
					flex: 1,
					miw: 0,
					children: g
				}), y]
			}),
			b.length > 0 && /* @__PURE__ */ H(I, {
				gap: 6,
				"data-testid": "conversation-list-active-filters",
				children: b.map((e) => /* @__PURE__ */ H(Qe, {
					withRemoveButton: !0,
					onRemove: () => d(e.value, !1),
					removeButtonProps: { "aria-label": f.removeFilter.replace("{label}", e.label) },
					children: e.label
				}, e.value))
			})
		]
	});
}
function bu(e) {
	return e.variant === "merchant" ? /* @__PURE__ */ H(yu, { ...e }) : /* @__PURE__ */ H(xu, { ...e });
}
function xu({ title: e, tabs: t, isMobile: n = !1, search: r, onSearchChange: i, onDebouncedSearchChange: a, unreadOnly: o, onUnreadOnlyChange: s, labels: c }) {
	let [l, u] = Y(!1), d = (e) => /* @__PURE__ */ H(M, {
		flex: 1,
		miw: 0,
		children: /* @__PURE__ */ H(to, {
			value: r,
			onChange: i,
			onDebouncedChange: a,
			placeholder: c.searchPlaceholder,
			size: "sm",
			autoFocus: e
		})
	});
	return n ? /* @__PURE__ */ U(z, {
		gap: 0,
		px: "md",
		pt: "xs",
		"data-testid": "conversation-list-header",
		children: [l ? /* @__PURE__ */ U(I, {
			gap: "xs",
			wrap: "nowrap",
			h: pu,
			children: [
				d(!0),
				/* @__PURE__ */ H(hu, {
					unreadOnly: o,
					onUnreadOnlyChange: s,
					labels: c,
					size: pu
				}),
				/* @__PURE__ */ H(A, {
					variant: "subtle",
					color: "gray",
					size: pu,
					onClick: () => {
						i(""), u(!1);
					},
					"aria-label": c.closeSearch,
					children: /* @__PURE__ */ H(V, { size: 18 })
				})
			]
		}) : /* @__PURE__ */ U(I, {
			justify: "space-between",
			wrap: "nowrap",
			h: pu,
			children: [/* @__PURE__ */ H(M, {
				miw: 0,
				children: e
			}), /* @__PURE__ */ H(Ge, {
				disabled: !o,
				size: mu,
				offset: 10,
				children: /* @__PURE__ */ H(A, {
					variant: "subtle",
					color: "gray",
					size: pu,
					onClick: () => u(!0),
					"aria-label": c.openSearch,
					"data-testid": "conversation-list-open-search",
					children: /* @__PURE__ */ H(Tn, { size: 20 })
				})
			})]
		}), t]
	}) : /* @__PURE__ */ U(z, {
		gap: "xs",
		px: "md",
		pt: "md",
		pb: "xs",
		"data-testid": "conversation-list-header",
		children: [
			/* @__PURE__ */ H(M, {
				miw: 0,
				children: e
			}),
			t,
			/* @__PURE__ */ U(I, {
				gap: "xs",
				wrap: "nowrap",
				children: [d(!1), /* @__PURE__ */ H(hu, {
					unreadOnly: o,
					onUnreadOnlyChange: s,
					labels: c,
					size: "lg"
				})]
			})
		]
	});
}
//#endregion
//#region src/components/chat/AssigneeChip.tsx
var Su = {
	me: {
		background: ["blue-1", "blue-9"],
		text: ["blue-9", "blue-1"]
	},
	other: {
		background: ["gray-1", "dark-5"],
		text: ["gray-8", "dark-0"]
	},
	none: {
		background: ["gray-2", "dark-6"],
		text: ["gray-7", "dark-1"]
	}
}, Cu = ([e, t]) => `light-dark(var(--mantine-color-${e}), var(--mantine-color-${t}))`;
function wu(e) {
	let { background: t, text: n } = Su[e];
	return {
		bg: Cu(t),
		c: Cu(n)
	};
}
var Tu = 10;
function Eu(e) {
	let t = e.trim().split(/\s+/).filter(Boolean), n = t[0] ?? "";
	return n.length <= Tu ? n : t.slice(0, 2).map((e) => e[0].toUpperCase()).join("");
}
function Du({ assignee: e, unassignedLabel: t, unknownLabel: n = "?", isMe: r = !1 }) {
	if (!e) return /* @__PURE__ */ H(j, {
		size: "xs",
		variant: "light",
		...wu("none"),
		"aria-label": t,
		"data-testid": "assignee-chip-none",
		children: "—"
	});
	let i = e.displayName ?? n;
	return /* @__PURE__ */ H(dt, {
		label: i,
		withinPortal: !0,
		openDelay: 300,
		children: /* @__PURE__ */ H(j, {
			size: "xs",
			variant: "light",
			...wu(r ? "me" : "other"),
			tt: "none",
			"aria-label": i,
			"data-testid": "assignee-chip",
			"data-mine": r ? "true" : void 0,
			children: e.displayName ? Eu(e.displayName) : n
		})
	});
}
var Ou = {
	panel: "_panel_1iqh0_10",
	icon: "_icon_1iqh0_19"
};
//#endregion
//#region src/components/chat/BlockedComposerPanel.tsx
function ku({ variant: e, onUnblock: t, unblocking: n = !1 }) {
	let { t: r } = W();
	return /* @__PURE__ */ U(I, {
		className: Ou.panel,
		gap: "sm",
		wrap: "nowrap",
		justify: "space-between",
		role: "status",
		"data-testid": "blocked-composer-panel",
		"data-variant": e,
		children: [/* @__PURE__ */ U(I, {
			gap: "sm",
			wrap: "nowrap",
			align: "flex-start",
			style: { minWidth: 0 },
			children: [/* @__PURE__ */ H(Ct, {
				size: 20,
				className: Ou.icon,
				"aria-hidden": !0
			}), e === "buyer" ? /* @__PURE__ */ U(z, {
				gap: 2,
				children: [/* @__PURE__ */ H(B, {
					size: "sm",
					fw: 500,
					c: "inherit",
					"data-testid": "blocked-composer-title",
					children: r("messages.blocked.buyerTitle", "The shop is not accepting messages")
				}), /* @__PURE__ */ H(B, {
					size: "xs",
					c: "inherit",
					"data-testid": "blocked-composer-hint",
					children: r("messages.blocked.buyerHint", "You can write to other shops.")
				})]
			}) : /* @__PURE__ */ H(B, {
				size: "sm",
				fw: 500,
				c: "inherit",
				"data-testid": "blocked-composer-title",
				children: r("messages.blocked.merchantTitle", "Conversation blocked")
			})]
		}), e === "merchant" && t ? /* @__PURE__ */ H(N, {
			variant: "default",
			size: "xs",
			onClick: t,
			loading: n,
			"data-testid": "blocked-composer-unblock",
			children: r("messages.blocked.unblock", "Unblock")
		}) : null]
	});
}
var Au = {
	row: "_row_876w5_9",
	secondary: "_secondary_876w5_37",
	icon: "_icon_876w5_41"
}, ju = 99;
function Mu(e) {
	if (!e) return null;
	let t = e instanceof Date ? e : new Date(e);
	if (Number.isNaN(t.getTime())) return null;
	let n = /* @__PURE__ */ new Date();
	return t.getFullYear() === n.getFullYear() && t.getMonth() === n.getMonth() && t.getDate() === n.getDate() ? t.toLocaleTimeString(void 0, {
		hour: "2-digit",
		minute: "2-digit"
	}) : t.toLocaleDateString(void 0, {
		day: "numeric",
		month: "short"
	});
}
function Nu({ title: e, unreadCount: t, preview: n, lastMessageAt: r, selected: i = !1, onClick: a }) {
	let { t: o } = W(), s = rr(), c = t > 0, l = Mu(r), u = t > ju ? `${ju}+` : String(t);
	return /* @__PURE__ */ U(ft, {
		className: Au.row,
		onClick: a,
		"aria-label": o("messages.teamGroup.ariaLabel", "Командная переписка, закреплено"),
		"aria-describedby": s,
		"aria-current": i ? "true" : void 0,
		"data-selected": i ? "" : void 0,
		"data-unread": c ? "" : void 0,
		"data-testid": "pinned-conversation-row",
		children: [/* @__PURE__ */ U(I, {
			gap: "sm",
			wrap: "nowrap",
			justify: "space-between",
			children: [/* @__PURE__ */ U(I, {
				gap: "sm",
				wrap: "nowrap",
				style: { minWidth: 0 },
				children: [/* @__PURE__ */ H(Vn, {
					size: 20,
					className: Au.icon,
					"aria-hidden": !0,
					"data-testid": "pinned-row-icon"
				}), /* @__PURE__ */ U(M, {
					style: { minWidth: 0 },
					children: [/* @__PURE__ */ H(B, {
						size: "sm",
						fw: c ? 700 : 600,
						truncate: !0,
						"data-testid": "pinned-row-title",
						children: e
					}), n ? /* @__PURE__ */ H(B, {
						size: "xs",
						className: Au.secondary,
						truncate: !0,
						"data-testid": "pinned-row-preview",
						children: n
					}) : null]
				})]
			}), /* @__PURE__ */ U(I, {
				gap: "xs",
				wrap: "nowrap",
				style: { flexShrink: 0 },
				children: [l ? /* @__PURE__ */ H(B, {
					size: "xs",
					className: Au.secondary,
					"data-testid": "pinned-row-when",
					children: l
				}) : null, c ? /* @__PURE__ */ H(j, {
					size: "sm",
					circle: u.length < 3,
					"aria-hidden": !0,
					"data-testid": "pinned-row-badge",
					children: u
				}) : null]
			})]
		}), /* @__PURE__ */ H(pt, {
			id: s,
			children: [
				e,
				n,
				c ? o("messages.teamGroup.unread", {
					count: t,
					defaultValue: "{{count}} unread"
				}) : null
			].filter(Boolean).join(". ")
		})]
	});
}
//#endregion
//#region src/components/catalog/BrandFilter.tsx
function Pu({ brands: e, selectedBrands: t, onChange: n, maxHeight: r = 200, labels: i }) {
	let [a, o] = Y(""), s = q(() => {
		if (!a.trim()) return e;
		let t = a.toLowerCase();
		return e.filter((e) => e.label.toLowerCase().includes(t));
	}, [e, a]), c = (e, r) => {
		n(r ? [...t, e] : t.filter((t) => t !== e));
	};
	return e.length === 0 ? null : /* @__PURE__ */ U(z, {
		gap: "xs",
		"data-testid": "brand-filter",
		children: [
			/* @__PURE__ */ H(B, {
				fw: 600,
				size: "sm",
				children: i.brand
			}),
			e.length > 5 && /* @__PURE__ */ H(st, {
				placeholder: i.searchBrand,
				size: "xs",
				leftSection: /* @__PURE__ */ H(Tn, { size: 14 }),
				value: a,
				onChange: (e) => o(e.currentTarget.value),
				"data-testid": "brand-search"
			}),
			/* @__PURE__ */ H(tt.Autosize, {
				mah: r,
				children: /* @__PURE__ */ H(z, {
					gap: 4,
					children: s.map((e) => /* @__PURE__ */ H(Fe, {
						label: /* @__PURE__ */ U(I, {
							gap: "xs",
							wrap: "nowrap",
							children: [/* @__PURE__ */ H(B, {
								size: "sm",
								lineClamp: 1,
								children: e.label
							}), /* @__PURE__ */ U(B, {
								size: "xs",
								c: "dimmed",
								children: [
									"(",
									e.count,
									")"
								]
							})]
						}),
						checked: t.includes(e.key),
						onChange: (t) => c(e.key, t.currentTarget.checked),
						size: "sm",
						"data-testid": `brand-${e.label.replace(/\s+/g, "-")}`
					}, e.key))
				})
			}),
			s.length === 0 && a && /* @__PURE__ */ H(B, {
				size: "xs",
				c: "dimmed",
				children: i.noBrandsFound
			})
		]
	});
}
//#endregion
//#region src/components/catalog/CategoryFilter.tsx
function Fu(e) {
	return {
		key: e.key,
		label: e.label,
		count: e.count ?? 0,
		level: e.level,
		parentGuid: e.parentGuid,
		slug: e.slug
	};
}
function Iu({ itemKey: e, label: t, count: n, isSelected: r, onClick: i, children: a, defaultOpened: o }) {
	return /* @__PURE__ */ H(Je, {
		label: /* @__PURE__ */ U(I, {
			gap: "xs",
			wrap: "nowrap",
			justify: "space-between",
			children: [/* @__PURE__ */ H(B, {
				size: "sm",
				truncate: !0,
				children: t
			}), n !== void 0 && /* @__PURE__ */ H(j, {
				size: "xs",
				variant: "light",
				color: "accent",
				children: n
			})]
		}),
		active: r,
		onClick: i,
		leftSection: /* @__PURE__ */ H(tn, { size: 14 }),
		defaultOpened: o,
		childrenOffset: a ? 16 : void 0,
		"data-testid": `category-${e}`,
		children: a
	});
}
function Lu({ categories: e, tree: t, selected: n, onSelect: r, label: i }) {
	let a = t !== void 0;
	if (a ? t.length === 0 : e.length === 0) return null;
	let o = (e) => e.key === n || e.children.some(o), s = (e) => {
		let t = n === e.key, i = e.children.length > 0;
		return /* @__PURE__ */ H(Iu, {
			itemKey: e.key,
			label: e.label,
			count: e.count,
			isSelected: t,
			onClick: () => r(t ? null : Fu(e)),
			defaultOpened: i ? o(e) : void 0,
			children: i ? e.children.map(s) : void 0
		}, e.key);
	};
	return /* @__PURE__ */ U(z, {
		gap: "xs",
		"data-testid": "category-filter",
		children: [/* @__PURE__ */ H(B, {
			fw: 600,
			size: "sm",
			children: i
		}), /* @__PURE__ */ H(z, {
			gap: 0,
			children: a ? t.map(s) : e.map((e) => {
				let t = n === e.key;
				return /* @__PURE__ */ H(Iu, {
					itemKey: e.key,
					label: e.label,
					count: e.count,
					isSelected: t,
					onClick: () => r(t ? null : e)
				}, e.key);
			})
		})]
	});
}
//#endregion
//#region src/components/catalog/InStockFilter.tsx
function Ru({ checked: e, onChange: t, label: n }) {
	return /* @__PURE__ */ U(I, {
		justify: "space-between",
		"data-testid": "instock-filter",
		children: [/* @__PURE__ */ H(B, {
			size: "sm",
			children: n
		}), /* @__PURE__ */ H(at, {
			checked: e,
			onChange: (e) => t(e.currentTarget.checked),
			size: "sm",
			"data-testid": "instock-switch"
		})]
	});
}
//#endregion
//#region src/components/catalog/PriceFilter.tsx
function zu({ minPrice: e, maxPrice: t, onChange: n, labels: r }) {
	let [i, a] = Y(e ?? ""), [o, s] = Y(t ?? "");
	K(() => {
		a(e ?? ""), s(t ?? "");
	}, [e, t]);
	let c = () => {
		n(typeof i == "number" ? i : null, typeof o == "number" ? o : null);
	}, l = () => {
		a(""), s(""), n(null, null);
	}, u = i !== "" || o !== "";
	return /* @__PURE__ */ U(z, {
		gap: "xs",
		"data-testid": "price-filter",
		children: [
			/* @__PURE__ */ H(B, {
				fw: 600,
				size: "sm",
				children: r.priceRange
			}),
			/* @__PURE__ */ U(I, {
				gap: "xs",
				align: "center",
				children: [
					/* @__PURE__ */ H(Ye, {
						placeholder: "Min",
						value: i,
						onChange: (e) => a(e),
						min: 0,
						size: "xs",
						w: 80,
						hideControls: !0,
						"data-testid": "price-min",
						leftSection: "$"
					}),
					/* @__PURE__ */ H(B, {
						size: "sm",
						c: "dimmed",
						children: "-"
					}),
					/* @__PURE__ */ H(Ye, {
						placeholder: "Max",
						value: o,
						onChange: (e) => s(e),
						min: 0,
						size: "xs",
						w: 80,
						hideControls: !0,
						"data-testid": "price-max",
						leftSection: "$"
					})
				]
			}),
			/* @__PURE__ */ U(I, {
				gap: "xs",
				children: [/* @__PURE__ */ H(N, {
					size: "xs",
					variant: "light",
					onClick: c,
					"data-testid": "apply-price-filter",
					children: r.apply
				}), u && /* @__PURE__ */ H(N, {
					size: "xs",
					variant: "subtle",
					onClick: l,
					"data-testid": "clear-price-filter",
					children: r.clear
				})]
			})
		]
	});
}
//#endregion
//#region src/components/catalog/AttributeFilter/StringAttributeFilter.tsx
function Bu({ attribute: e, selectedValues: t, onChange: n, maxHeight: r = 200, initialVisibleCount: i = 5, labels: a }) {
	let [o, s] = Y(""), [c, l] = Y(!1), { buckets: u } = e, d = q(() => {
		if (!o.trim()) return u;
		let e = o.toLowerCase();
		return u.filter((t) => t.label.toLowerCase().includes(e));
	}, [u, o]), f = q(() => c || o.trim() ? d : d.slice(0, i), [
		d,
		c,
		o,
		i
	]), p = d.length > i && !o.trim(), m = (e, r) => {
		n(r ? [...t, e] : t.filter((t) => t !== e));
	};
	return u.length === 0 ? null : /* @__PURE__ */ U(z, {
		gap: "xs",
		"data-testid": `attr-filter-${e.slug}`,
		children: [
			/* @__PURE__ */ H(B, {
				fw: 500,
				size: "sm",
				children: e.name
			}),
			u.length > i && /* @__PURE__ */ H(st, {
				placeholder: a.searchAttribute,
				size: "xs",
				leftSection: /* @__PURE__ */ H(Tn, { size: 14 }),
				value: o,
				onChange: (e) => s(e.currentTarget.value),
				"data-testid": `attr-search-${e.slug}`,
				"aria-label": a.searchAttributeValues(e.name)
			}),
			/* @__PURE__ */ H(tt.Autosize, {
				mah: c ? r : void 0,
				children: /* @__PURE__ */ H(z, {
					gap: 4,
					role: "group",
					"aria-labelledby": `attr-label-${e.slug}`,
					children: f.map((n) => /* @__PURE__ */ H(Fe, {
						label: /* @__PURE__ */ U(I, {
							gap: "xs",
							wrap: "nowrap",
							children: [/* @__PURE__ */ H(B, {
								size: "sm",
								lineClamp: 1,
								children: n.label
							}), /* @__PURE__ */ U(B, {
								size: "xs",
								c: "dimmed",
								"aria-label": a.productCount(n.count),
								children: [
									"(",
									n.count,
									")"
								]
							})]
						}),
						checked: t.includes(n.key),
						onChange: (e) => m(n.key, e.currentTarget.checked),
						size: "sm",
						"data-testid": `attr-${e.slug}-${n.key}`
					}, n.key))
				})
			}),
			p && /* @__PURE__ */ H(N, {
				variant: "subtle",
				size: "xs",
				onClick: () => l(!c),
				leftSection: H(c ? Nt : At, { size: 14 }),
				"data-testid": `attr-${e.slug}-toggle`,
				children: c ? a.showLess : a.showMore(d.length - i)
			}),
			d.length === 0 && o && /* @__PURE__ */ H(B, {
				size: "xs",
				c: "dimmed",
				children: a.noValuesFound
			})
		]
	});
}
//#endregion
//#region src/components/catalog/AttributeFilter/NumberAttributeFilter.tsx
function Vu({ attribute: e, range: t, onChange: n, labels: r }) {
	let { minValue: i, maxValue: a, step: o, hasBounds: s } = q(() => {
		let t = (e, t) => {
			let n = t - e;
			return n > 1e3 ? 10 : n > 100 ? 1 : n > 10 ? .5 : .1;
		};
		if (typeof e.rangeMin == "number" && typeof e.rangeMax == "number" && e.rangeMax > e.rangeMin) return {
			minValue: e.rangeMin,
			maxValue: e.rangeMax,
			step: t(e.rangeMin, e.rangeMax),
			hasBounds: !0
		};
		let n = e.buckets.map((e) => parseFloat(e.key)).filter((e) => !isNaN(e)).sort((e, t) => e - t);
		if (n.length === 0) return {
			minValue: 0,
			maxValue: 100,
			step: 1,
			hasBounds: !1
		};
		let r = n[0], i = n[n.length - 1];
		return {
			minValue: r,
			maxValue: i,
			step: t(r, i),
			hasBounds: !0
		};
	}, [
		e.buckets,
		e.rangeMin,
		e.rangeMax
	]), [c, l] = Y(t?.min ?? ""), [u, d] = Y(t?.max ?? ""), [f, p] = Y([t?.min ?? i, t?.max ?? a]);
	K(() => {
		l(t?.min ?? ""), d(t?.max ?? ""), p([t?.min ?? i, t?.max ?? a]);
	}, [
		t,
		i,
		a
	]);
	let m = (e) => {
		p(e), l(e[0]), d(e[1]);
	}, h = (e) => {
		let t = {
			min: e[0] === i ? null : e[0],
			max: e[1] === a ? null : e[1]
		};
		t.min !== null || t.max !== null ? n(t) : n(null);
	}, g = () => {
		let e = typeof c == "number" ? c : null, t = typeof u == "number" ? u : null;
		n(e === null && t === null ? null : {
			min: e,
			max: t
		});
	}, _ = () => {
		l(""), d(""), p([i, a]), n(null);
	}, v = c !== "" || u !== "";
	return s ? /* @__PURE__ */ U(z, {
		gap: "xs",
		"data-testid": `attr-filter-${e.slug}`,
		children: [
			/* @__PURE__ */ H(B, {
				fw: 500,
				size: "sm",
				children: e.name
			}),
			/* @__PURE__ */ H(et, {
				value: f,
				onChange: m,
				onChangeEnd: h,
				min: i,
				max: a,
				step: o,
				minRange: o,
				label: (e) => e.toLocaleString(),
				size: "sm",
				"data-testid": `attr-slider-${e.slug}`,
				"aria-label": r.rangeSlider(e.name)
			}),
			/* @__PURE__ */ U(I, {
				gap: "xs",
				align: "center",
				children: [
					/* @__PURE__ */ H(Ye, {
						placeholder: "Min",
						value: c,
						onChange: (e) => l(e),
						min: i,
						max: a,
						size: "xs",
						w: 80,
						hideControls: !0,
						"data-testid": `attr-min-${e.slug}`,
						"aria-label": r.minValue
					}),
					/* @__PURE__ */ H(B, {
						size: "sm",
						c: "dimmed",
						children: "-"
					}),
					/* @__PURE__ */ H(Ye, {
						placeholder: "Max",
						value: u,
						onChange: (e) => d(e),
						min: i,
						max: a,
						size: "xs",
						w: 80,
						hideControls: !0,
						"data-testid": `attr-max-${e.slug}`,
						"aria-label": r.maxValue
					})
				]
			}),
			/* @__PURE__ */ U(B, {
				size: "xs",
				c: "dimmed",
				children: [
					r.rangeHint,
					": ",
					i.toLocaleString(),
					" - ",
					a.toLocaleString()
				]
			}),
			/* @__PURE__ */ U(I, {
				gap: "xs",
				children: [/* @__PURE__ */ H(N, {
					size: "xs",
					variant: "light",
					onClick: g,
					"data-testid": `attr-apply-${e.slug}`,
					children: r.apply
				}), v && /* @__PURE__ */ H(N, {
					size: "xs",
					variant: "subtle",
					onClick: _,
					"data-testid": `attr-clear-${e.slug}`,
					children: r.clear
				})]
			})
		]
	}) : null;
}
//#endregion
//#region src/components/catalog/AttributeFilter/BooleanAttributeFilter.tsx
function Hu({ attribute: e, checked: t, onChange: n, labels: r }) {
	let i = e.buckets.find((e) => e.key === "true" || e.key === "1"), a = e.buckets.find((e) => e.key === "false" || e.key === "0"), o = i?.count ?? 0, s = a?.count ?? 0, c = (e) => {
		n(e ? !0 : null);
	};
	return o === 0 ? null : /* @__PURE__ */ U(z, {
		gap: "xs",
		"data-testid": `attr-filter-${e.slug}`,
		children: [/* @__PURE__ */ U(I, {
			justify: "space-between",
			wrap: "nowrap",
			children: [/* @__PURE__ */ U(I, {
				gap: "xs",
				wrap: "nowrap",
				children: [/* @__PURE__ */ H(B, {
					size: "sm",
					fw: 500,
					children: e.name
				}), /* @__PURE__ */ U(B, {
					size: "xs",
					c: "dimmed",
					"aria-label": r.productCount(o),
					children: [
						"(",
						o,
						")"
					]
				})]
			}), /* @__PURE__ */ H(at, {
				checked: t === !0,
				onChange: (e) => c(e.currentTarget.checked),
				size: "sm",
				"data-testid": `attr-switch-${e.slug}`,
				"aria-label": e.name
			})]
		}), s > 0 && t === null && /* @__PURE__ */ H(B, {
			size: "xs",
			c: "dimmed",
			children: r.booleanHint(s)
		})]
	});
}
//#endregion
//#region src/components/catalog/types.ts
var Uu = {
	categories: "Categories",
	brand: "Brand",
	searchBrand: "Search brand...",
	noBrandsFound: "No brands found",
	inStockOnly: "In stock only",
	priceRange: "Price range",
	priceHint: "Range",
	technicalSpecs: "Specifications",
	searchAttribute: "Search...",
	noValuesFound: "No values found",
	showLess: "Show less",
	rangeHint: "Range",
	minValue: "Min value",
	maxValue: "Max value",
	apply: "Apply",
	clear: "Clear",
	productCount: (e) => `${e} products`,
	showMore: (e) => `Show more (${e})`,
	searchAttributeValues: (e) => `Search ${e} values`,
	rangeSlider: (e) => `${e} range`,
	booleanHint: (e) => `${e} without this feature`,
	excludeHeader: (e) => `Exclude ${e}`,
	emptyToggle: () => "None"
};
//#endregion
//#region src/components/catalog/AttributeFilter/AttributeFilterSection.tsx
function Wu({ attribute: e, includeValue: t = null, excludeValues: n = [], emptyChecked: r = !1, mode: i = "include", showEmptyToggle: a = !1, onFilterChange: o, labels: s }) {
	let c = s.excludeHeader ?? Uu.excludeHeader, l = s.emptyToggle ?? Uu.emptyToggle;
	return /* @__PURE__ */ U(Gn, { children: [i === "exclude" ? /* @__PURE__ */ H(Bu, {
		attribute: {
			...e,
			name: c(e.name)
		},
		selectedValues: n,
		onChange: (t) => o(`xattr_${e.slug}`, t.length > 0 ? t : null),
		labels: s
	}) : /* @__PURE__ */ H(Gu, {
		attribute: e,
		value: t,
		onChange: (t) => o(`attr_${e.slug}`, t),
		labels: s
	}), a && /* @__PURE__ */ H(at, {
		mt: "xs",
		size: "sm",
		label: l(e.name),
		checked: r,
		onChange: (t) => o(`noattr_${e.slug}`, t.currentTarget.checked),
		"data-testid": `empty-toggle-${e.slug}`
	})] });
}
//#endregion
//#region src/components/catalog/AttributeFilter/index.tsx
function Gu({ attribute: e, value: t, onChange: n, labels: r }) {
	switch (e.dataType) {
		case "string":
		case "enum": return /* @__PURE__ */ H(Bu, {
			attribute: e,
			selectedValues: Array.isArray(t) ? t : [],
			onChange: (e) => n(e.length > 0 ? e : null),
			labels: r
		});
		case "number": return /* @__PURE__ */ H(Vu, {
			attribute: e,
			range: t && typeof t == "object" && !Array.isArray(t) ? t : null,
			onChange: n,
			labels: r
		});
		case "boolean": return /* @__PURE__ */ H(Hu, {
			attribute: e,
			checked: typeof t == "boolean" ? t : null,
			onChange: n,
			labels: r
		});
		default: return null;
	}
}
//#endregion
//#region src/components/catalog/IcecatFeatureFilters/index.tsx
function Ku(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		let e = n.groupName || "Otros", r = t.get(e) || [];
		r.push(n), t.set(e, r);
	}
	return t;
}
function qu(e) {
	return {
		slug: e.code,
		name: e.unit ? `${e.name} (${e.unit})` : e.name,
		dataType: e.dataType === "boolean" ? "boolean" : e.dataType === "number" ? "number" : "string",
		buckets: e.buckets
	};
}
function Ju(e) {
	return e == null ? null : Array.isArray(e) ? e.length > 0 ? { values: e } : null : typeof e == "object" && ("min" in e || "max" in e) ? { range: e } : typeof e == "boolean" ? { values: [e ? "Y" : "N"] } : null;
}
function Yu({ features: e, values: t, onChange: n, maxFeaturesPerGroup: r = 5, labels: i }) {
	let a = q(() => Ku(e), [e]), o = (e) => {
		let n = t[e.code];
		return n ? n.values ? e.dataType === "boolean" ? n.values.includes("Y") || n.values.includes("true") : n.values : n.range ? {
			min: n.range.min ?? null,
			max: n.range.max ?? null
		} : null : null;
	};
	return e.length === 0 ? null : a.size === 1 || e.length <= r ? /* @__PURE__ */ U(z, {
		gap: "md",
		"data-testid": "icecat-feature-filters",
		children: [/* @__PURE__ */ H(B, {
			fw: 600,
			size: "sm",
			children: i.technicalSpecs
		}), e.map((e) => /* @__PURE__ */ H(Gu, {
			attribute: qu(e),
			value: o(e),
			onChange: (t) => n(e.code, t),
			labels: i
		}, e.code))]
	}) : /* @__PURE__ */ U(z, {
		gap: "xs",
		"data-testid": "icecat-feature-filters",
		children: [/* @__PURE__ */ H(B, {
			fw: 600,
			size: "sm",
			children: i.technicalSpecs
		}), /* @__PURE__ */ H(Oe, {
			variant: "separated",
			multiple: !0,
			defaultValue: [...a.keys()].slice(0, 2),
			children: [...a.entries()].map(([e, t]) => /* @__PURE__ */ U(Oe.Item, {
				value: e,
				children: [/* @__PURE__ */ H(Oe.Control, { children: /* @__PURE__ */ U(B, {
					size: "sm",
					fw: 500,
					children: [
						e,
						" (",
						t.length,
						")"
					]
				}) }), /* @__PURE__ */ H(Oe.Panel, { children: /* @__PURE__ */ H(z, {
					gap: "md",
					children: t.map((e) => /* @__PURE__ */ H("div", { children: /* @__PURE__ */ H(Gu, {
						attribute: qu(e),
						value: o(e),
						onChange: (t) => n(e.code, t),
						labels: i
					}) }, e.code))
				}) })]
			}, e))
		})]
	});
}
//#endregion
//#region src/components/catalog/FiltersSidebar.tsx
function Xu({ filters: e, onFilterChange: t, onCategorySelect: n, facets: r, categoryTree: i, excludeAttributeSlugs: a, emptyToggleSlugs: o, labels: s }) {
	return /* @__PURE__ */ H(Ze, {
		withBorder: !0,
		p: "md",
		"data-testid": "filters-sidebar",
		children: /* @__PURE__ */ U(z, {
			gap: "md",
			children: [
				/* @__PURE__ */ H(Lu, {
					categories: r?.categories ?? [],
					tree: i,
					selected: e.category,
					onSelect: n,
					label: s.categories
				}),
				/* @__PURE__ */ H(Be, {}),
				/* @__PURE__ */ H(Ru, {
					checked: e.inStock ?? !1,
					onChange: (e) => t("inStock", e),
					label: s.inStockOnly
				}),
				r && r.brands.length > 0 && /* @__PURE__ */ U(Gn, { children: [/* @__PURE__ */ H(Be, {}), /* @__PURE__ */ H(Pu, {
					brands: r.brands,
					selectedBrands: e.brands ?? [],
					onChange: (e) => t("brands", e),
					labels: s
				})] }),
				/* @__PURE__ */ H(Be, {}),
				/* @__PURE__ */ U(z, {
					gap: "xs",
					children: [/* @__PURE__ */ H(zu, {
						minPrice: e.minPrice,
						maxPrice: e.maxPrice,
						onChange: (e, n) => {
							t("minPrice", e === null ? "" : String(e)), t("maxPrice", n === null ? "" : String(n));
						},
						labels: s
					}), r?.priceRange && /* @__PURE__ */ U(B, {
						size: "xs",
						c: "dimmed",
						children: [
							s.priceHint,
							": $",
							r.priceRange.min.toFixed(2),
							" - $",
							r.priceRange.max.toFixed(2)
						]
					})]
				}),
				r?.attributes && r.attributes.length > 0 && /* @__PURE__ */ H(Gn, { children: r.attributes.map((n) => /* @__PURE__ */ U("div", { children: [/* @__PURE__ */ H(Be, { my: "md" }), /* @__PURE__ */ H(Wu, {
					attribute: n,
					includeValue: e.attributes?.[n.slug] ?? null,
					excludeValues: e.excludeAttributes?.[n.slug] ?? [],
					emptyChecked: e.emptyAttributes?.includes(n.slug) ?? !1,
					mode: (a ?? []).includes(n.slug) ? "exclude" : "include",
					showEmptyToggle: (o ?? []).includes(n.slug),
					onFilterChange: t,
					labels: s
				})] }, n.slug)) }),
				r?.icecatFeatures && r.icecatFeatures.length > 0 && /* @__PURE__ */ U(Gn, { children: [/* @__PURE__ */ H(Be, { my: "md" }), /* @__PURE__ */ H(Yu, {
					features: r.icecatFeatures,
					values: e.icecatFeatures ?? {},
					onChange: (e, n) => t(`ice_${e}`, n),
					labels: s
				})] })
			]
		})
	});
}
//#endregion
//#region src/components/catalog/DietaryBadges.tsx
var Zu = {
	green: "green",
	neutral: "gray",
	red: "red",
	orange: "orange",
	blue: "blue"
};
function Qu(e) {
	return Zu[e] ?? "gray";
}
function $u({ badges: e, max: t = 6 }) {
	return !e || e.length === 0 ? null : /* @__PURE__ */ H(I, {
		gap: 4,
		wrap: "wrap",
		"data-testid": "dietary-badges",
		children: e.slice(0, t).map((e) => /* @__PURE__ */ H(j, {
			color: Qu(e.badgeStyle),
			variant: "light",
			size: "sm",
			radius: "sm",
			"data-testid": `dietary-badge-${e.slug}`,
			children: e.label
		}, e.slug))
	});
}
//#endregion
//#region src/types/conversations.ts
var ed = {
	all: ["conversations"],
	lists: () => [...ed.all, "list"],
	list: (e) => [...ed.lists(), e ?? {}],
	details: () => [...ed.all, "detail"],
	detail: (e) => [...ed.details(), e],
	messages: (e) => [
		...ed.all,
		"messages",
		e
	],
	unreadTotal: () => [...ed.all, "unreadTotal"],
	unreadCounts: () => [...ed.all, "unreadCounts"]
}, td = [
	"pending",
	"partially_paid",
	"paid",
	"overpaid",
	"expired",
	"expired_partial",
	"failed",
	"refunded"
], nd = [
	"awaiting_payment",
	"confirmed",
	"preparing",
	"ready",
	"shipped",
	"delivered",
	"cancelled"
];
//#endregion
//#region src/hooks/usePagination.ts
function rd(e) {
	let { total: t, initialPage: n = 1, initialLimit: r = 10 } = e, [i, a] = Y(n), [o, s] = Y(r), c = q(() => Math.max(1, Math.ceil(t / o)), [t, o]), l = q(() => (i - 1) * o, [i, o]), u = q(() => i < c, [i, c]), d = q(() => i > 1, [i]);
	return {
		page: i,
		limit: o,
		total: t,
		totalPages: c,
		offset: l,
		hasNext: u,
		hasPrev: d,
		setPage: G((e) => {
			a(Math.max(1, Math.min(e, c)));
		}, [c]),
		setLimit: G((e) => {
			s(e), a(1);
		}, []),
		nextPage: G(() => {
			u && a((e) => e + 1);
		}, [u]),
		prevPage: G(() => {
			d && a((e) => e - 1);
		}, [d]),
		reset: G(() => {
			a(n), s(r);
		}, [n, r])
	};
}
//#endregion
//#region src/hooks/useConfirmation.ts
function id() {
	let [e, t] = Y(!1), [n, r] = Y(!1), [i, a] = Y(null), o = G((e) => {
		a(e), t(!0), r(!1);
	}, []), s = G(() => {
		n || (t(!1), a(null));
	}, [n]);
	return {
		isOpen: e,
		isLoading: n,
		confirm: o,
		cancel: s,
		modalProps: {
			opened: e,
			onClose: s,
			onConfirm: G(async () => {
				if (i?.onConfirm) try {
					r(!0), await i.onConfirm(), t(!1), a(null);
				} finally {
					r(!1);
				}
			}, [i]),
			title: i?.title ?? "",
			message: i?.message ?? "",
			danger: i?.danger ?? !1,
			confirmLabel: i?.confirmLabel ?? (i?.danger ? "Eliminar" : "Confirmar"),
			cancelLabel: i?.cancelLabel ?? "Cancelar",
			loading: n
		}
	};
}
//#endregion
//#region src/utils/currencyConverter.ts
var ad = [
	"ARS",
	"USD",
	"EUR",
	"BRL"
], od = [
	"BTC",
	"ETH",
	"USDT",
	"TRX"
], sd = [
	"USDT",
	"USDC",
	"DAI",
	"BUSD"
], cd = [...ad, ...od];
function ld(e) {
	return sd.includes(e);
}
function ud(e) {
	return ld(e) ? "USD" : e.toUpperCase();
}
function dd(e, t, n) {
	let r = `${e}_${t}`;
	if (n[r] !== void 0) return n[r];
	let i = `${t}_${e}`;
	return n[i] !== void 0 && n[i] !== 0 ? 1 / n[i] : null;
}
function fd(e, t) {
	let n = ud(e), r = ud(t);
	return n === r ? [] : n === "USD" ? [`USD_${r}`] : r === "USD" ? [`${n}_USD`] : [`${n}_USD`, `USD_${r}`];
}
function pd(e, t, n, r) {
	if (typeof e != "number" || isNaN(e)) return null;
	let i = ud(t), a = ud(n);
	if (i === a) return e;
	if (i === "USD") {
		let t = dd("USD", a, r);
		return t === null ? null : e * t;
	}
	if (a === "USD") {
		let t = dd(i, "USD", r);
		return t === null ? null : e * t;
	}
	let o = dd(i, "USD", r), s = dd("USD", a, r);
	return o === null || s === null ? null : e * o * s;
}
function md(e, t, n, r) {
	return `${ee(n, r)} (${ee(e, t)})`;
}
function hd(e, t, n, r) {
	let i = pd(e, t, n, r);
	return i === null ? null : md(e, t, i, n);
}
//#endregion
//#region src/hooks/useCurrencyConversion.ts
var gd = 300 * 1e3, _d = 600 * 1e3, vd = "USD";
async function yd(e, t) {
	if (e.length === 0) return {
		rates: {},
		timestamp: (/* @__PURE__ */ new Date()).toISOString()
	};
	let n = `${t}/api/v2/exchange-rates?pairs=${e.join(",")}`, r = await fetch(n, {
		method: "GET",
		headers: { "Content-Type": "application/json" }
	});
	if (!r.ok) throw Error(`Failed to fetch exchange rates: ${r.status} ${r.statusText}`);
	let i = await r.json();
	if (!i.success) throw Error("API returned unsuccessful response");
	return i.data;
}
function bd(e) {
	let { sourceCurrency: t, targetCurrency: n, apiBaseUrl: r, enabled: i = !0 } = e, a = n || vd, o = r ?? (typeof window < "u" ? window.location.origin : ""), s = q(() => fd(t, a), [t, a]), { data: c, isLoading: l, error: u, refetch: d } = Fr({
		queryKey: q(() => ["exchangeRates", s.join(",")], [s]),
		queryFn: () => yd(s, o),
		staleTime: gd,
		gcTime: _d,
		enabled: i && s.length > 0
	}), f = G((e) => t === a ? e : c?.rates ? pd(e, t, a, c.rates) : null, [
		c?.rates,
		t,
		a
	]), p = q(() => t === a ? 1 : c?.rates ? pd(1, t, a, c.rates) : null, [
		c?.rates,
		t,
		a
	]), m = G(async () => {
		await d();
	}, [d]);
	return {
		convert: f,
		rates: c?.rates || {},
		isLoading: l,
		error: u,
		userCurrency: a,
		refreshRates: m,
		exchangeRate: p,
		ratesTimestamp: c?.timestamp || null
	};
}
//#endregion
//#region src/hooks/usePreferencesSync.ts
function xd(e) {
	let { userGuid: t, onLanguageChange: n, onCurrencyChange: r, onThemeChange: i, enabled: a = !0 } = e, o = J(null), s = J(!1), c = J(n), l = J(r), u = J(i);
	K(() => {
		c.current = n;
	}, [n]), K(() => {
		l.current = r;
	}, [r]), K(() => {
		u.current = i;
	}, [i]);
	let { isConnected: d, subscribe: f, unsubscribe: p } = zr(), m = G((e) => {
		if (e.correlationId && e.correlationId === o.current) {
			console.log("[usePreferencesSync] Skipping self-originated event:", e.correlationId);
			return;
		}
		console.log("[usePreferencesSync] Processing preferences update:", e), e.language_code && c.current && (console.log("[usePreferencesSync] Language changed to:", e.language_code), c.current(e.language_code)), e.preferred_currency && l.current && (console.log("[usePreferencesSync] Currency changed to:", e.preferred_currency), l.current(e.preferred_currency)), e.ui_preferences?.theme && u.current && (console.log("[usePreferencesSync] Theme changed to:", e.ui_preferences.theme), u.current(e.ui_preferences.theme));
	}, []);
	Rr(Ir.PREFERENCES_UPDATED, m, [m]), K(() => {
		if (!a || !t || !d) {
			console.log("[usePreferencesSync] Skipping subscription:", {
				enabled: a,
				userGuid: t,
				isConnected: d
			}), s.current = !1;
			return;
		}
		let e = Lr.userPreferences(t);
		return console.log("[usePreferencesSync] Subscribing to topic:", e), f([e]), s.current = !0, () => {
			console.log("[usePreferencesSync] Unsubscribing from topic:", e), p([e]), s.current = !1;
		};
	}, [
		a,
		t,
		d,
		f,
		p
	]);
	let h = G((e) => {
		o.current = e, setTimeout(() => {
			o.current === e && (o.current = null);
		}, 5e3);
	}, []);
	return {
		isSubscribed: s.current,
		setLastCorrelationId: h
	};
}
//#endregion
//#region src/hooks/useProfileRealtimeSync.ts
function Sd(e) {
	let { userGuid: t, onProfileChanged: n, enabled: r = !0 } = e, i = J(!1), a = J(n);
	K(() => {
		a.current = n;
	}, [n]);
	let { isConnected: o, subscribe: s, unsubscribe: c } = zr(), l = G((e) => {
		console.log("[useProfileRealtimeSync] Profile update received:", e.fields), a.current?.();
	}, []);
	return Rr(Ir.PROFILE_UPDATED, l, [l]), K(() => {
		if (!r || !t || !o) {
			i.current = !1;
			return;
		}
		let e = Lr.userProfile(t);
		return console.log("[useProfileRealtimeSync] Subscribing to topic:", e), s([e]), i.current = !0, () => {
			console.log("[useProfileRealtimeSync] Unsubscribing from topic:", e), c([e]), i.current = !1;
		};
	}, [
		r,
		t,
		o,
		s,
		c
	]), { isSubscribed: i.current };
}
//#endregion
//#region src/hooks/useVersionNotification.ts
function Cd(e) {
	let { currentBuildId: t, app: n, onUpdateAvailable: r, enabled: i = !0 } = e, a = J(r);
	K(() => {
		a.current = r;
	}, [r]);
	let o = J(null), s = J(!1), { isConnected: c, subscribe: l, unsubscribe: u } = zr(), d = G((e) => {
		i && e.app === n && e.buildId && t && e.buildId !== t && e.buildId !== o.current && (o.current = e.buildId, a.current(e));
	}, [
		i,
		n,
		t
	]);
	return Rr(Ir.FRONTEND_VERSION_UPDATED, d, [d]), K(() => {
		if (!i || !c) {
			s.current = !1;
			return;
		}
		let e = Lr.systemBroadcast();
		return l([e]), s.current = !0, () => {
			u([e]), s.current = !1;
		};
	}, [
		i,
		c,
		l,
		u
	]), { isSubscribed: s.current };
}
//#endregion
//#region src/providers/UserPreferencesProvider.tsx
var wd = "tt-theme-cache", Td = 800, Ed = Qn({
	theme: "light",
	compactMode: !1,
	showTooltips: !0,
	highContrast: !1,
	largeText: !1,
	screenReader: !1,
	reducedMotion: !1
});
function Dd() {
	return nr(Ed);
}
function Od(e) {
	if (typeof document > "u") return;
	let t = document.documentElement;
	t.setAttribute("data-compact", String(e.compactMode)), t.setAttribute("data-show-tooltips", String(e.showTooltips)), t.setAttribute("data-high-contrast", String(e.highContrast)), t.setAttribute("data-large-text", String(e.largeText)), t.setAttribute("data-reduced-motion", String(e.reducedMotion)), t.setAttribute("data-screen-reader", String(e.screenReader));
}
function kd() {
	if (typeof document > "u") return;
	let e = document.documentElement;
	e.removeAttribute("data-compact"), e.removeAttribute("data-show-tooltips"), e.removeAttribute("data-high-contrast"), e.removeAttribute("data-large-text"), e.removeAttribute("data-reduced-motion"), e.removeAttribute("data-screen-reader");
}
function Ad(e) {
	let t = e?.ui_preferences ?? void 0, n = e?.accessibility_preferences ?? void 0;
	return {
		theme: t?.theme ?? "light",
		compactMode: t?.compactMode ?? !1,
		showTooltips: t?.showTooltips ?? !0,
		highContrast: n?.highContrast ?? !1,
		largeText: n?.largeText ?? !1,
		screenReader: n?.screenReader ?? !1,
		reducedMotion: n?.reducedMotion ?? !1
	};
}
function jd({ profile: e, isAuthenticated: t, onSaveTheme: n, themeCacheKey: r = wd, applyA11yAttributes: i = !0, children: a }) {
	let { setColorScheme: o, colorScheme: s } = gt(), c = ht("light"), l = J(!1), u = J(null), d = J(t), f = Ad(e);
	K(() => {
		i && (t && e ? Od(f) : kd());
	}, [
		i,
		t,
		e,
		f.compactMode,
		f.showTooltips,
		f.highContrast,
		f.largeText,
		f.screenReader,
		f.reducedMotion
	]), K(() => {
		if (!t || !e) return;
		let n = e.ui_preferences?.theme ?? "light";
		if (u.current !== n) {
			if (u.current = n, l.current = !0, o(n), typeof window < "u") {
				let e = n === "auto" ? c : n;
				window.localStorage.setItem(r, e), window.localStorage.setItem("mantine-color-scheme-value", e);
			}
			requestAnimationFrame(() => {
				l.current = !1;
			});
		}
	}, [
		t,
		e,
		e?.ui_preferences?.theme,
		o,
		c,
		r
	]), K(() => {
		d.current === !0 && t === !1 && (typeof window < "u" && (window.localStorage.removeItem(r), window.localStorage.removeItem("mantine-color-scheme-value")), l.current = !0, o("auto"), u.current = null, requestAnimationFrame(() => {
			l.current = !1;
		})), d.current = t;
	}, [
		t,
		r,
		o
	]);
	let p = sr(async (r) => {
		if (!(!t || !e)) try {
			await n(r);
		} catch (e) {
			console.error("[UserPreferences] Failed to save theme:", e);
		}
	}, Td);
	K(() => {
		!t || !e || l.current || s !== (e.ui_preferences?.theme ?? "light") && (s === "light" || s === "dark") && (typeof window < "u" && window.localStorage.setItem(r, s), p(s));
	}, [
		s,
		t,
		e,
		e?.ui_preferences?.theme,
		p,
		r
	]);
	let m = G(() => {
		typeof window > "u" || e?.ui_preferences?.theme === "auto" && window.localStorage.setItem(r, c);
	}, [
		e?.ui_preferences?.theme,
		c,
		r
	]);
	return K(() => {
		m();
	}, [m]), K(() => () => {
		i && kd();
	}, [i]), /* @__PURE__ */ H(Ed.Provider, {
		value: f,
		children: a
	});
}
//#endregion
export { Su as ASSIGNEE_CHIP_TOKENS, pe as ATTR_PREFIX, pi as AddressContextBadge, ti as AddressStatusBadge, Du as AssigneeChip, ds as AttachmentCard, ss as AttachmentPreview, Gu as AttributeFilter, Wu as AttributeFilterSection, yi as BalanceLevelBadge, ku as BlockedComposerPanel, Hu as BooleanAttributeFilter, Pu as BrandFilter, ca as Breadcrumbs, La as CHART_COLORS, Ra as CHART_COLOR_SEQUENCE, Z as CHART_DEFAULTS, Ri as CardSkeleton, li as CategoryBadge, Lu as CategoryFilter, Wi as ChartSkeleton, rs as ChatAttachmentProvider, lo as ConfirmModal, _i as ConfirmationLevelBadge, gs as ContextCard, bu as ConversationListHeader, Si as CounterBadge, ro as CurrencyInput, go as CurrencySwitcher, Ai as CustomRoleBadge, oo as DATE_RANGE_PRESETS, ho as DEFAULT_CURRENCIES, Ee as DEFAULT_FONT_STACKS, fo as DEFAULT_LANGUAGES, ja as DataTable, Ea as DataTableHeader, Oa as DataTablePagination, co as DateRangePicker, zs as DateSeparator, $u as DietaryBadges, Nl as DropZoneOverlay, Uo as EmptyCartState, Qi as EmptyState, Ti as EndpointCounterBadge, ta as ErrorBoundary, ea as ErrorState, n as FULFILLMENT_STATUS_CONFIG, nd as FULFILLMENT_STATUS_VALUES, Xo as FavoritesDrawerItem, na as FilterChips, Xu as FiltersSidebar, si as FulfillmentStatusBadge, qi as FullScreenLoader, wo as HeaderDivider, Co as HeaderLayout, To as HeaderNavButton, Eo as HeaderPreferences, Oo as HeaderUserSection, le as ICE_PREFIX, O as ICE_VALUE_SEPARATOR, ve as IMAGE_SIZE_PIXELS, Yu as IcecatFeatureFilters, uo as ImageLightbox, as as ImageThumbnail, Ru as InStockFilter, wi as ItemCounterBadge, Ia as KPICard, Ui as KPISkeleton, ge as LOCALE, po as LanguageSwitcher, hi as LevelBadge, Li as ListSkeleton, Gi as LoadingSkeleton, vs as MentionChip, ys as MentionChipView, Qo as MerchantCardLayout, $o as MerchantCardSkeleton, Vo as MerchantCartCard, Pi as MerchantGridSkeleton, ri as MerchantOrderStatusBadge, ni as MerchantStatusBadge, ui as MerchantTypeBadge, Is as MessageBubble, cu as MessageComposer, Us as MessageList, ts as MessageStatus, Ao as MessagesHeaderButton, Jo as MultiCartDrawer, oe as NOATTR_PREFIX, a as NOTIFICATIONS_CONFIG, m as NOTIFICATION_COLORS, ra as NOTIFICATION_ICON_SIZE, oa as NOTIFICATION_ICON_TYPES, Ci as NotificationCounterBadge, aa as NotificationIcons, Vu as NumberAttributeFilter, t as ORDER_PAYMENT_STATUS_CONFIG, oi as OrderPaymentStatusBadge, Zr as OrderStatusBadge, td as PAYMENT_STATUS_VALUES, za as PIE_CHART_COLORS, Ki as PageLoader, mi as PaymentModeBadge, Qr as PaymentStatusBadge, Nu as PinnedConversationRow, fa as PriceDisplay, zu as PriceFilter, Fo as ProductCard, Fi as ProductDetailSkeleton, Mi as ProductGridSkeleton, Qa as QuantityInput, Ll as QuickReplySuggestions, xi as RankingLevelBadge, vi as RatingLevelBadge, gi as ResourceLevelBadge, di as ResourceTypeBadge, Oi as RoleBadge, fi as RoleTypeBadge, sd as STABLECOINS, od as SUPPORTED_CRYPTO, cd as SUPPORTED_CURRENCIES, ad as SUPPORTED_FIAT, to as SearchInput, Bi as StatsSkeleton, Xr as StatusBadge, ya as StockBadge, ai as StockStatusBadge, Bu as StringAttributeFilter, ii as SyncStatusBadge, ki as SystemRoleBadge, Vi as TableSkeleton, Ga as TeleAreaChart, Ka as TeleBarChart, Za as TeleDonutChart, qa as TeleLineChart, Ya as TelePieChart, zi as TextSkeleton, mo as ThemeSwitcher, wa as Timeline, ei as TransactionStatusBadge, fu as TypingIndicator, bi as UsageLevelBadge, jd as UserPreferencesProvider, Ro as WishlistButton, $r as WithdrawalStatusBadge, ne as XATTR_PREFIX, Va as X_AXIS_DEFAULTS, Ba as Y_AXIS_DEFAULTS, Wa as assignPieColors, Ua as assignSeriesColors, Se as buildBrandTheme, ue as clearAllFiltersKeepCategory, fe as clearAttributeFilters, Ql as clearNoteDrafts, ed as conversationKeys, hd as convertAndFormat, pd as convertCurrency, we as darken, Uu as defaultFacetLabels, Il as firstLineOf, te as formatBusinessHours, md as formatConvertedPrice, ee as formatCurrency, x as formatCurrencyCompact, b as formatDate, os as formatFileSize, S as formatNumber, D as formatPercentage, v as formatRelativeTime, be as generateColorPalette, Ha as getChartColor, re as getImageSizeUrl, _e as getRecommendedSize, fd as getRequiredPairs, ga as getStockStatus, k as hexToRgb, Ce as hslToRgb, he as isCurrentlyOpen, C as isIcecatImage, y as isMerchantImage, ld as isStablecoin, Te as lighten, au as matchQuickReplies, ie as parseAttributeFilters, se as parseEmptyToggles, me as parseExcludeFilters, ae as parseIcecatFeatureFilters, Ju as parseIcecatFilterValue, ye as rgbToHex, xe as rgbToHsl, w as serializeAttributeFilters, Eu as shortAssigneeName, de as updateAttributeParam, ce as updateEmptyToggleParam, E as updateExcludeParam, T as updateIcecatFeatureParam, De as useBrandTheme, lu as useClearNoteDraftsOnSignOut, id as useConfirmation, bd as useCurrencyConversion, $a as useDebounce, eo as useDebouncedCallback, is as useFetchAttachment, vo as useHeaderLayout, rd as usePagination, xd as usePreferencesSync, Sd as useProfileRealtimeSync, Dd as useUserPreferences, Cd as useVersionNotification };

//# sourceMappingURL=index.es.js.map